import React, {
  useEffect,
  useState,
  useRef,
  useMemo,
  useCallback,
} from "react";
import "../../../../styles/dashboard.css";
import "../../../../../src/styles/userManagement.css";
import { Loading } from '@appkit4/react-components/loading';
import { Modal } from "@appkit4/react-components/modal";
import ModalFooter from "@appkit4/react-components/esm/modal/ModalFooter";
import { Button } from "@appkit4/react-components/button";
import { Draggable, Droppable } from "react-drag-and-drop";
import displayToastMessage from "../../../../components/Common/Alert/displayToastMessage";
import { AgGridReact } from "ag-grid-react"; // React Grid Logic
import "./chart.css";
import * as d3 from "d3";
import APIService from "../../../../services/apiAxiosService.js";
import useHttp from "../../../../hooks/useHttp.js";

export const truncateString = (str, max) => {
  return str?.length > max ? str.slice(0, max) + "..." : str;
};

function Dashboard() {
  const [availableGraphsInMenu, setAvailableGraphsInMenu] = useState([]);
  const [availableOptionalGraphs, setAvailableOptionalGraphs] = useState([]);
  const [issueTrendModal, setIssueTrendModal] = useState(false);
  const [issueRatingModal, setIssueRatingModal] = useState(false);
  const [vendorResponseModal, setVendorResponseModal] = useState(false);
  const [IssueManagementFollowUpModal, setIssueManagementFollowUpModal] =
    useState(false);
  const [VendorHighRiskModal, setVendorHighRiskModal] = useState(false);
  const [VendorMediumRiskModal, setVendorMediumRiskModal] = useState(false);
  const [VendorLowRiskModal, setVendorLowRiskModal] = useState(false);

  const [upcomingAssessmentModal, setUpcomingAssessmentModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [cardsData, setCardsData] = useState({});
  const [vendorResponseChartData, setVendorResponseChartData] = useState([]);
  const [getIssuesByRatings, setGetIssuesByRatings] = useState([]);
  const [upComingChatData, setUpComingChatData] = useState([]);
  const [ClosueStatusTrendsData, setClosueStatusTrendsData] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("All");
  const [loader, setLoader] = useState(true);
  const [filterUpcomingAssessment, setFilterUpcomingAssessment] = useState([]);
  const [filterIssueRating, setFilterIssueRating] = useState([]);
  const [bannerLoader, setBannerLoader] = useState(true);
  const [vendorResponseDrilldownData, setVendorResponseDrilldownData] =
    useState([]);
  const [vendorCategoryAssessmentSent, setVendorCategoryAssessmentSent] =
    useState([]);
  const [
    IssueMangementFollowUpByCategory,
    setIssueMangementFollowUpByCategory,
  ] = useState([]);
  const [IssueMangementClose, SetIssueMangementClose] = useState([]);
  const [
    vendorCategoryAssessmentCompleted,
    setVendorCategoryAssessmentCompleted,
  ] = useState([]);
  const [
    issueManagementFollwUpResponse,
    setIssueMangementFollowUpResponseData,
  ] = useState([]);
  const [categoryWiseCriticalityData, setCategoryWiseCriticalityData] =
    useState([]);
    const [categoryWiseOverDueDateResponse, setCategoryWiseOverDueDateResponse] =useState([]);
  const [VendorHighRiskCategory, setVendorHighRiskCategory] = useState([]);
  const [VendorMediumRiskCategory, setVendorMediumRiskCategory] = useState([]);
  const [VendorLowRiskCategory, setVendorLowRiskCategory] = useState([]);
  const [
    vendorHighRiskModalDrillDownData,
    setvendorHighRiskModalDrillDownData,
  ] = useState([]);
  const [closeStatusTrendsDownData, setcloseStatusTrendsDownData] = useState(
    []
  );
  const [
    vendorCategoryAssessmentSentDrilldown,
    setVendorCategoryAssessmentSentDrilldown,
  ] = useState([]);
  const [
    vendorCategoryAssessmentCompletedDrilldown,
    setVendorCategoryAssessmentCompletedDrilldown,
  ] = useState([]);
  const [vendorAssessmentSentModal, setVendorAssessmentSentModal] =
    useState(false);
  const [vendorAssessmentCompletedModal, setVendorAssessmentCompletedModal] =
    useState(false);
  const [assessmentSummary, setAssessmentSummary] = useState([]);
  const [assessmentSummaryByCategory, setAssessmentSummaryByCategory] =
    useState([]);
  const issueByRatingRef = useRef(null);
  const upcomingAssessmentRef = useRef(null);
  const vendorAssessmentSentRef = useRef(null);
  const vendorAssessmentCompletedRef = useRef(null);
  const vendorAssessmentResponseRef = useRef(null);
  const completedPendingResponseRef = useRef(null);
  const IssueManagementFollowUpRef = useRef(null);
  const VendorCategoryOfHighRiskRef = useRef(null);
  const VendorCategoryOfMediumRiskRef = useRef(null);
  const VendorCategoryOfLowRiskRef = useRef(null);
  const VendorsClosureStatusRef = useRef(null);
  const ClosureIssueTrendsRef = useRef(null);
  const CategoryWiseCriticalityRef = useRef(null);
  const d3Container = useRef(null);
  const assessmentSummaryDashboard = useRef(null);
  const criticalityPerCategoryRef = useRef(null);
  const assessmentSummaryByCategoryRef = useRef(null);
  const assessmentSummaryCriticalityRef = useRef(null);
  const [categoryWiseCriticality, setCategoryWiseCriticality] = useState(false);
  const [assessmentSummaryModal, setAssessmentSummaryModal] = useState(false);
  const [assessmentSummaryByCategoryModal, setAssessmentSummaryByCategoryModal] = useState(false);
  const [assessmentCriticalityModal, setAssessmentCriticalityModal] = useState(false);
  const AgingAnalysisCategoryRef=useRef(null);
  const AgingAnalysisCriticalityRef=useRef(null);
  const riskOverviewAssesmentOutcome = useRef(null);
  const [categoryWiseOverDueDateDetails, setCategoryWiseCriticalityOverDueDateDetails] = useState(false);

  const [getIssuesCloseOpenData, setGetIssuesCloseOpen] = useState([]);
  const [getIssuesCloseOpenModalData, setGetIssuesCloseOpenModalData] =
    useState(false);
  const [
    getIssuesCloseOpenModalApiDataDetails,
    setGetIssuesCloseOpenModalApiDataDetails,
  ] = useState(false);
  const [completedPendingAssessment, setCompletedPendingAssessment] = useState(
    []
  );
  const [completedAssessmentData, setCompletedAssessmentData] = useState([]);
  const [pendingAssessmentData, setPendingAssessmentData] = useState([]);
  const [completedAssessmentModal, setCompletedAssessmentModal] =
    useState(false);
  const [pendingAssessmentModal, setPendingAssessmentModal] = useState(false);
  const [assessmentSummaryDrilldown, setAssessmentSummaryDrilldown] = useState(
    []
  );
  const [assessmentSummaryCriticalityDrilldown, setAssessmentSummaryCriticalityDrilldown] = useState([]);
  const [assessmentSummaryByCategoryDrilldown, setAssessmentSummaryByCategoryDrilldown] = useState([]);
  const [categoryByCriticalityDrilldown, setCategoryByCriticalityDrilldown] = useState([]);
  const [categoryByCriticalityModal, setCategoryByCriticalityModal] = useState(false);
  const [criticalityPerCategory, setCriticalityPerCategory] = useState([]);
  const [assessmentSummaryCriticality, setAssessmentSummaryCriticality] = useState([]);

  const { sendRequest: getVendorResponseCountAPI } = useHttp();
  const { sendRequest: getVendorResponseDrilldownData } = useHttp();
  const { sendRequest: getIssueManagementFollowUpDrilldownData } = useHttp();
  const { sendRequest: getVendorHighRiskModalDrillDownData } = useHttp();
  const { sendRequest: getIssueClosureTrendDrillDown } = useHttp();
  const { sendRequest: getVendorByCategoryAssessmentSentDrilldown } = useHttp();
  const { sendRequest: getVendorByCategoryAssessmentCompletedDrilldown } =
    useHttp();
  const { sendRequest: getWidgetsDataAPI } = useHttp();
  const { sendRequest: getIssueAgingChartAPI } = useHttp();
  const { sendRequest: getIssuesbyRatingAPI } = useHttp();
  const { sendRequest: issueByRatingDrilldownAPI } = useHttp();
  const { sendRequest: upcomingAssessmentsDrilldownAPI } = useHttp();
  const { sendRequest: upcomingAssessmentsChartCountAPI } = useHttp();
  const { sendRequest: getOptionalWidgetsDataAPI } = useHttp();
  const { sendRequest: dragAndDropInsertAPI } = useHttp();
  const { sendRequest: getExistedGraphsData } = useHttp();
  const { sendRequest: getVendorCategoryAssessmentSent } = useHttp();
  const { sendRequest: getVendorCategoryAssessmentCompleted } = useHttp();
  const { sendRequest: getIssueManagementFollowUpData } = useHttp();
  const { sendRequest: getVendorHighRiskCategory } = useHttp();
  const { sendRequest: getVendorMediumRiskCategory } = useHttp();
  const { sendRequest: getVendorLowRiskCategory } = useHttp();
  const { sendRequest: getIssueManagementCloseStatus } = useHttp();
  const { sendRequest: getClosureStatusTrendsCountAPI } = useHttp();
  const { sendRequest: getCategoryWiseCriticalityData } = useHttp();
  const { sendRequest: getCriticalVendor } = useHttp();
  const { sendRequest: getIssuesOpenClose } = useHttp();
  const { sendRequest: getIssuesCloseOpenApiDataDetails } = useHttp();
  const { sendRequest: getCompletedPendingAssessment } = useHttp();
  const { sendRequest: getCompletedAssessmentData } = useHttp();
  const { sendRequest: getPendingAssessmentData } = useHttp();
  const { sendRequest: getAssessmentSummary } = useHttp();
  const { sendRequest: getAssessmentSummaryDrilldown } = useHttp();
  const { sendRequest: getAssessmentSummaryByCategory } = useHttp();
  const { sendRequest: getCategoryDueDate } = useHttp();
  const { sendRequest: getCategoryWiseCriticalityDueData } = useHttp();
  const { sendRequest: getCriticalityDueDate } = useHttp();
  const { sendRequest: getAssessmentSummaryByCategoryDrilldown } = useHttp();
  const { sendRequest: getCriticalityPerCategoryData } = useHttp();
  const { sendRequest: getAssessmentSummaryCriticalityData } = useHttp();
  const { sendRequest: getAssessmentbyRatingAPI } = useHttp();
  const { sendRequest: getAssessmentbyRatingDrillDownAPIData } = useHttp();
  const { sendRequest: getCategoryByAssessment } = useHttp();

  const riskOverviewCategoryRef = useRef(null);

  const [riskOverviewCategory, setRiskOverviewCategory] =
  useState([
   
  ]);
  
  const IssuesOpenCloseRef = useRef();

  const gridRef = useRef();
  const gridRefIssueRating = useRef();
  const gridRefUpcoming = useRef();
  const gridRefAssessmentSent = useRef();
  const gridRefAssessmentCompleted = useRef();
  const gridRefCompletedAssessment = useRef();
  const gridRefPendingAssessment = useRef();
  const vendor = useRef();
  const gridRefOpenIssue = useRef();
  const mediumRisk = useRef();
  const vendorHigh = useRef();
  const closeStatus = useRef();
  const gridRefAssessmentSummary = useRef();
  const gridRefAssessmentSummaryByCategory = useRef();
  const gridRefAssessmentCriticality = useRef();
  const gridRefCriticalityPerCategory = useRef();
  const [vendorCriticality, SetVendorCriticality] = useState([]);
  const [categoryWiseOverDueDate, SetCategoryWiseOverDueDate] = useState([]);
  const [criticalityWiseOverDueDate, SetCriticalityWiseOverDueDate] = useState([]);
  const [riskOverview, setRiskOverview] = useState([]);
  function formatDate(date) {
    let d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();
    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
    return [day, month, year].join("-");
  }

  

  const getVendorCategoryAssessmentSentDrilldown = async (category) => {
    await getVendorByCategoryAssessmentSentDrilldown(
      APIService.getVendorByCategoryAssessmentSentDrilldown(category),
      (res) => {
        setVendorCategoryAssessmentSentDrilldown(res.MSG);
      }
    );
  };

  const getAssessmentSummaryDrill = async (param) => {
    await getAssessmentSummaryDrilldown(
      APIService.getAssessmentSummaryDrilldown(param),
      (res) => {
        setAssessmentSummaryDrilldown(res.MSG);
        setLoading(false);
      }
    );
  };

  const getAssessmentSummaryCriticalityDrill = async (param) => {
    await getAssessmentSummaryDrilldown(
      APIService.getAssessmentSummaryDrilldown(param),
      (res) => {
        setAssessmentSummaryCriticalityDrilldown(res.MSG),
        setLoading(false);
      }
    )
  }

  const getAssessmentSummaryByCategoryDrilldownModal = async (param) => {
    await getAssessmentSummaryByCategoryDrilldown(
      APIService.getAssessmentSummaryByCategoryDrilldown(param), (res) => {
        setAssessmentSummaryByCategoryDrilldown(res.MSG);
        setLoading(false);
      }
    )
  }

  const getCriticalityPerCategoryDataModal = async (param) => {
    await getAssessmentSummaryByCategoryDrilldown(
      APIService.getAssessmentSummaryByCategoryDrilldown(param), (res) => {
        setCategoryByCriticalityDrilldown(res.MSG);
        setLoading(false);
      }
    )
  }

  const getCompletedAssessmentDataDrilldown = async () => {
    await getCompletedAssessmentData(
      APIService.getCompletedAssessmentDrilldown(),
      (res) => {
        setCompletedAssessmentData(res.MSG);
      }
    );
  };

  const getPendingAssessmentDataDrilldown = async () => {
    await getPendingAssessmentData(
      APIService.getPendingAssessmentDrilldown(),
      (res) => {
        setPendingAssessmentData(res.MSG);
      }
    );
  };

  const getVendorCategoryAssessmentCompletedDrilldown = async (category) => {
    await getVendorByCategoryAssessmentCompletedDrilldown(
      APIService.getVendorByCategoryAssessmentCompletedDrilldown(category),
      (res) => {
        setVendorCategoryAssessmentCompletedDrilldown(res.MSG);
      }
    );
  };

  const getOptionalWidgetData = async () => {
    await getOptionalWidgetsDataAPI(
      APIService.getOptionalWidgetsData(sessionStorage.getItem("userId")),
      (res) => {
        setAvailableGraphsInMenu(res.MSG);
      }
    );
  };

  const getOptionalExistedGraphData = async () => {
    getExistedGraphsData(
      APIService.getExistedGraphsData(sessionStorage.getItem("userId")),
      (res) => {
        setAvailableOptionalGraphs(res.MSG);
      }
    );
  };

  const VendorResponseDrilldownData = async (ID) => {
    await getVendorResponseDrilldownData(
      APIService.vendorResponseDrilldownAPI(ID),
      (res) => {
        if (res.CODE) {
          setVendorResponseDrilldownData(res.MSG);
        }
      }
    );
    setLoading(false);
  };

  const issueManagementFollwUpResponseData = async (ID, status) => {
    await getIssueManagementFollowUpDrilldownData(
      APIService.IssueManagementFollowUpDrilldownDataAPI(ID, status),
      (res) => {
        if (res.CODE) {
          setIssueMangementFollowUpResponseData(res.MSG);
        }
      }
    );
    setLoading(false);
  };

  const CategoryWiseCriticalityData = async (category) => {
    await getCategoryWiseCriticalityData(
      APIService.categoryWiseCriticalityDataAPI(category),
      (res) => {
        if (res.CODE) {
          setCategoryWiseCriticalityData(res.MSG);
        }
      }
    );
    setLoading(false);
  };

  const CategoryWiseCriticalityOverDueDate = async (category,type) => {
    await getCategoryWiseCriticalityDueData(
      APIService.categoryWiseCriticalityDueDataAPI(category,type),
      (res) => {
        if (res.CODE) {
          setCategoryWiseOverDueDateResponse(res.MSG);
        }
      }
    );
    setLoading(false);
  };

  const vendorHighRiskModalDrillDown = async (service, risk) => {
    await getVendorHighRiskModalDrillDownData(
      APIService.getVendorHighRiskModalDrillDownData(service, risk),
      (res) => {
        if (res.CODE) {
          setvendorHighRiskModalDrillDownData(res.MSG);
        }
      }
    );
    setLoading(false);
  };

  const IssueClosureTrendDrillDown = async (status, date) => {
    await getIssueClosureTrendDrillDown(
      APIService.getIssueClosureTrendDrillDownData(status, date),
      (res) => {
        if (res.CODE) {
          setcloseStatusTrendsDownData(res.MSG);
        }
      }
    );
    setLoading(false);
  };

  const getIssuesCloseOpenApiData = async (status) => {
    await getIssuesCloseOpenApiDataDetails(
      APIService.getIssuesCloseOpenAPIData(status),
      (res) => {
        if (res.CODE) {
          setGetIssuesCloseOpenModalApiDataDetails(res.MSG);
        }
      }
    );
    setLoading(false);
  };

  const getIssueByRatingDrilldownData = async (ID) => {
    await issueByRatingDrilldownAPI(
      APIService.issueByRatingDrilldown(ID),
      (res) => {
        setFilterIssueRating(res.MSG);
      }
    );
  };

  const getAssessmentbyRatingDrillDownAPI = async (rating,category) => {
    await getAssessmentbyRatingDrillDownAPIData(
      APIService.AssessmentbyRatingDrillDownAPI(rating,category),
      (res) => {
        setFilterIssueRating(res.MSG);
      }
    );
  };

  const getUpcomingAssessmentDrilldownData = async (month) => {
    await upcomingAssessmentsDrilldownAPI(
      APIService.UpcomingAssessmentsDrilldown(month, selectedCountry),
      (res) => {
        if (res.CODE) {
          setFilterUpcomingAssessment(res.MSG);
          setUpcomingAssessmentModal(true);
        }
      }
    );
    setLoading(false);
  };

  const [gridApi, setGridApi] = useState(null);

  // Apply settings across all columns
  const defaultColDef = useMemo(() => ({
    // Enable filtering on all columns,
    // flex:1,
    sortable: true,
    cellDataType: false,
    wrapText: true,
    autoHeight: true,
  }));

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const onBtnExport = useCallback((val) => {
    val.current.api.exportDataAsCsv();
  }, []);

  const handleCancel = () => {
    setUpcomingAssessmentModal(false);
    setVendorAssessmentSentModal(false);
    setVendorAssessmentCompletedModal(false);
    setIssueRatingModal(false);
    setCompletedAssessmentModal(false);
    setPendingAssessmentModal(false);
    setAssessmentSummaryModal(false);
    setAssessmentSummaryByCategoryModal(false);
    setCategoryByCriticalityModal(false);
    setAssessmentCriticalityModal(false);
  };

  const IssueCloseOpenData = () => {
    setGetIssuesCloseOpenModalData(false);
  };
  const VendorResponseCancel = () => {
    setVendorResponseModal(false);
  };

  const IssueManagementFollowUpCancel = () => {
    setIssueManagementFollowUpModal(false);
  };

  const VendorHighRiskModalCancel = () => {
    setVendorHighRiskModal(false);
  };

  const VendorMediumRiskModalCancel = () => {
    setVendorMediumRiskModal(false);
  };
  const VendorLowRiskModalCancel = () => {
    setVendorLowRiskModal(false);
  };
  const issueTrendModalCancel = () => {
    setIssueTrendModal(false);
  };

  const CategoryWiseCriticalityCancel = () => {
    setCategoryWiseCriticality(false);
  };
  const CategoryWiseCriticalityOverDueDateDetailsCancel = () => {
    setCategoryWiseCriticalityOverDueDateDetails(false);
  };
  useEffect(() => {
    ClosureIssueTrends();
    vendorResponseChart();
    IssueFollowUpVendorByCategory();
    VendorCategoryOfHighRisk();
    VendorCategoryOfMediumRisk();
    VendorCategoryOfLowRisk();
    getIssuesByPriorityDonutChart();
    upCompingAssesment();
    vendorAssessmentSent();
    vendorAssessmentCompleted();
    VendorsClosureStatusId();
    CategoryWiseCriticality();
    completedPendingAssessmentChart();
    getIssuesOpenCloseChart();
    assessmentSummaryChart();
    riskOverviewChart();
    assessmentSummaryByCategoryChart();
    CategoryWiseOverDueDate();
    CriticalityWiseOverDueDate();
    criticalityPerCategoryChart();
    assessmentSummaryByCriticality();
    riskOverviewCategoryChart();

  }, [
    issueByRatingRef.current,
    getIssuesByRatings,
    upcomingAssessmentRef.current,
    upComingChatData,
    availableGraphsInMenu,
    vendorCategoryAssessmentCompleted,
    vendorAssessmentCompletedRef.current,
    vendorCategoryAssessmentSent,
    vendorAssessmentSentRef.current,
    vendorAssessmentResponseRef.current,
    completedPendingResponseRef.current,
    completedPendingAssessment,
    IssueManagementFollowUpRef.current,
    VendorCategoryOfHighRiskRef.current,
    VendorCategoryOfMediumRiskRef.current,
    VendorCategoryOfLowRiskRef.current,
    VendorsClosureStatusRef.current,
    ClosureIssueTrendsRef.current,
    ClosueStatusTrendsData,
    CategoryWiseCriticalityRef.current,
    IssuesOpenCloseRef.current,
    getIssuesCloseOpenData,
    assessmentSummary,
    riskOverview,
    assessmentSummaryDashboard.current,
    riskOverviewAssesmentOutcome.current,
    assessmentSummaryByCategory,
    riskOverviewCategory,
    assessmentSummaryByCategoryRef.current,
    AgingAnalysisCategoryRef.current,
    AgingAnalysisCriticalityRef.current,
    riskOverviewCategoryRef.current,
    criticalityPerCategory,
    criticalityPerCategoryRef.current,
    assessmentSummaryCriticality,
    assessmentSummaryCriticalityRef.current,

  ]);


  function riskOverviewCategoryChart() {    
    let data4 = riskOverviewCategory; // Ensure this is an array of objects with consistent keys    
    const margin = { top: 10, right: 100, bottom: 60, left: 120 },    
        width = 404 - margin.left - margin.right,    
        height = 270 - margin.top - margin.bottom;    
    
     
    
    if (riskOverviewCategoryRef.current) {    
        let tempRef = riskOverviewCategoryRef.current.id;    
        d3.select(`#${tempRef}`).selectAll("*").remove();    
        const svg = d3    
            .select(`#${tempRef}`)    
            .append("svg")    
            .attr("width", width + margin.left + margin.right)    
            .attr("height", height + margin.top + margin.bottom)    
            .append("g")    
            .attr("transform", `translate(${margin.left}, ${margin.top})`);    
    
        const status = Object.keys(data4[0]).filter((d) => d != "daysBracket");    
        const category = data4.map((d) => d.daysBracket);    
    
        const groups = data4.map(d => d?.daysBracket); 
        
        const subgroups = [      
          "IT Services Provider", "Manpower Services Provider", "Manufacturing Equipment Supplier",      
          "Parts and Ancillaries Supplier", "Dealer PV", "Others", "Dealer CV",      
          "Supplier CV", "Supplier PV", "DPDS service provider", "Connected Vehicle Vendors"      
        ];   
        const stack = d3.stack().keys(subgroups);      
        const stackedData = stack(data4);   
    
        // const stackedData = d3.stack().keys(status)(data4);    
    
        // Log the stacked data to inspect its structure    
    
        // Ensure stacked data is properly generated    
        if (!stackedData || !stackedData.length) {    
            console.error("Stacked data generated incorrectly:", stackedData);    
            return;    
        }    
    
        // Calculate xmax by iterating over all layers and all values    
        const xmax = d3.max(stackedData, layer => d3.max(layer, seq => seq[1]));    
    
        const x = d3.scaleLinear().domain([0, xmax]).nice().range([0, width]);    
    
        const y = d3    
            .scaleBand()    
            .domain(category)    
            .range([0, height])    
            .padding(0.25);    
    
        // const colorMapping = {  
        //   "IT Service Provider": "#D04A02",    
  
        //     "Parts and Ancillaries Supplier": "#7D7D7D",    
        //     "Dealer CV": "#299D8F",    
        //     "Manpower Service Provider": "#EB8C00",    
        //     "Deader PV": "#DEDEDE",    
        //     "Manufacturing Equipment Provider": "#FFB600",    
        //     "Super CV": "#4577C9",    
        //     "Others": "#295477",    
        //     "Supplier PV": "#00C6F7",    
        //     "DPDS service provider": "#D93954",    
        //     "Connected Vehicle Vendors": "#657DFF",    
        //     "Manufacturing Equipment Supplier": "#F18085"    
        // };    
    
        // // Define a fallback color scale    
        // const color = d3.scaleOrdinal(d3.schemeCategory10); 
        // const subgroups = Object.keys(data4[0]).slice(1);  
         
          
        // Ensure all subgroups have values in the data      
        data4 = data4.map(d => {      
            subgroups.forEach(subgroup => {      
                if (d[subgroup] === undefined) {      
                    d[subgroup] = '';      
                }      
            });      
            return d;      
        });      
          
         
        const color = d3.scaleOrdinal()      
                    .domain(subgroups)      
                    .range([      
                      "#D04A02", "#EB8C00", "#FFB600", "#7D7D7D", "#DEDEDE",      
                      "#295477", "#299D8F", "#4577C9", "#00C6F7", "#D93954", "#657DFF"      
                    ]);      
    
        const yAxis = d3.axisLeft(y);    
        // Generate an array of tick values with a step of 1    
        const tickValues = d3.range(0, xmax + 1, 1);    
        const xAxis = d3.axisBottom(x)    
            .tickValues(tickValues)    
            .tickFormat(d3.format("d"));      
  
        let hoverTooltip = d3.select("body").append("div")    
            .attr("class", "vendorAssessmentTooltip")    
            .style("opacity", 0);    
    
        let div = d3.select("body").append("div")    
            .attr("class", "xaxisTooltip")    
            .style("opacity", 0);    
    
        svg    
            .append("g")    
            .attr("transform", `translate(0, ${height})`)    
            .call(xAxis)    
            .selectAll("text")    
            .style("font-size", 12)    
            .call((g) => g.select(".domain").remove());    
    
        svg    
            .append("g")    
            .call(yAxis.tickFormat(    
                (d) => (d?.length > 12 ? d?.substring(0, 12) + "..." : d))    
                .tickPadding(8))    
            .style("text-anchor", "end")    
            .style("font-size", 10)    
            .call((g) => g.select(".domain").remove())    
            .selectAll("text")    
            .style("font-size", 10)    
            .on("mousemove", function (event, d) {    
                div.style("opacity", 1)    
                    .style("left", event.pageX + "px")    
                    .style("top", event.pageY - 30 + "px")    
                    .style("display", "inline-block")    
                    .style("font-size", "12px")    
                    .html(`<span>${d}</span>`);    
            })    
            .on("mouseout", function (n) {    
                div.style("opacity", 0);    
                div.style("display", "none");    
            }); 
            
           // Add x-axis grid lines  
        svg.append("g")  
        .attr("class", "grid")  
        .selectAll("line")  
        .data(tickValues)  
        .enter()  
        .append("line")  
        .attr("x1", d => x(d))  
        .attr("x2", d => x(d))  
        .attr("y1", 0)  
        .attr("y2", height)  
        .style("stroke", "#000") // Dark line color  
        .style("stroke-width", "0.5px"); // Line thickness  

        svg    
            .append("g")    
            .selectAll("g")    
            .data(stackedData)    
            .enter()    
            .append("g")    
            .attr("fill", function (d) {    
                return  color(d.key);    
            })    
            .selectAll("rect")    
            .data((d) => d)    
            .enter()    
            .append("rect")    
            .attr("x", (d) => x(d[0]))    
            .attr("y", (d) => y(d.data.daysBracket))    
            .attr("height", y.bandwidth())    
            .attr("width", (d) => x(d[1]) - x(d[0]))    
            .on("mousemove", function (event, d) {    
                const key = d3.select(this.parentNode).datum().key;    
                const formattedKey = key.charAt(0).toUpperCase() + key.slice(1).toLowerCase();    
                hoverTooltip.style("opacity", 1)    
                    .style("left", event.pageX + "px")    
                    .style("top", event.pageY - 30 + "px")    
                    .style("display", "inline-block")    
                    .style("font-size", "12px")    
                    .html(`<span>Category: ${formattedKey} <br> Value: ${d[1] - d[0]}</span>`);    
            })    
            .on("mouseout", function (n) {    
                hoverTooltip.style("opacity", 0);    
                hoverTooltip.style("display", "none");    
            })    
            .on("click", function (event, d) {    
                const key = d3.select(this.parentNode).datum().key;    
                const formattedKey = key.charAt(0).toUpperCase() + key.slice(1).toLowerCase();    
                if (d.data.daysBracket == "Need Improvement") {    
                    getAssessmentbyRatingDrillDownAPI("High", formattedKey);    
                } else if (d.data.daysBracket == "Fairly Satisfactory") {    
                    getAssessmentbyRatingDrillDownAPI("Medium", formattedKey);    
                } else if (d.data.daysBracket == "Satisfactory") {    
                    getAssessmentbyRatingDrillDownAPI("Low", formattedKey);    
                }    
                setIssueRatingModal(true);    
            })  
            // .each(function (d) {  
            //    // Add text label, but only if the value is a number  
            //    const value = d[1] - d[0];  
            //    if (!isNaN(value)) {  
            //        svg.append("text")  
            //            .attr("x", x(d[1]) - (x(d[1]) - x(d[0])) / 2)  
            //            .attr("y", y(d.data.daysBracket) + y.bandwidth() / 2)  
            //            .attr("dy", "0.35em")  
            //            .style("text-anchor", "middle")  
            //            .style("fill", "black")  
            //            .style("font-size", "10px")  
            //            .text(value);  
            //    }  
            // });  
              
           // X Axis Label        
     svg.append("text")        
     .attr("transform", `translate(${width / 2}, ${height + margin.bottom - 10})`)        
     .style("text-anchor", "middle")        
     .style("font-size", "10px")        
     .text("Risk");        
      
  // Y Axis Label        
  svg.append("text")        
     .attr("transform", "rotate(-90)")        
     .attr("y", -98)        
     .attr("x", 0 - (height / 2))        
     .attr("dy", "1em")        
     .style("text-anchor", "middle")        
     .style("font-size", "10px")        
     .text("Assessment Count");  
    
        const legendRectSize = 10;
   
        const legendSpacing = 4;  
        const legendOffsetX = width + 15; // Start legend after the chart width with some padding        
        const legendOffsetY = 25; // Start legend from the top with some padding        
  
       
        const legend = svg.selectAll('.legend')  
            .data(subgroups)  
            .enter()  
            .append('g')  
            .attr('class', 'legend')  
            .attr('transform', (d, i) => {  
                const yOffset = legendOffsetY + i * 20;  
                return `translate(${legendOffsetX}, ${yOffset})`;  
            });  
  
        legend.append('rect')  
            .attr('width', legendRectSize)  
            .attr('height', legendRectSize)  
            .style('fill', d => color(d))  
            .style('stroke', d => color(d));  
  
        legend.append('text')  
            .attr('x', legendRectSize + legendSpacing)  
            .attr('y', legendRectSize - legendSpacing)  
            .style("font-size", "10px")  
            .text(d => d.length > 7 ? d.substring(0, 7) + "..." : d)  
            .on("mousemove", function (event, d) {  
                div.style("opacity", 1)  
                    .style("left", event.pageX + "px")  
                    .style("top", event.pageY - 30 + "px")  
                    .style("display", "inline-block")  
                    .style("font-size", "12px")  
                    .html(`<span>${d}</span>`);  
            })  
            .on("mouseout", function () {  
                div.style("opacity", 0);  
                div.style("display", "none");  
            });  
    }  
}  



   //Issues by priority chart
   function riskOverviewChart() {    
    let data = riskOverview.map((e) => {    
      return { name: e.name, value: parseInt(e.count) ,label:parseInt(e.count)};    
    });    
    const data1 = riskOverview.reduce((acc, val) => {  
      return acc + parseInt(val.count);  
    }, 0); // Text to be displayed in the middle  
      
    let text = data1;  
    let width = 300;    
    let height = 335;    
      
    let thickness = 40;    
    let duration = 750;    
      
    let radius = Math.min(width - 100, height - 100) / 2;    
    let color = d3.scaleOrdinal(d3.schemeCategory10);    
      
    if (riskOverviewAssesmentOutcome.current) {    
      let tempRef = riskOverviewAssesmentOutcome.current.id;    
      d3.select(`#${tempRef}`).selectAll("*").remove();    
      let svg = d3    
        .select(`#${tempRef}`)    
        .append("svg")    
        .attr("class", "assesmentSummaryDonut")    
        .attr("width", width)    
        .attr("height", height);    
        
      let g = svg    
        .append("g")    
        .attr(    
          "transform",    
          "translate(" +    
            ((width - 100) / 2 + 50) +    
            "," +    
            (height - 100) / 2 +    
            ")"    
        );    
        
      var arc = d3    
        .arc()    
        .innerRadius(radius - thickness)    
        .outerRadius(radius);    
        
      var pie = d3    
        .pie()
        .padAngle(0.02)    
        .value(function (d) {    
          return d.value;    
        })    
        .startAngle(1.1 * Math.PI)    
        .endAngle(3.1 * Math.PI)    
        .sort(null);    
        
      var path = g    
        .selectAll("path")    
        .data(pie(data))    
        .enter()    
        .append("g")    
        .on("mouseover", function (event, d) {    
          let g = d3    
            .select(this)    
            .style("cursor", "pointer")    
            .append("g")    
            .attr("class", "text-group");    
        
          // g.append("text")    
          //   .attr("class", "name-text")    
          //   .text(`${d.data.name}`)    
          //   .attr("text-anchor", "middle")    
          //   .attr("dy", "-1.2em");    
        
          // g.append("text")    
          //   .attr("class", "value-text")    
          //   .text(`${d.data.value}`)    
          //   .attr("text-anchor", "middle")    
          //   .attr("dy", ".6em");    
        })    
        .on("mouseout", function (event, d) {    
          d3.select(this)    
            .style("cursor", "none")    
            .style("fill", color(this._current))    
            .select(".text-group")    
            .remove();    
        })    
        .on("click", function (event, d) {    
          if (d.data.name == "Need Improvement") {    
            getAssessmentbyRatingDrillDownAPI("High");    
          } else if (d.data.name == "Fairly Satisfactory") {    
            getAssessmentbyRatingDrillDownAPI("Medium");    
          } else if (d.data.name == "Satisfactory") {    
            getAssessmentbyRatingDrillDownAPI("Low");    
          }       
          setIssueRatingModal(true);    
        })    
        .append("path")    
        .attr("d", arc)    
        .attr("fill", (d, i) => {
          if (d.data.name === "Need Improvement") {    
            return "#FFB600";    
          } else if (d.data.name === "Fairly Satisfactory") {    
            return "#d04a02";    
          }  else if (d.data.name === "Satisfactory") {    
            return "#e0301e";    
          }    
          return color(i); // Fixed: Add 'return'    
        });    
        
      // Add labels    
      g.selectAll("text")    
        .data(pie(data))    
        .enter()    
        .append("text")    
        .attr("transform", function (d) {    
          return "translate(" + arc.centroid(d) + ")";    
        })    
        .attr("dy", ".35em")    
        .attr("text-anchor", "middle")    
        .attr("fill", "#fff") // Set label color to white    
        .text(function (d) {    
          return d.data.label; // Changed to 'label' to show the segment labels  
        });    
        
      // Add middle text    
      g.append("text")    
        .attr("text-anchor", "middle")    
        .attr("dy", ".35em")    
        .attr("class", "middle-text")    
        .style("font-size", "20px")    
        .style("fill", "#333")    
        .text(text);    
        
      // Add title above the chart  
        
    
      let newG = svg.append("g").attr("transform", "translate(0, 120)");    

      newG    
      .append("rect")    
      .attr("x", 10)    
      .attr("y", 124)    
      .attr("width", 10)    
      .attr("height", 8)    
      .attr("stroke", "#d04a02")    
      .attr("fill", "#d04a02");    
    newG    
      .append("text")    
      .attr("x", 25)    
      .attr("y", 133)    
      .style("font-size", 10)    
      .text("Fairly Satisfactory"); 

      newG    
        .append("rect")    
        .attr("x", 121)    
        .attr("y", 124)    
        .attr("width", 10)    
        .attr("height", 8)    
        .attr("stroke", "#FFB600")    
        .attr("fill", "#FFB600");    
      newG    
        .append("text")    
        .attr("x", 134)    
        .attr("y", 133)    
        .style("font-size", 10)    
        .text("Need Improvement");    
        
     
        
        newG    
        .append("rect")    
        .attr("x", 231)    
        .attr("y", 124)    
        .attr("width", 10)    
        .attr("height", 8)    
        .attr("stroke", "#e0301e")    
        .attr("fill", "#e0301e");    
      newG    
        .append("text")    
        .attr("x", 244)    
        .attr("y", 133)    
        .style("font-size", 10)    
        .text("Satisfactory");  
    }    
  }    
  

  function ClosureIssueTrends() {
    let format3 = d3.timeParse("%Y-%m-%d");
    let data = [];
    ClosueStatusTrendsData.reduce(function (res, value) {
      if (!res[value.date]) {
        res[value.date] = {
          date: format3(value.date),
          high: 0,
          low: 0,
          medium: 0,
        };
        data.push(res[value.date]);
      }
      res[value.date].high += Number(value.high);
      res[value.date].low += Number(value.low);
      res[value.date].medium += Number(value.medium);
      return res;
    }, {});
    let margin = { top: 30, right: 20, bottom: 75, left: 30 },
      width = 380 - margin.left - margin.right,
      height = 260 - margin.top - margin.bottom;
    let formatyAxis = d3.format(".0f");
    let x = d3.scaleTime().range([0, width]);
    let y = d3.scaleLinear().range([height, 0]);
    let maxhigh = Math.ceil(d3.max(data, (d) => d.high));
    let maxMid = Math.ceil(d3.max(data, (d) => d.medium));
    let maxLow = Math.ceil(d3.max(data, (d) => d.low));
    let maxVal = Math.ceil(d3.max([maxhigh, maxMid, maxLow]));
    if (maxVal < 4 && maxVal >= 1) {
      maxVal = 5;
    } else if (maxVal <= 5) {
      maxVal = 5;
    } else {
      maxVal += 2;
    }
    let xAxis = d3.axisBottom(x).ticks(6).tickSizeOuter(0);
    let yAxis = d3
      .axisLeft(y)
      .ticks(maxVal)
      .tickSizeOuter(0)
      .tickFormat(formatyAxis);
    let valueline = d3
      .line()
      .x(function (d) {
        return x(d.date);
      })
      .y(function (d) {
        return y(d.low);
      });
    let valueline2 = d3
      .line()
      .x(function (d) {
        return x(d.date);
      })
      .y(function (d) {
        return y(d.medium);
      });
    let valueline3 = d3
      .line()
      .x(function (d) {
        return x(d.date);
      })
      .y(function (d) {
        return y(d.high);
      });

    if (ClosureIssueTrendsRef.current) {
      let tempRef = ClosureIssueTrendsRef.current.id;
      d3.select(`#${tempRef}`).selectAll("*").remove();
      let svg = d3
        .select(`#${tempRef}`)
        .append("svg")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
        .append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

      let div = d3
        .select("body")
        .append("div")
        .attr("class", "overAllRiskLineCharttooltip")
        .style("opacity", 0);

      function make_y_gridlines() {
        return d3.axisLeft(y).ticks(maxVal);
      }
      x.domain(
        d3.extent(data, function (d) {
          return d.date;
        })
      );
      y.domain([0, maxVal]);

      svg
        .append("g")
        .attr("class", "grid")
        .call(make_y_gridlines().tickSize(-width).tickFormat(""));

      svg
        .append("path")
        .attr("class", "line")
        .style("stroke", "#299D8F")
        .style("stroke-width", "3.5")
        .style("fill", "none")
        .attr("d", valueline(data));

      svg
        .selectAll(".dot")
        .data(data)
        .enter()
        .append("circle")
        .attr("class", "dot")
        .attr("cx", function (d, i) {
          return x(d.date);
        })
        .attr("cy", function (d) {
          return y(d.low);
        })
        .attr("r", 5)
        .style("fill", "#299D8F")
        .on("mousemove", function (d, n) {
          div
            .style("opacity", 1)
            .style("left", d.pageX + "px")
            .style("top", d.pageY - 30 + "px")
            .style("display", "inline-block")
            .html(
              "<span>Date: " +
                d3.timeFormat("%Y-%m-%d")(n.date) +
                "<br />Low: " +
                n.low +
                "</span>"
            );
        })
        .on("mouseout", function (n) {
          div.style("opacity", 0);
          div.style("display", "none");
        })
        .on("click", function (event, d) {
          div.style("display", "none");
          setIssueTrendModal(true);
          IssueClosureTrendDrillDown(
            "High",
            d3.timeFormat("%Y-%m-%d")(d?.date)
          );
        });

      svg
        .append("path")
        //.data([data])
        .attr("class", "line")
        .style("stroke", "#FFB600")
        .style("stroke-width", "3.5")
        .style("fill", "none")
        .attr("d", valueline2(data));

      svg
        .selectAll(".valueline2")
        .data(data)
        .enter()
        .append("circle")
        .attr("class", "valueline2")
        .attr("cx", function (d, i) {
          return x(d.date);
        })
        .attr("cy", function (d) {
          return y(d.medium);
        })
        .attr("r", 5)
        .style("fill", "#FFB600")
        .on("mousemove", function (event, d) {
          div
            .style("opacity", 1)
            .style("left", event.pageX + "px")
            .style("top", event.pageY - 30 + "px")
            .style("display", "inline-block")
            .html(
              "<span>Date: " +
                d3.timeFormat("%Y-%m-%d")(d.date) +
                "<br />Medium: " +
                d.medium +
                "</span>"
            );
        })
        .on("mouseout", function (n) {
          div.style("opacity", 0);
          div.style("display", "none");
        })
        .on("click", function (event, d) {
          div.style("display", "none");
          setIssueTrendModal(true);
          IssueClosureTrendDrillDown(
            "Medium",
            d3.timeFormat("%Y-%m-%d")(d?.date)
          );
        });

      svg
        .append("path")
        //.data([data])
        .attr("class", "line")
        .style("stroke", "#D04A02")
        .style("stroke-width", "3.5")
        .style("fill", "none")
        .attr("d", valueline3(data));

      svg
        .selectAll(".valueline3")
        .data(data)
        .enter()
        .append("circle")
        .attr("class", "valueline3")
        .attr("cx", function (d, i) {
          return x(d.date);
        })
        .attr("cy", function (d) {
          return y(d.high);
        })
        .attr("r", 5)
        .style("fill", "#D04A02")
        .on("mousemove", function (event, d) {
          div
            .style("opacity", 1)
            .style("left", event.pageX + "px")
            .style("top", event.pageY - 30 + "px")
            .style("display", "inline-block")
            .html(
              "<span>Date: " +
                d3.timeFormat("%Y-%m-%d")(d.date) +
                "<br />High: " +
                d.high +
                "</span>"
            );
        })
        .on("mouseout", function (n) {
          div.style("opacity", 0);
          div.style("display", "none");
        })
        .on("click", function (event, d) {
          div.style("display", "none");
          setIssueTrendModal(true);
          IssueClosureTrendDrillDown("Low", d3.timeFormat("%Y-%m-%d")(d?.date));
        });

      svg
        .append("g")
        .attr("class", "x lineChartAxis")
        .attr("transform", "translate(0," + height + ")")
        .call(xAxis)
        .selectAll("text")
        .style("text-anchor", "end")
        .attr("dx", "-.8em")
        .attr("dy", ".15em")
        .attr("transform", "rotate(-65)");

      svg.append("g").attr("class", "y lineChartAxis").call(yAxis);

      d3.selectAll(".y > .tick > line").attr("visibility", "hidden");

      let newG = svg.append("g").attr("transform", "translate(12, 100)");
      newG
        .append("rect")
        .attr("x", 10)
        .attr("y", 120)
        .attr("width", 36)
        .attr("height", 5)
        .attr("stroke", "#D04A02")
        .attr("fill", "#D04A02");
      newG
        .append("text")
        .attr("x", 58)
        .attr("y", 128)
        .style("font-size", 12)
        .text("High");

      newG
        .append("rect")
        .attr("x", 130)
        .attr("y", 120)
        .attr("width", 36)
        .attr("height", 5)
        .attr("stroke", "#FFB600")
        .attr("fill", "#FFB600");
      newG
        .append("text")
        .attr("x", 178)
        .attr("y", 128)
        .style("font-size", 12)
        .text("Medium");

      newG
        .append("rect")
        .attr("x", 260)
        .attr("y", 120)
        .attr("width", 36)
        .attr("height", 5)
        .attr("stroke", "#299D8F")
        .attr("fill", "#299D8F");

      newG
        .append("text")
        .attr("x", 309)
        .attr("y", 128)
        .style("font-size", 12)
        .text("Low");
    }
  }

  // upcoming assesment bar chart
  function upCompingAssesment() {
    // get the data
    let data = upComingChatData;
    data.forEach(function (d) {
      d.issues = +d.issues;
    });
    let maxVal = Math.ceil(d3.max(data, (d) => d.issues));
    if (maxVal < 4 && maxVal >= 1) {
      maxVal = 4;
    } else if (maxVal <= 5) {
      maxVal = 5;
    } else {
      maxVal += 5;
    }
    let margin = { top: 20, right: 20, bottom: 70, left: 50 },
      width = 404 - margin.left - margin.right,
      height = 260 - margin.top - margin.bottom;

    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    let x = d3.scaleBand().range([0, width]).padding(0.5);
    let y = d3.scaleLinear().range([height, 0]);

    if (upcomingAssessmentRef.current) {
      let tempRef = upcomingAssessmentRef.current.id;
      d3.select(`#${tempRef}`).selectAll("*").remove();
      let svg = d3
        .select(`#${tempRef}`)
        .append("svg")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
        .append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

      let div = d3
        .select("body")
        .append("div")
        .attr("class", "upComingAssesmenttooltip")
        .style("opacity", 0);

      let xaxisTooltip = d3
        .select("body")
        .append("div")
        .attr("class", "xaxisTooltip")
        .style("opacity", 0);

      x.domain(
        data.map(function (d) {
          return d.months;
        })
      );
      y.domain([0, maxVal]);

      svg
        .selectAll(".bar")
        .data(data)
        .enter()
        .append("rect")
        .attr("class", "bar")
        .style("fill", "#FFB600")
        .attr("x", function (d) {
          return x(d.months);
        })
        .attr("width", x.bandwidth())
        .attr("y", function (d) {
          return y(d.issues);
        })
        .attr("height", function (d) {
          return height - y(d.issues);
        })
        .on("mousemove", function (event, d) {
          div
            .style("opacity", 1)
            .style("left", event.pageX + "px")
            .style("top", event.pageY - 30 + "px")
            .style("display", "inline-block")
            .html("<span>Assessments: " + d.issues + "</span>");
        })
        .on("mouseout", function (n) {
          div.style("opacity", 0);
          div.style("display", "none");
        })
        .on("click", function (event, d) {
          div.style("display", "none");
          getUpcomingAssessmentDrilldownData(d.months.trim());
        });

      svg
        .append("g")
        .attr("transform", "translate(0," + height + ")")
        .call(
          d3
            .axisBottom(x)
            .tickFormat((d) => (d.length > 15 ? d.substring(0, 15) + "..." : d))
        )
        .selectAll("text")
        .attr("transform", "translate(-5,5)rotate(-25)")
        .style("text-anchor", "end")
        .style("font-size", 16)
        .on("mousemove", function (event, d) {
          xaxisTooltip
            .style("opacity", 1)
            .style("left", event.pageX + "px")
            .style("top", event.pageY - 30 + "px")
            .style("display", "inline-block")
            .html(`<span>${d}</span>`);
        })
        .on("mouseout", function (n) {
          xaxisTooltip.style("opacity", 0);
          xaxisTooltip.style("display", "none");
        });

      svg
        .append("g")
        .call(d3.axisLeft(y).ticks(4))
        .selectAll("text")
        .style("font-size", 13);
    }
  }

  function vendorAssessmentSent() {
    // get the data
    let data = vendorCategoryAssessmentSent;
    let maxVal = Math.ceil(d3.max(data, (d) => d.vendor_count));
    if (maxVal < 4 && maxVal >= 1) {
      maxVal = 4;
    } else if (maxVal <= 5) {
      maxVal = 5;
    } else {
      maxVal += 5;
    }
    let margin = { top: 20, right: 20, bottom: 110, left: 50 },
      width = 404 - margin.left - margin.right,
      height = 260 - margin.top - margin.bottom;

    let x = d3.scaleBand().range([0, width]).padding(0.5);
    let y = d3.scaleLinear().range([height, 0]);

    if (vendorAssessmentSentRef.current) {
      let tempRef = vendorAssessmentSentRef.current.id;
      d3.select(`#${tempRef}`).selectAll("*").remove();
      let svg = d3
        .select(`#${tempRef}`)
        .append("svg")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
        .append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

      let div = d3
        .select("body")
        .append("div")
        .attr("class", "vendorAssessmentTooltip")
        .style("opacity", 0);

      let xaxisTooltip = d3
        .select("body")
        .append("div")
        .attr("class", "xaxisTooltip")
        .style("opacity", 0);

      x.domain(
        data.map(function (d) {
          return d.category;
        })
      );
      y.domain([0, maxVal]);

      svg
        .selectAll(".bar")
        .data(data)
        .enter()
        .append("rect")
        .attr("class", "bar")
        .style("fill", "#FF6600")
        .attr("x", function (d) {
          return x(d.category);
        })
        .attr("width", x.bandwidth())
        .attr("y", function (d) {
          return y(d.vendor_count);
        })
        .attr("height", function (d) {
          return height - y(d.vendor_count);
        })
        .on("mousemove", function (event, d) {
          div
            .style("opacity", 1)
            .style("left", event.pageX + "px")
            .style("top", event.pageY - 30 + "px")
            .style("display", "inline-block")
            .html("<span>Assessment: " + d.vendor_count + "</span>");
        })
        .on("mouseout", function (n) {
          div.style("opacity", 0);
          div.style("display", "none");
        })
        .on("click", function (event, d) {
          div.style("opacity", 0);
          div.style("display", "none");
          getVendorCategoryAssessmentSentDrilldown(d.category);
          setVendorAssessmentSentModal(true);
        });

      svg
        .append("g")
        .attr("transform", "translate(0," + height + ")")
        .call(
          d3
            .axisBottom(x)
            .tickFormat((d) => (d.length > 15 ? d.substring(0, 15) + "..." : d))
        )
        .selectAll("text")
        .attr("transform", "translate(-5,5)rotate(-25)")
        .style("text-anchor", "end")
        .style("font-size", 16)
        .on("mousemove", function (event, d) {
          xaxisTooltip
            .style("opacity", 1)
            .style("left", event.pageX + "px")
            .style("top", event.pageY - 30 + "px")
            .style("display", "inline-block")
            .html(`<span>${d}</span>`);
        })
        .on("mouseout", function (n) {
          xaxisTooltip.style("opacity", 0);
          xaxisTooltip.style("display", "none");
        });

      svg.append("g").call(d3.axisLeft(y).ticks(4));
    }
  }

  function vendorAssessmentCompleted() {
    // get the data
    let data = vendorCategoryAssessmentCompleted;
    let maxVal = Math.ceil(d3.max(data, (d) => d.vendor_count));
    if (maxVal < 4 && maxVal >= 1) {
      maxVal = 4;
    } else if (maxVal <= 5) {
      maxVal = 5;
    } else {
      maxVal += 5;
    }
    let margin = { top: 20, right: 20, bottom: 110, left: 50 },
      width = 404 - margin.left - margin.right,
      height = 260 - margin.top - margin.bottom;

    let x = d3.scaleBand().range([0, width]).padding(0.5);
    let y = d3.scaleLinear().range([height, 0]);

    if (vendorAssessmentCompletedRef.current) {
      let tempRef = vendorAssessmentCompletedRef.current.id;
      d3.select(`#${tempRef}`).selectAll("*").remove();
      let svg = d3
        .select(`#${tempRef}`)
        .append("svg")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
        .append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

      let div = d3
        .select("body")
        .append("div")
        .attr("class", "vendorAssessmentTooltip")
        .style("opacity", 0);

      let xaxisTooltip = d3
        .select("body")
        .append("div")
        .attr("class", "xaxisTooltip")
        .style("opacity", 0);

      x.domain(
        data.map(function (d) {
          return d.category;
        })
      );
      y.domain([0, maxVal]);

      svg
        .selectAll(".bar")
        .data(data)
        .enter()
        .append("rect")
        .attr("class", "bar")
        .style("fill", "#175d2d")
        .attr("x", function (d) {
          return x(d.category);
        })
        .attr("width", x.bandwidth())
        .attr("y", function (d) {
          return y(d.vendor_count);
        })
        .attr("height", function (d) {
          return height - y(d.vendor_count);
        })
        .on("mousemove", function (event, d) {
          div
            .style("opacity", 1)
            .style("left", event.pageX + "px")
            .style("top", event.pageY - 30 + "px")
            .style("display", "inline-block")
            .html("<span>Assessment: " + d.vendor_count + "</span>");
        })
        .on("mouseout", function (n) {
          div.style("opacity", 0);
          div.style("display", "none");
        })
        .on("click", function (event, d) {
          div.style("opacity", 0);
          div.style("display", "none");
          getVendorCategoryAssessmentCompletedDrilldown(d.category);
          setVendorAssessmentCompletedModal(true);
        });

      svg
        .append("g")
        .attr("transform", "translate(0," + height + ")")
        .call(
          d3
            .axisBottom(x)
            .tickFormat((d) => (d.length > 15 ? d.substring(0, 15) + "..." : d))
        )
        .selectAll("text")
        .attr("transform", "translate(-5,5)rotate(-25)")
        .style("text-anchor", "end")
        .style("font-size", 16)
        .on("mousemove", function (event, d) {
          xaxisTooltip
            .style("opacity", 1)
            .style("left", event.pageX + "px")
            .style("top", event.pageY - 30 + "px")
            .style("display", "inline-block")
            .html(`<span>${d}</span>`);
        })
        .on("mouseout", function (n) {
          xaxisTooltip.style("opacity", 0);
          xaxisTooltip.style("display", "none");
        });

      svg.append("g").call(d3.axisLeft(y).ticks(4));
    }
  }

  //Assesment Summary Donut chart
  function vendorResponseChart() {
    let data = vendorResponseChartData.map((e, i) => {
      return { name: e.name.replace(" ", "-"), value: parseInt(e.value) };
    });
    let text = "";

    let width = 300;
    let height = 335;

    let thickness = 40;
    let duration = 750;

    let radius = Math.min(width - 100, height - 100) / 2;
    let color = d3.scaleOrdinal(d3.schemeCategory10);
    if (vendorAssessmentResponseRef.current) {
      let tempRef = vendorAssessmentResponseRef.current.id;
      d3.select(`#${tempRef}`).selectAll("*").remove();
      let svg = d3
        .select(`#${tempRef}`)
        .append("svg")
        .attr("class", "assesmentSummaryDonut")
        .attr("width", width)
        .attr("height", height);

      let g = svg
        .append("g")
        .attr(
          "transform",
          "translate(" +
            ((width - 100) / 2 + 50) +
            "," +
            (height - 100) / 2 +
            ")"
        );

      let arc = d3
        .arc()
        .innerRadius(radius - thickness)
        .outerRadius(radius);

      let pie = d3
        .pie()
        .value(function (d) {
          return d.value;
        })
        .sort(null);

      let path = g
        .selectAll("path")
        .data(pie(data))
        .enter()
        .append("g")
        .on("mouseover", function (event, d) {
          let g = d3
            .select(this)
            .style("cursor", "pointer")
            .append("g")
            .attr("class", "text-group");

          g.append("text")
            .attr("class", "name-text")
            .text(`${d.data.name}`)
            .attr("text-anchor", "middle")
            .attr("dy", "-1.2em");

          g.append("text")
            .attr("class", "value-text")
            .text(`${d.data.value}`)
            .attr("text-anchor", "middle")
            .attr("dy", ".6em");
        })
        .on("mouseout", function (d) {
          d3.select(this)
            .style("cursor", "none")
            .style("fill", color(this._current))
            .select(".text-group")
            .remove();
        })
        .on("click", function (event, d) {
          VendorResponseDrilldownData(d?.data?.name);
          setVendorResponseModal(true);
        })
        .append("path")
        .attr("d", arc)
        .attr("fill", (d, i) => {
          if (d.data.name === "Delayed") {
            return "#D04A02";
          } else if (d.data.name === "Responded") {
            return "#FFB600";
          } else if (d.data.name == "No-Response") {
            return "#FF6600";
          }
          color(i);
        });

      g.append("text")
        .attr("text-anchor", "middle")
        .attr("dy", ".35em")
        .text(text);

      //transform="translate(100,110)"
      let newG = svg.append("g").attr("transform", "translate(0, 120)");
      newG
        .append("rect")
        .attr("x", 10)
        .attr("y", 120)
        .attr("width", 30)
        .attr("height", 8)
        .attr("stroke", "#D04A02")
        .attr("fill", "#D04A02");
      newG
        .append("text")
        .attr("x", 50)
        .attr("y", 130)
        .style("font-size", 10)
        .text("Delayed");

      newG
        .append("rect")
        .attr("x", 10 + 85)
        .attr("y", 120)
        .attr("width", 30)
        .attr("height", 8)
        .attr("stroke", "#FFB600")
        .attr("fill", "#FFB600");
      newG
        .append("text")
        .attr("x", 50 + 85)
        .attr("y", 130)
        .style("font-size", 10)
        .text("Responded");

      newG
        .append("rect")
        .attr("x", 10 + 190)
        .attr("y", 120)
        .attr("width", 30)
        .attr("height", 8)
        .attr("stroke", "#FF6600")
        .attr("fill", "#FF6600");

      newG
        .append("text")
        .attr("x", 240)
        .attr("y", 130)
        .style("font-size", 10)
        .text("No Response");
    }
  }

  function completedPendingAssessmentChart() {
    let data = completedPendingAssessment.map((e, i) => {
      return { name: e.name.replace(" ", "-"), value: parseInt(e.value) };
    });
    let text = "";

    let width = 300;
    let height = 335;

    let thickness = 40;
    let duration = 750;

    let radius = Math.min(width - 100, height - 100) / 2;
    let color = d3.scaleOrdinal(d3.schemeCategory10);
    if (completedPendingResponseRef.current) {
      let tempRef = completedPendingResponseRef.current.id;
      d3.select(`#${tempRef}`).selectAll("*").remove();
      let svg = d3
        .select(`#${tempRef}`)
        .append("svg")
        .attr("class", "assesmentSummaryDonut")
        .attr("width", width)
        .attr("height", height);

      let g = svg
        .append("g")
        .attr(
          "transform",
          "translate(" +
            ((width - 100) / 2 + 50) +
            "," +
            (height - 100) / 2 +
            ")"
        );

      let arc = d3
        .arc()
        .innerRadius(radius - thickness)
        .outerRadius(radius);

      let pie = d3
        .pie()
        .value(function (d) {
          return d.value;
        })
        .sort(null);

      let path = g
        .selectAll("path")
        .data(pie(data))
        .enter()
        .append("g")
        .on("mouseover", function (event, d) {
          let g = d3
            .select(this)
            .style("cursor", "pointer")
            .append("g")
            .attr("class", "text-group");

          g.append("text")
            .attr("class", "name-text")
            .text(`${d.data.name}`)
            .attr("text-anchor", "middle")
            .attr("dy", "-1.2em");

          g.append("text")
            .attr("class", "value-text")
            .text(`${d.data.value}`)
            .attr("text-anchor", "middle")
            .attr("dy", ".6em");
        })
        .on("mouseout", function (d) {
          d3.select(this)
            .style("cursor", "none")
            .style("fill", color(this._current))
            .select(".text-group")
            .remove();
        })
        .on("click", function (event, d) {
          if (d?.data?.name === "Completed") {
            getCompletedAssessmentDataDrilldown();
            setCompletedAssessmentModal(true);
          } else if (d?.data?.name === "Pending") {
            getPendingAssessmentDataDrilldown();
            setPendingAssessmentModal(true);
          }
        })
        .append("path")
        .attr("d", arc)
        .attr("fill", (d, i) => {
          if (d.data.name === "Completed") {
            return "#175d2d";
          } else if (d.data.name === "Pending") {
            return "#e0301e";
          }
          color(i);
        });

      g.append("text")
        .attr("text-anchor", "middle")
        .attr("dy", ".35em")
        .text(text);

      //transform="translate(100,110)"
      let newG = svg.append("g").attr("transform", "translate(0, 120)");

      newG
        .append("rect")
        .attr("x", 65)
        .attr("y", 120)
        .attr("width", 30)
        .attr("height", 8)
        .attr("stroke", "#175d2d")
        .attr("fill", "#175d2d");
      newG
        .append("text")
        .attr("x", 102)
        .attr("y", 128)
        .style("font-size", 10)
        .text("Completed");

      newG
        .append("rect")
        .attr("x", 10 + 190)
        .attr("y", 120)
        .attr("width", 30)
        .attr("height", 8)
        .attr("stroke", "#e0301e")
        .attr("fill", "#e0301e");

      newG
        .append("text")
        .attr("x", 240)
        .attr("y", 128)
        .style("font-size", 10)
        .text("Pending");
    }
  }

  function assessmentSummaryChart() {
    let data = assessmentSummary;
    let totalCount = 0;
    assessmentSummary.map((item) => {
      totalCount = totalCount + parseInt(item.count);
    });

    let width = 500;
    let height = 275;

    let thickness = 40;
    let duration = 750;

    let radius = Math.min(width - 100, height - 100) / 2;
    let color = d3.scaleOrdinal(d3.schemeCategory10);
    if (assessmentSummaryDashboard.current) {
      let tempRef = assessmentSummaryDashboard.current.id;
      d3.select(`#${tempRef}`).selectAll("*").remove();
      let svg = d3
        .select(`#${tempRef}`)
        .append("svg")
        .attr("class", "assesmentSummaryDonut")
        .attr("width", width)
        .attr("height", height);

      svg
        .append("text")
        .attr("class", "value-text")
        .attr("text-anchor", "middle")
        .text(totalCount);

      let g = svg
        .append("g")
        .attr(
          "transform",
          "translate(" +
            ((width - 100) / 2 + 50) +
            "," +
            (height - 100) / 2 +
            ")"
        );

      g.append("text")
        .attr("class", "value-text")
        .attr("text-anchor", "middle")
        .text(`${totalCount}`)
        .attr("dy", "0.3em");

      let arc = d3
        .arc()
        .innerRadius(radius - thickness)
        .outerRadius(radius);

      let pie = d3
        .pie()
        .padAngle(0.02)
        .value(function (d) {
          return d.count;
        })
        .sort(null);

      let div = d3
        .select("body")
        .append("div")
        .attr("class", "vendorAssessmentTooltip")
        .style("opacity", 0);

      let path = g
        .selectAll("path")
        .data(pie(data))
        .enter()
        .append("g")
        .on("mouseover", function (event, d) {
          let g = d3
            .select(this)
            .style("cursor", "pointer")
            .append("g")
            .attr("class", "text-group");

          div
            .style("opacity", 1)
            .style("left", event.pageX + "px")
            .style("top", event.pageY - 30 + "px")
            .style("display", "inline-block")
            .style("font-size", "12px")  
            .html(
              `<span>Total: <b>${
                d.data.count
              }</b></span><br>% of total: <b>(${Math.round(
                (d.data.count / totalCount) * 100
              )}%)</b>`
            );
        })
        .on("mouseout", function (d) {
          d3.select(this)
            .style("cursor", "none")
            .style("fill", color(this._current))
            .select(".text-group")
            .remove();
          div.style("opacity", 0);
          div.style("display", "none");
        })
        .on("click", function (event, d) {
          getAssessmentSummaryDrill(d.data.name);
          setAssessmentSummaryModal(true);
        })
        .append("path")
        .attr("d", arc)
        .attr("fill", (d, i) => {
          if (d.data.name === "Not started") {
            return "#657DFF";
          } else if (d.data.name === "Assessment Completed") {
            return "#3DD5B0";
          } else if (d.data.name === "Over due") {
            return "#D04A02";
          } else if (d.data.name === "In Progress - Third Party") {
            return "#FFB600";
          } else if (d.data.name === "In Progress - TPRM Team") {
            return "#299D8F";
          } else if (d.data.name === "Sent Back to Third Party") {
            return "#B579CE";
          } else if (d.data.name === "Closed") {
            return "#22992E";
          } else if (d.data.name === "Open Issue") {
            return "#EB8C00";
          } else if (d.data.name === "Reminder 1") {
            return "#7D7D7D";
          } else if (d.data.name === "Reminder 2") {
            return "#295477";
          }
          color(i);
        });

      let path1 = g
        .selectAll("path1")
        .data(pie(data))
        .enter()
        .append("g")
        .append("text")
        .text(function (d) {
          return d.data.count != 0 ? d.data.count : "";
        })
        .attr("transform", function (d) {
          return "translate(" + arc.centroid(d) + ")";
        });

      //transform="translate(100,110)"
      let newG = svg.append("g").attr("transform", "translate(0, 120)");

      newG
        .append("rect")
        .attr("x", 75)
        .attr("y", 80)
        .attr("width", 10)
        .attr("height", 10)
        .attr("stroke", "#657DFF")
        .attr("fill", "#657DFF");
      newG
        .append("text")
        .attr("class", "value-text-label-legends")
        .attr("x", 90)
        .attr("y", 88)
        .style("font-size", 10)
        .text("Not started");

      newG
        .append("rect")
        .attr("x", 150)
        .attr("y", 80)
        .attr("width", 10)
        .attr("height", 10)
        .attr("stroke", "#3DD5B0")
        .attr("fill", "#3DD5B0");

      newG
        .append("text")
        .attr("class", "value-text-label-legends")
        .attr("x", 165)
        .attr("y", 88)
        .style("font-size", 10)
        .text("Assessment Completed");

      newG
        .append("rect")
        .attr("x", 280)
        .attr("y", 80)
        .attr("width", 10)
        .attr("height", 10)
        .attr("stroke", "#D04A02")
        .attr("fill", "#D04A02");

      newG
        .append("text")
        .attr("class", "value-text-label-legends")
        .attr("x", 295)
        .attr("y", 88)
        .style("font-size", 10)
        .text("Over due");

        newG
        .append("rect")
        .attr("x", 350)
        .attr("y", 80)
        .attr("width", 10)
        .attr("height", 10)
        .attr("stroke", "#7D7D7D")
        .attr("fill", "#7D7D7D");

      newG
        .append("text")
        .attr("class", "value-text-label-legends")
        .attr("x", 365)
        .attr("y", 88)
        .style("font-size", 10)
        .text("Reminder 1");

      newG
        .append("rect")
        .attr("x", 75)
        .attr("y", 95)
        .attr("width", 10)
        .attr("height", 10)
        .attr("stroke", "#EB8C00")
        .attr("fill", "#EB8C00");

      newG
        .append("text")
        .attr("class", "value-text-label-legends")
        .attr("x", 90)
        .attr("y", 103)
        .style("font-size", 10)
        .text("Open Issue");

      newG
        .append("rect")
        .attr("x", 150)
        .attr("y", 95)
        .attr("width", 10)
        .attr("height", 10)
        .attr("stroke", "#FFB600")
        .attr("fill", "#FFB600");

      newG
        .append("text")
        .attr("class", "value-text-label-legends")
        .attr("x", 165)
        .attr("y", 103)
        .style("font-size", 10)
        .text("In Progress - Third Party");

      newG
        .append("rect")
        .attr("x", 280)
        .attr("y", 95)
        .attr("width", 10)
        .attr("height", 10)
        .attr("stroke", "#22992E")
        .attr("fill", "#22992E");

      newG
        .append("text")
        .attr("class", "value-text-label-legends")
        .attr("x", 295)
        .attr("y", 103)
        .style("font-size", 10)
        .text("Closed");

        newG
        .append("rect")
        .attr("x", 350)
        .attr("y", 95)
        .attr("width", 10)
        .attr("height", 10)
        .attr("stroke", "#295477")
        .attr("fill", "#295477");

      newG
        .append("text")
        .attr("class", "value-text-label-legends")
        .attr("x", 365)
        .attr("y", 103)
        .style("font-size", 10)
        .text("Reminder 2");

      newG
        .append("rect")
        .attr("x", 75)
        .attr("y", 110)
        .attr("width", 10)
        .attr("height", 10)
        .attr("stroke", "#B579CE")
        .attr("fill", "#B579CE");

      newG
        .append("text")
        .attr("class", "value-text-label-legends")
        .attr("x", 90)
        .attr("y", 118)
        .style("font-size", 10)
        .text("Sent Back to Third Party");

      newG
        .append("rect")
        .attr("x", 280)
        .attr("y", 110)
        .attr("width", 10)
        .attr("height", 10)
        .attr("stroke", "#299D8F")
        .attr("fill", "#299D8F");

      newG
        .append("text")
        .attr("class", "value-text-label-legends")
        .attr("x", 295)
        .attr("y", 118)
        .style("font-size", 10)
        .text("In Progress - TPRM Team");
    }
  }
  
   //Issues by priority chart
   function riskOverviewChart() {    
    let data = riskOverview.map((e) => {    
      return { name: e.name, value: parseInt(e.count) ,label:parseInt(e.count)};    
    });    
    const data1 = riskOverview.reduce((acc, val) => {  
      return acc + parseInt(val.count);  
    }, 0); // Text to be displayed in the middle  
      
    let text = data1;  
    let width = 300;    
    let height = 335;    
      
    let thickness = 40;    
    let duration = 750;    
      
    let radius = Math.min(width - 100, height - 100) / 2;    
    let color = d3.scaleOrdinal(d3.schemeCategory10);    
      
    if (riskOverviewAssesmentOutcome.current) {    
      let tempRef = riskOverviewAssesmentOutcome.current.id;    
      d3.select(`#${tempRef}`).selectAll("*").remove();    
      let svg = d3    
        .select(`#${tempRef}`)    
        .append("svg")    
        .attr("class", "assesmentSummaryDonut")    
        .attr("width", width)    
        .attr("height", height);    
        
      let g = svg    
        .append("g")    
        .attr(    
          "transform",    
          "translate(" +    
            ((width - 100) / 2 + 50) +    
            "," +    
            (height - 100) / 2 +    
            ")"    
        );    
        
      var arc = d3    
        .arc()    
        .innerRadius(radius - thickness)    
        .outerRadius(radius);    
        
      var pie = d3    
        .pie()
        .padAngle(0.02)    
        .value(function (d) {    
          return d.value;    
        })    
        .startAngle(1.1 * Math.PI)    
        .endAngle(3.1 * Math.PI)    
        .sort(null);    
        
      var path = g    
        .selectAll("path")    
        .data(pie(data))    
        .enter()    
        .append("g")    
        .on("mouseover", function (event, d) {    
          let g = d3    
            .select(this)    
            .style("cursor", "pointer")    
            .append("g")    
            .attr("class", "text-group");    
        
          // g.append("text")    
          //   .attr("class", "name-text")    
          //   .text(`${d.data.name}`)    
          //   .attr("text-anchor", "middle")    
          //   .attr("dy", "-1.2em");    
        
          // g.append("text")    
          //   .attr("class", "value-text")    
          //   .text(`${d.data.value}`)    
          //   .attr("text-anchor", "middle")    
          //   .attr("dy", ".6em");    
        })    
        .on("mouseout", function (event, d) {    
          d3.select(this)    
            .style("cursor", "none")    
            .style("fill", color(this._current))    
            .select(".text-group")    
            .remove();    
        })    
        .on("click", function (event, d) {    
          if (d.data.name == "Need Improvement") {    
            getAssessmentbyRatingDrillDownAPI("High");    
          } else if (d.data.name == "Fairly Satisfactory") {    
            getAssessmentbyRatingDrillDownAPI("Medium");    
          } else if (d.data.name == "Satisfactory") {    
            getAssessmentbyRatingDrillDownAPI("Low");    
          }       
          setIssueRatingModal(true);    
        })    
        .append("path")    
        .attr("d", arc)    
        .attr("fill", (d, i) => {
          if (d.data.name === "Need Improvement") {    
            return "#FFB600";    
          } else if (d.data.name === "Fairly Satisfactory") {    
            return "#d04a02";    
          }  else if (d.data.name === "Satisfactory") {    
            return "#EB8C00";    
          }    
          return color(i); // Fixed: Add 'return'    
        });    
        
      // Add labels    
      g.selectAll("text")    
        .data(pie(data))    
        .enter()    
        .append("text")    
        .attr("transform", function (d) {    
          return "translate(" + arc.centroid(d) + ")";    
        })    
        .attr("dy", ".35em")    
        .attr("text-anchor", "middle")    
        .attr("fill", "#fff") // Set label color to white    
        .text(function (d) {    
          return d.data.label; // Changed to 'label' to show the segment labels  
        });    
        
      // Add middle text    
      g.append("text")    
        .attr("text-anchor", "middle")    
        .attr("dy", ".35em")    
        .attr("class", "middle-text")    
        .style("font-size", "20px")    
        .style("fill", "#333")    
        .text(text);    
        
      // Add title above the chart  
        
    
      let newG = svg.append("g").attr("transform", "translate(0, 120)");    

      newG    
      .append("rect")    
      .attr("x", 10)    
      .attr("y", 124)    
      .attr("width", 10)    
      .attr("height", 8)    
      .attr("stroke", "#d04a02")    
      .attr("fill", "#d04a02");    
    newG    
      .append("text")    
      .attr("x", 25)    
      .attr("y", 133)    
      .style("font-size", 10)    
      .text("Fairly Satisfactory"); 

      newG    
        .append("rect")    
        .attr("x", 121)    
        .attr("y", 124)    
        .attr("width", 10)    
        .attr("height", 8)    
        .attr("stroke", "#FFB600")    
        .attr("fill", "#FFB600");    
      newG    
        .append("text")    
        .attr("x", 134)    
        .attr("y", 133)    
        .style("font-size", 10)    
        .text("Need Improvement");    
        
     
        
        newG    
        .append("rect")    
        .attr("x", 231)    
        .attr("y", 124)    
        .attr("width", 10)    
        .attr("height", 8)    
        .attr("stroke", "#EB8C00")    
        .attr("fill", "#EB8C00");    
      newG    
        .append("text")    
        .attr("x", 244)    
        .attr("y", 133)    
        .style("font-size", 10)    
        .text("Satisfactory");  
    }    
  }    

  function assessmentSummaryByCategoryChart() {
    if(assessmentSummaryByCategory.length > 0){
    let data4 = assessmentSummaryByCategory

    const margin = { top: 10, right: 100, bottom: 60, left: 120 },    
        width = 404 - margin.left - margin.right,    
        height = 270 - margin.top - margin.bottom;    
    
    if (assessmentSummaryByCategoryRef.current) {
      let tempRef = assessmentSummaryByCategoryRef.current.id;
      d3.select(`#${tempRef}`).selectAll("*").remove();
      const svg = d3
        .select(`#${tempRef}`)
        .append("svg")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
        .append("g")
        .attr("transform", `translate(${margin.left}, ${margin.top})`);

      const status = Object.keys(data4[0]).filter((d) => d != "categoryName");
      const category = data4.map((d) => d.categoryName);

      const stackedData = d3.stack().keys(status)(data4);

      let maxVal = Math.ceil(d3.max(stackedData[stackedData.length - 1], d => d[1]));      
      if (maxVal < 4 && maxVal >= 1) {      
          maxVal = 4;      
      } else if (maxVal <= 5) {      
          maxVal = 5;      
      } else {      
          maxVal += 5;      
      }  
      const x = d3.scaleLinear().domain([0, maxVal]).range([0, width]);

      const tickValues = d3.range(0, maxVal + 1, 1);    
        const xAxis = d3.axisBottom(x)    
            .tickValues(tickValues)    
            .tickFormat(d3.format("d"));  

      const y = d3
        .scaleBand()
        .domain(category)
        .range([0, width])
        .padding([0.5]);
      
      const subgroups = ['Assessment Completed', 'Over due', 'Sent Back to Third Party', 'Reminder 1', 'Reminder 2', 'Not started', 'In Progress - Third Party', 'In Progress - TPRM Team', 'Open Issue', 'Closed']

      let color = d3.scaleOrdinal(d3.schemeCategory10).domain(subgroups)      
        .range([      
          "#3DD5B0", "#D04A02", "#B579CE", "#7D7D7D", "#295477",      
          "#657DFF", "#FFB600", "#299D8F", "#EB8C00", "#22992E"     
        ]);;
      const yAxis = d3.axisLeft(y);

      let hoverTooltip = d3.select("body").append("div")      
      .attr("class", "vendorAssessmentTooltip")      
      .style("opacity", 0);      

      let div = d3.select("body").append("div")      
      .attr("class", "xaxisTooltip")      
      .style("opacity", 0); 

      svg
        .append("g")
        .attr("transform", `translate(0, ${height - 15})`)
        .call(xAxis)
        .selectAll("text")
        .style("font-size", 10)
        .call((g) => g.select(".domain").remove());

      svg
        .append("g")
        .selectAll("g")
        .data(stackedData)
        .enter()
        .append("g")
        .attr("fill", (d) => color(d.key))    
        .selectAll("rect")
        .data((d) => d)
        .enter()
        .append("rect")
        .attr("x", (d) => x(d[0]))
        .attr("y", (d) => y(d.data.categoryName))
        .attr("height", y.bandwidth())
        .attr("width", (d) => x(d[1]) - x(d[0]))
        .on("mousemove", function (event, d) {      
          const key = d3.select(this.parentNode).datum().key;      
          const formattedKey = key.charAt(0).toUpperCase() + key.slice(1).toLowerCase();      
          hoverTooltip.style("opacity", 1)      
                      .style("left", event.pageX + "px")      
                      .style("top", event.pageY - 30 + "px")      
                      .style("display", "inline-block") 
                      .style("font-size", "12px")     
                      .html(`<span>Status: ${formattedKey} <br> Value: ${d[1] - d[0]}</span>`);      
        })      
        .on("mouseout", function (n) {      
          hoverTooltip.style("opacity", 0);      
          hoverTooltip.style("display", "none");      
        })      
        .on("click", function (event, d) {  
          getAssessmentSummaryByCategoryDrilldownModal(d?.data?.categoryName);
          setAssessmentSummaryByCategoryModal(true);
        });  

        svg
        .append("g")
        .call(yAxis.tickFormat(
          (d) => (d?.length > 12 ? d?.substring(0, 12) + "..." : d))       
          .tickPadding(8))
        .style("text-anchor", "end")
        .style("font-size", 10)
        .call((g) => g.select(".domain").remove())
       .selectAll("text")           
       .style("font-size", 10) 
           
       .on("mousemove", function (event, d) {      
         div.style("opacity", 1)      
            .style("left", event.pageX + "px")      
            .style("top", event.pageY - 30 + "px")      
            .style("display", "inline-block") 
            .style("font-size", "12px")     
     
            .html(`<span>${d}</span>`);      
       })      
       .on("mouseout", function (n) {      
         div.style("opacity", 0);      
         div.style("display", "none");      
       });

       svg.append("g")  
        .attr("class", "grid")  
        .selectAll("line")  
        .data(tickValues)  
        .enter()  
        .append("line")  
        .attr("x1", d => x(d))  
        .attr("x2", d => x(d))  
        .attr("y1", 0)  
        .attr("y2", height - 15)  
        .style("stroke", "#000")  
        .style("stroke-width", "0.5px");

        svg.append("text")      
       .attr("transform", `translate(${width / 2}, ${height + margin.bottom -30})`)      
       .style("text-anchor", "middle")      
       .style("font-size", "10px")      
       .text("Assessment Count");  
       
       svg.append("text")      
       .attr("transform", "rotate(-90)")      
       .attr("y", -98)      
       .attr("x", 0 - (height / 2))      
       .attr("dy", "1em")      
       .style("text-anchor", "middle")      
       .style("font-size", "10px")      
       .text("Categories");  
        
    const legendRectSize = 10;      
    const legendSpacing = 4;      
    const legendOffsetX = width +  15; // Start legend after the chart width with some padding      
    const legendOffsetY = 25; // Start legend from the top with some padding      
      
    const legend = svg.selectAll('.legend')      
        .data(subgroups)      
        .enter()      
        .append('g')      
        .attr('class', 'legend')      
        .attr('transform', (d, i) => {      
            const yOffset = legendOffsetY + i * 20;      
            return `translate(${legendOffsetX}, ${yOffset})`;      
        });      
      
    legend.append('rect')      
        .attr('width', legendRectSize)      
        .attr('height', legendRectSize)      
        .style('fill', color)      
        .style('stroke', color);      
      
    legend.append('text')      
        .attr('x', legendRectSize + legendSpacing)      
        .attr('y', legendRectSize - legendSpacing)      
        .style("font-size", "10px")      
        .text(d => d.length > 7 ? d.substring(0, 7) + "..." : d)      
        .on("mousemove", function (event, d) {      
            div.style("opacity", 1)      
               .style("left", event.pageX + "px")      
               .style("top", event.pageY - 30 + "px")      
               .style("display", "inline-block")   
               .style("font-size", "12px")      
   
               .html(`<span>${d}</span>`);      
        })      
        .on("mouseout", function () {      
            div.style("opacity", 0);      
            div.style("display", "none");      
        }); 
      
    }
  }
  }

  function assessmentSummaryByCriticality() {
    if(assessmentSummaryCriticality.length > 0){
      let data4 = assessmentSummaryCriticality;
  
      const margin = { top: 40, right: 0, bottom: 60, left: 100 },      
            width = 260 - margin.left - margin.right,      
            height = 280 - margin.top - margin.bottom
      if (assessmentSummaryCriticalityRef.current) {
        let tempRef = assessmentSummaryCriticalityRef.current.id;
        d3.select(`#${tempRef}`).selectAll("*").remove();
        const svg = d3
          .select(`#${tempRef}`)
          .append("svg")
          .attr("width", 354)
          .attr("height", height + margin.top + margin.bottom)
          .append("g")
          .attr("transform", `translate(${margin.left}, ${margin.top})`);
          const subgroups = ["Tier 1", "Tier 2", "Tier 3"];

          const tierData = Object.keys(data4[0]).filter((d) => d != "status");
          const statusName = data4.map((d) => d.status);
  
          const stackedData = d3.stack().keys(tierData)(data4);
  
        let maxVal = Math.ceil(d3.max(stackedData[stackedData.length - 1], d => d[1]));      
        if (maxVal < 4 && maxVal >= 1) {      
            maxVal = 4;      
        } else if (maxVal <= 5) {      
            maxVal = 5;      
        } else {      
            maxVal += 5;      
        }  
        const x = d3.scaleLinear().domain([0, maxVal]).range([0, width]);
  
        const tickValues = d3.range(0, maxVal + 1, 1);    
          const xAxis = d3.axisBottom(x)    
              .tickValues(tickValues)    
              .tickFormat(d3.format("d"));  
  
        const y = d3
          .scaleBand()
          .domain(statusName)
          .range([0, width])
          .padding([0.5]);
  
        let color = d3.scaleOrdinal(d3.schemeCategory10).domain(subgroups)      
          .range([      
            "#e0301e", "#FFB600", "#eb8c00"     
          ]);;
  
        const yAxis = d3.axisLeft(y);
  
        let hoverTooltip = d3.select("body").append("div")      
        .attr("class", "vendorAssessmentTooltip")      
        .style("opacity", 0);      
  
        let div = d3.select("body").append("div")      
        .attr("class", "xaxisTooltip")      
        .style("opacity", 0); 
  
        svg
          .append("g")
          .attr("transform", `translate(0, ${height - 15})`)
          .call(xAxis)
          .selectAll("text")
          .style("font-size", 10)
          .call((g) => g.select(".domain").remove());
  
        svg
          .append("g")
          .selectAll("g")
          .data(stackedData)
          .enter()
          .append("g")
          .attr("fill", (d) => color(d.key))    
          .selectAll("rect")
          .data((d) => d)
          .enter()
          .append("rect")
          .attr("x", (d) => x(d[0]))
          .attr("y", (d) => y(d.data.status))
          .attr("height", y.bandwidth())
          .attr("width", (d) => x(d[1]) - x(d[0]))
          .on("mousemove", function (event, d) {      
            const key = d3.select(this.parentNode).datum().key;      
            const formattedKey = key.charAt(0).toUpperCase() + key.slice(1).toLowerCase();      
            hoverTooltip.style("opacity", 1)      
                        .style("left", event.pageX + "px")      
                        .style("top", event.pageY - 30 + "px")      
                        .style("display", "inline-block") 
                        .style("font-size", "12px")     
                        .html(`<span>Criticality: ${formattedKey} <br> Value: ${d[1] - d[0]}</span>`);      
          })      
          .on("mouseout", function (n) {      
            hoverTooltip.style("opacity", 0);      
            hoverTooltip.style("display", "none");      
          })      
          .on("click", function (event, d) {  
            getAssessmentSummaryCriticalityDrill(d?.data?.status);
            setAssessmentCriticalityModal(true);
          });  
  
          svg
          .append("g")
          .call(yAxis.tickFormat(
            (d) => (d?.length > 10 ? d?.substring(0, 10) + "..." : d))       
            .tickPadding(8))
          .style("text-anchor", "end")
          .style("font-size", 12)
          .call((g) => g.select(".domain").remove())
         .selectAll("text")           
         .style("font-size", 10) 
             
         .on("mousemove", function (event, d) {      
           div.style("opacity", 1)      
              .style("left", event.pageX + "px")      
              .style("top", event.pageY - 30 + "px")      
              .style("display", "inline-block") 
              .style("font-size", "12px")     
       
              .html(`<span>${d}</span>`);      
         })      
         .on("mouseout", function (n) {      
           div.style("opacity", 0);      
           div.style("display", "none");      
         });
  
         svg.append("g")  
          .attr("class", "grid")  
          .selectAll("line")  
          .data(tickValues)  
          .enter()  
          .append("line")  
          .attr("x1", d => x(d))  
          .attr("x2", d => x(d))  
          .attr("y1", 0)  
          .attr("y2", height - 15)  
          .style("stroke", "#000")  
          .style("stroke-width", "0.5px");
  
          svg.append("text")      
         .attr("transform", `translate(${width / 2}, ${height + margin.bottom -30})`)      
         .style("text-anchor", "middle")      
         .style("font-size", "10px")      
         .text("Assessment Count");  
         
         svg.append("text")      
         .attr("transform", "rotate(-90)")      
         .attr("y", -90)      
         .attr("x", 0 - (height / 2))      
         .attr("dy", "1em")      
         .style("text-anchor", "middle")      
         .style("font-size", "10px")      
         .text("Assessment Status");  
          
      const legendRectSize = 10;      
      const legendSpacing = 4;      
      const legendOffsetX = width +  30; // Start legend after the chart width with some padding      
      const legendOffsetY = 5; // Start legend from the top with some padding      
        
      const legend = svg.selectAll('.legend')      
          .data(subgroups)      
          .enter()      
          .append('g')      
          .attr('class', 'legend')      
          .attr('transform', (d, i) => {      
              const yOffset = legendOffsetY + i * 20;      
              return `translate(${legendOffsetX}, ${yOffset})`;      
          });      
        
      legend.append('rect')      
          .attr('width', legendRectSize)      
          .attr('height', legendRectSize)      
          .style('fill', color)      
          .style('stroke', color);      
        
      legend.append('text')      
          .attr('x', legendRectSize + legendSpacing)      
          .attr('y', legendRectSize - legendSpacing)      
          .style("font-size", "10px")      
          .text(d => d.length > 12 ? d.substring(0, 12) + "..." : d)
      }
    }
  }

  function criticalityPerCategoryChart() {
    if(criticalityPerCategory.length > 0){
      let data4 = criticalityPerCategory
  
      const margin = { top: 10, right: 100, bottom: 60, left: 120 },    
      width = 404 - margin.left - margin.right,    
      height = 270 - margin.top - margin.bottom; 
      if (criticalityPerCategoryRef.current) {
        let tempRef = criticalityPerCategoryRef.current.id;
        d3.select(`#${tempRef}`).selectAll("*").remove();
        const svg = d3
          .select(`#${tempRef}`)
          .append("svg")
          .attr("width", width + margin.left + margin.right)
          .attr("height", height + margin.top + margin.bottom)
          .append("g")
          .attr("transform", `translate(${margin.left}, ${margin.top})`);
  
        const status = Object.keys(data4[0]).filter((d) => d != "categoryName");
        const category = data4.map((d) => d.categoryName);
  
        const stackedData = d3.stack().keys(status)(data4);
  
        let maxVal = Math.ceil(d3.max(stackedData[stackedData.length - 1], d => d[1]));      
        if (maxVal < 4 && maxVal >= 1) {      
            maxVal = 4;      
        } else if (maxVal <= 5) {      
            maxVal = 5;      
        } else {      
            maxVal += 5;      
        }  
        const x = d3.scaleLinear().domain([0, maxVal]).range([0, width]);
  
        const tickValues = d3.range(0, maxVal + 1, 1);    
          const xAxis = d3.axisBottom(x)    
              .tickValues(tickValues)    
              .tickFormat(d3.format("d"));  
  
        const y = d3
          .scaleBand()
          .domain(category)
          .range([0, width])
          .padding([0.5]);
        
        const subgroups = Object.keys(data4[0]).slice(1)
  
        let color = d3.scaleOrdinal(d3.schemeCategory10).domain(subgroups)      
          .range(["#e0301e", "#FFB600", "#eb8c00"]);
  
        const yAxis = d3.axisLeft(y);
  
        let hoverTooltip = d3.select("body").append("div")      
        .attr("class", "vendorAssessmentTooltip")      
        .style("opacity", 0);      
  
        let div = d3.select("body").append("div")      
        .attr("class", "xaxisTooltip")      
        .style("opacity", 0); 
  
        svg
          .append("g")
          .attr("transform", `translate(0, ${height - 15})`)
          .call(xAxis)
          .selectAll("text")
          .style("font-size", 10)
          .call((g) => g.select(".domain").remove());
  
        svg
          .append("g")
          .selectAll("g")
          .data(stackedData)
          .enter()
          .append("g")
          .attr("fill", (d) => color(d.key))    
          .selectAll("rect")
          .data((d) => d)
          .enter()
          .append("rect")
          .attr("x", (d) => x(d[0]))
          .attr("y", (d) => y(d.data.categoryName))
          .attr("height", y.bandwidth())
          .attr("width", (d) => x(d[1]) - x(d[0]))
          .on("mousemove", function (event, d) {      
            const key = d3.select(this.parentNode).datum().key;      
            const formattedKey = key.charAt(0).toUpperCase() + key.slice(1).toLowerCase();      
            hoverTooltip.style("opacity", 1)      
                        .style("left", event.pageX + "px")      
                        .style("top", event.pageY - 30 + "px")      
                        .style("display", "inline-block") 
                        .style("font-size", "12px")     
                        .html(`<span>Criticality: ${formattedKey} <br> Value: ${d[1] - d[0]}</span>`);      
          })      
          .on("mouseout", function (n) {      
            hoverTooltip.style("opacity", 0);      
            hoverTooltip.style("display", "none");      
          })      
          .on("click", function (event, d) {  
            getCriticalityPerCategoryDataModal(d?.data?.categoryName);
            setCategoryByCriticalityModal(true);
          });  
  
          svg
          .append("g")
          .call(yAxis.tickFormat(
            (d) => (d?.length > 12 ? d?.substring(0, 12) + "..." : d))       
            .tickPadding(8))
          .style("text-anchor", "end")
          .style("font-size", 12)
          .call((g) => g.select(".domain").remove())
         .selectAll("text")           
         .style("font-size", 10) 
             
         .on("mousemove", function (event, d) {      
           div.style("opacity", 1)      
              .style("left", event.pageX + "px")      
              .style("top", event.pageY - 30 + "px")      
              .style("display", "inline-block") 
              .style("font-size", "12px")     
       
              .html(`<span>${d}</span>`);      
         })      
         .on("mouseout", function (n) {      
           div.style("opacity", 0);      
           div.style("display", "none");      
         });
  
         svg.append("g")  
          .attr("class", "grid")  
          .selectAll("line")  
          .data(tickValues)  
          .enter()  
          .append("line")  
          .attr("x1", d => x(d))  
          .attr("x2", d => x(d))  
          .attr("y1", 0)  
          .attr("y2", height - 15)  
          .style("stroke", "#000")  
          .style("stroke-width", "0.5px");
  
          svg.append("text")      
         .attr("transform", `translate(${width / 2}, ${height + margin.bottom -30})`)      
         .style("text-anchor", "middle")      
         .style("font-size", "10px")      
         .text("Assessment Count");  
         
         svg.append("text")      
         .attr("transform", "rotate(-90)")      
         .attr("y", -98)      
         .attr("x", 0 - (height / 2))      
         .attr("dy", "1em")      
         .style("text-anchor", "middle")      
         .style("font-size", "10px")      
         .text("Categories");  
          
      const legendRectSize = 10;      
      const legendSpacing = 4;      
      const legendOffsetX = width +  15; // Start legend after the chart width with some padding      
      const legendOffsetY = 25; // Start legend from the top with some padding      
        
      const legend = svg.selectAll('.legend')      
          .data(subgroups)      
          .enter()      
          .append('g')      
          .attr('class', 'legend')      
          .attr('transform', (d, i) => {      
              const yOffset = legendOffsetY + i * 20;      
              return `translate(${legendOffsetX}, ${yOffset})`;      
          });      
        
      legend.append('rect')      
          .attr('width', legendRectSize)      
          .attr('height', legendRectSize)      
          .style('fill', color)      
          .style('stroke', color);      
        
      legend.append('text')      
          .attr('x', legendRectSize + legendSpacing)      
          .attr('y', legendRectSize - legendSpacing)      
          .style("font-size", "10px")      
          .text(d => d.length > 7 ? d.substring(0, 7) + "..." : d)
      }
    }
  
  }

  function riskOverviewCategoryChart() {    
    let data4 = riskOverviewCategory; // Ensure this is an array of objects with consistent keys    
    const margin = { top: 10, right: 100, bottom: 60, left: 120 },    
        width = 404 - margin.left - margin.right,    
        height = 270 - margin.top - margin.bottom;    
     
    
    if (riskOverviewCategoryRef.current) {    
        let tempRef = riskOverviewCategoryRef.current.id;    
        d3.select(`#${tempRef}`).selectAll("*").remove();    
        const svg = d3    
            .select(`#${tempRef}`)    
            .append("svg")    
            .attr("width", width + margin.left + margin.right)    
            .attr("height", height + margin.top + margin.bottom)    
            .append("g")    
            .attr("transform", `translate(${margin.left}, ${margin.top})`);    
    
        const status = Object.keys(data4[0]).filter((d) => d != "daysBracket");    
        const category = data4.map((d) => d.daysBracket);    
    
        const groups = data4.map(d => d?.daysBracket); 
        
        const subgroups = [      
          "IT Services Provider", "Manpower Services Provider", "Manufacturing Equipment Supplier",      
          "Parts and Ancillaries Supplier", "Dealer PV", "Others", "Dealer CV",      
          "Supplier CV", "Supplier PV", "DPDS service provider", "Connected Vehicle Vendors"      
        ];   
        const stack = d3.stack().keys(subgroups);      
        const stackedData = stack(data4);   
    
        // const stackedData = d3.stack().keys(status)(data4);    
    
        // Log the stacked data to inspect its structure    
    
        // Ensure stacked data is properly generated    
        if (!stackedData || !stackedData.length) {    
            console.error("Stacked data generated incorrectly:", stackedData);    
            return;    
        }    
    
        // Calculate xmax by iterating over all layers and all values    
        const xmax = d3.max(stackedData, layer => d3.max(layer, seq => seq[1]));    
    
        const x = d3.scaleLinear().domain([0, xmax]).nice().range([0, width]);    
    
        const y = d3    
            .scaleBand()    
            .domain(category)    
            .range([0, height])    
            .padding(0.25);    
    
        // const colorMapping = {  
        //   "IT Service Provider": "#D04A02",    
  
        //     "Parts and Ancillaries Supplier": "#7D7D7D",    
        //     "Dealer CV": "#299D8F",    
        //     "Manpower Service Provider": "#EB8C00",    
        //     "Deader PV": "#DEDEDE",    
        //     "Manufacturing Equipment Provider": "#FFB600",    
        //     "Super CV": "#4577C9",    
        //     "Others": "#295477",    
        //     "Supplier PV": "#00C6F7",    
        //     "DPDS service provider": "#D93954",    
        //     "Connected Vehicle Vendors": "#657DFF",    
        //     "Manufacturing Equipment Supplier": "#F18085"    
        // };    
    
        // // Define a fallback color scale    
        // const color = d3.scaleOrdinal(d3.schemeCategory10); 
        // const subgroups = Object.keys(data4[0]).slice(1);  
         
          
        // Ensure all subgroups have values in the data      
        data4 = data4.map(d => {      
            subgroups.forEach(subgroup => {      
                if (d[subgroup] === undefined) {      
                    d[subgroup] = '';      
                }      
            });      
            return d;      
        });      
          
         
        const color = d3.scaleOrdinal()      
                    .domain(subgroups)      
                    .range([      
                      "#D04A02", "#EB8C00", "#FFB600", "#7D7D7D", "#DEDEDE",      
                      "#295477", "#299D8F", "#4577C9", "#00C6F7", "#D93954", "#657DFF"      
                    ]);      
    
        const yAxis = d3.axisLeft(y);    
        // Generate an array of tick values with a step of 1    
        const tickValues = d3.range(0, xmax + 1, 1);    
        const xAxis = d3.axisBottom(x)    
            .tickValues(tickValues)    
            .tickFormat(d3.format("d"));      
  
        let hoverTooltip = d3.select("body").append("div")    
            .attr("class", "vendorAssessmentTooltip")    
            .style("opacity", 0);    
    
        let div = d3.select("body").append("div")    
            .attr("class", "xaxisTooltip")    
            .style("opacity", 0);    
    
        svg    
            .append("g")    
            .attr("transform", `translate(0, ${height})`)    
            .call(xAxis)    
            .selectAll("text")    
            .style("font-size", 12)    
            .call((g) => g.select(".domain").remove());    
    
        svg    
            .append("g")    
            .call(yAxis.tickFormat(    
                (d) => (d?.length > 12 ? d?.substring(0, 12) + "..." : d))    
                .tickPadding(8))    
            .style("text-anchor", "end")    
            .style("font-size", 10)    
            .call((g) => g.select(".domain").remove())    
            .selectAll("text")    
            .style("font-size", 10)    
            .on("mousemove", function (event, d) {    
                div.style("opacity", 1)    
                    .style("left", event.pageX + "px")    
                    .style("top", event.pageY - 30 + "px")    
                    .style("display", "inline-block")    
                    .style("font-size", "12px")    
                    .html(`<span>${d}</span>`);    
            })    
            .on("mouseout", function (n) {    
                div.style("opacity", 0);    
                div.style("display", "none");    
            }); 
            
           // Add x-axis grid lines  
        svg.append("g")  
        .attr("class", "grid")  
        .selectAll("line")  
        .data(tickValues)  
        .enter()  
        .append("line")  
        .attr("x1", d => x(d))  
        .attr("x2", d => x(d))  
        .attr("y1", 0)  
        .attr("y2", height)  
        .style("stroke", "#000") // Dark line color  
        .style("stroke-width", "0.5px"); // Line thickness  

        svg    
            .append("g")    
            .selectAll("g")    
            .data(stackedData)    
            .enter()    
            .append("g")    
            .attr("fill", function (d) {    
                return  color(d.key);    
            })    
            .selectAll("rect")    
            .data((d) => d)    
            .enter()    
            .append("rect")    
            .attr("x", (d) => x(d[0]))    
            .attr("y", (d) => y(d.data.daysBracket))    
            .attr("height", y.bandwidth())    
            .attr("width", (d) => x(d[1]) - x(d[0]))    
            .on("mousemove", function (event, d) {    
                const key = d3.select(this.parentNode).datum().key;    
                const formattedKey = key.charAt(0).toUpperCase() + key.slice(1).toLowerCase();    
                hoverTooltip.style("opacity", 1)    
                    .style("left", event.pageX + "px")    
                    .style("top", event.pageY - 30 + "px")    
                    .style("display", "inline-block")    
                    .style("font-size", "12px")    
                    .html(`<span>Category: ${formattedKey} <br> Value: ${d[1] - d[0]}</span>`);    
            })    
            .on("mouseout", function (n) {    
                hoverTooltip.style("opacity", 0);    
                hoverTooltip.style("display", "none");    
            })    
            .on("click", function (event, d) {    
                const key = d3.select(this.parentNode).datum().key;    
                const formattedKey = key.charAt(0).toUpperCase() + key.slice(1).toLowerCase();    
                if (d.data.daysBracket == "Need Improvement") {    
                    getAssessmentbyRatingDrillDownAPI("High", formattedKey);    
                } else if (d.data.daysBracket == "Fairly Satisfactory") {    
                    getAssessmentbyRatingDrillDownAPI("Medium", formattedKey);    
                } else if (d.data.daysBracket == "Satisfactory") {    
                    getAssessmentbyRatingDrillDownAPI("Low", formattedKey);    
                }    
                setIssueRatingModal(true);    
            })  
            // .each(function (d) {  
            //    // Add text label, but only if the value is a number  
            //    const value = d[1] - d[0];  
            //    if (!isNaN(value)) {  
            //        svg.append("text")  
            //            .attr("x", x(d[1]) - (x(d[1]) - x(d[0])) / 2)  
            //            .attr("y", y(d.data.daysBracket) + y.bandwidth() / 2)  
            //            .attr("dy", "0.35em")  
            //            .style("text-anchor", "middle")  
            //            .style("fill", "black")  
            //            .style("font-size", "10px")  
            //            .text(value);  
            //    }  
            // });  
              
           // X Axis Label        
     svg.append("text")        
     .attr("transform", `translate(${width / 2}, ${height + margin.bottom - 10})`)        
     .style("text-anchor", "middle")        
     .style("font-size", "10px")        
     .text("Risk");        
      
  // Y Axis Label        
  svg.append("text")        
     .attr("transform", "rotate(-90)")        
     .attr("y", -98)        
     .attr("x", 0 - (height / 2))        
     .attr("dy", "1em")        
     .style("text-anchor", "middle")        
     .style("font-size", "10px")        
     .text("Assessment Count");  
    
        const legendRectSize = 10;
   
        const legendSpacing = 4;  
        const legendOffsetX = width + 15; // Start legend after the chart width with some padding        
        const legendOffsetY = 25; // Start legend from the top with some padding        
  
       
        const legend = svg.selectAll('.legend')  
            .data(subgroups)  
            .enter()  
            .append('g')  
            .attr('class', 'legend')  
            .attr('transform', (d, i) => {  
                const yOffset = legendOffsetY + i * 20;  
                return `translate(${legendOffsetX}, ${yOffset})`;  
            });  
  
        legend.append('rect')  
            .attr('width', legendRectSize)  
            .attr('height', legendRectSize)  
            .style('fill', d => color(d))  
            .style('stroke', d => color(d));  
  
        legend.append('text')  
            .attr('x', legendRectSize + legendSpacing)  
            .attr('y', legendRectSize - legendSpacing)  
            .style("font-size", "10px")  
            .text(d => d.length > 7 ? d.substring(0, 7) + "..." : d)  
            .on("mousemove", function (event, d) {  
                div.style("opacity", 1)  
                    .style("left", event.pageX + "px")  
                    .style("top", event.pageY - 30 + "px")  
                    .style("display", "inline-block")  
                    .style("font-size", "12px")  
                    .html(`<span>${d}</span>`);  
            })  
            .on("mouseout", function () {  
                div.style("opacity", 0);  
                div.style("display", "none");  
            });  
    }  
}  


  //Issues by priority chart
  function getIssuesByPriorityDonutChart() {
    let data = getIssuesByRatings.map((e) => {
      return { name: e.name, value: parseInt(e.value) };
    });
    let maxVal = Math.ceil(d3.max(data, (d) => d.value));
    if (maxVal < 4 && maxVal >= 1) {
      maxVal = 4;
    } else if (maxVal <= 5) {
      maxVal = 5;
    } else {
      maxVal += 5;
    }
    let margin = { top: 20, right: 40, bottom: 90, left: 40 },
      width = 404 - margin.left - margin.right,
      height = 260 - margin.top - margin.bottom;

    let x = d3.scaleBand().range([0, width]).padding(0.5);
    let y = d3.scaleLinear().range([height, 0]);

    if (issueByRatingRef.current) {
      let tempRef = issueByRatingRef.current.id;
      d3.select(`#${tempRef}`).selectAll("*").remove();
      let svg = d3
        .select(`#${tempRef}`)
        .append("svg")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
        .append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

      let div = d3
        .select("body")
        .append("div")
        .attr("class", "vendorAssessmentTooltip")
        .style("opacity", 0);

      let xAxisTooltip = d3
        .select("body")
        .append("div")
        .attr("class", "xaxisTooltip")
        .style("opacity", 0);

      x.domain(
        data.map(function (d) {
          return d.name;
        })
      );
      y.domain([0, maxVal]);

      svg
        .selectAll(".bar")
        .data(data)
        .enter()
        .append("rect")
        .attr("fill", function (d, i) {
          if (d.name === "High") {
            return "#e0301e";
          } else if (d.name === "Medium") {
            return "#FFB600";
          } else if (d.name === "Low") {
            return "#175d2d";
          }
        })
        .attr("x", function (d) {
          return x(d.name);
        })
        .attr("width", x.bandwidth())
        .attr("y", function (d) {
          return y(d.value);
        })
        .attr("height", function (d) {
          return height - y(d.value);
        })
        .on("mousemove", function (event, d) {
          div
            .style("opacity", 1)
            .style("left", event.pageX + "px")
            .style("top", event.pageY - 30 + "px")
            .style("display", "inline-block")
            .html("<span>Issues: " + d.value + "</span>");
        })
        .on("mouseout", function (n) {
          div.style("opacity", 0);
          div.style("display", "none");
        })
        .on("click", function (event, d) {
          div.style("opacity", 0);
          div.style("display", "none");
          getIssueByRatingDrilldownData(d.name);
          setIssueRatingModal(true);
        });

      svg
        .append("g")
        .attr("transform", "translate(0," + height + ")")
        .call(
          d3
            .axisBottom(x)
            .tickFormat((d) => (d.length > 15 ? d.substring(0, 15) + "..." : d))
        )
        .selectAll("text")
        .attr("transform", "translate(-5,5)rotate(-25)")
        .style("text-anchor", "end")
        .style("font-size", 16)
        .on("mousemove", function (event, d) {
          xAxisTooltip
            .style("opacity", 1)
            .style("left", event.pageX + "px")
            .style("top", event.pageY - 30 + "px")
            .style("display", "inline-block")
            .html(`<span>${d}</span>`);
        })
        .on("mouseout", function (n) {
          xAxisTooltip.style("opacity", 0);
          xAxisTooltip.style("display", "none");
        });

      svg.append("g").call(d3.axisLeft(y).ticks(4));
      svg
        .append("rect")
        .attr("x", 60)
        .attr("y", 210)
        .attr("width", 13)
        .attr("height", 13)
        .style("fill", "#e0301e");
      svg
        .append("text")
        .attr("class", "legend")
        .attr("x", 75)
        .attr("y", 220)
        .text("High");
      svg
        .append("rect")
        .attr("x", 120)
        .attr("y", 210)
        .attr("width", 13)
        .attr("height", 13)
        .style("fill", "#ffb600");
      svg
        .append("text")
        .attr("class", "legend")
        .attr("x", 135)
        .attr("y", 220)
        .text("Medium");
      svg
        .append("rect")
        .attr("x", 195)
        .attr("y", 210)
        .attr("width", 13)
        .attr("height", 13)
        .style("fill", "#175d2d");
      svg
        .append("text")
        .attr("class", "legend")
        .attr("x", 210)
        .attr("y", 220)
        .text("Low");
    }
  }

  //Issues by priority chart
  function getIssuesOpenCloseChart() {    
    let data = getIssuesCloseOpenData.map((e) => {    
      return { name: e.name, value: parseInt(e.value) ,label:parseInt(e.value)};    
    });    
    const data1 = getIssuesCloseOpenData.reduce((acc, val) => {  
      return acc + parseInt(val.value);  
    }, 0); // Text to be displayed in the middle  
      
    let text = data1;  
    let width = 300;    
    let height = 335;    
      
    let thickness = 40;    
    let duration = 750;    
      
    let radius = Math.min(width - 100, height - 100) / 2;    
    let color = d3.scaleOrdinal(d3.schemeCategory10);    
      
    if (IssuesOpenCloseRef.current) {    
      let tempRef = IssuesOpenCloseRef.current.id;    
      d3.select(`#${tempRef}`).selectAll("*").remove();    
      let svg = d3    
        .select(`#${tempRef}`)    
        .append("svg")    
        .attr("class", "assesmentSummaryDonut")    
        .attr("width", width)    
        .attr("height", height);    
        
      let g = svg    
        .append("g")    
        .attr(    
          "transform",    
          "translate(" +    
            ((width - 100) / 2 + 50) +    
            "," +    
            (height - 100) / 2 +    
            ")"    
        );    
        
      var arc = d3    
        .arc()    
        .innerRadius(radius - thickness)    
        .outerRadius(radius);    
        
      var pie = d3    
        .pie()
        .padAngle(0.02)    
        .value(function (d) {    
          return d.value;    
        })    
        .startAngle(1.1 * Math.PI)    
        .endAngle(3.1 * Math.PI)    
        .sort(null);    
        
      var path = g    
        .selectAll("path")    
        .data(pie(data))    
        .enter()    
        .append("g")    
        .on("mouseover", function (event, d) {    
          let g = d3    
            .select(this)    
            .style("cursor", "pointer")    
            .append("g")    
            .attr("class", "text-group");    
        
          // g.append("text")    
          //   .attr("class", "name-text")    
          //   .text(`${d.data.name}`)    
          //   .attr("text-anchor", "middle")    
          //   .attr("dy", "-1.2em");    
        
          // g.append("text")    
          //   .attr("class", "value-text")    
          //   .text(`${d.data.value}`)    
          //   .attr("text-anchor", "middle")    
          //   .attr("dy", ".6em");    
        })    
        .on("mouseout", function (event, d) {    
          d3.select(this)    
            .style("cursor", "none")    
            .style("fill", color(this._current))    
            .select(".text-group")    
            .remove();    
        })    
        .on("click", function (event, d) {    
          if (d.data.name == "Open") {    
            getIssuesCloseOpenApiData(1);    
          } else if (d.data.name == "Close") {    
            getIssuesCloseOpenApiData(2);    
          }    
          setGetIssuesCloseOpenModalData(true);    
        })    
        .append("path")    
        .attr("d", arc)    
        .attr("fill", (d, i) => {    
          if (d.data.name === "Open") {    
            return "#FFB600";    
          } else if (d.data.name === "Close") {    
            return "#d04a02";    
          }    
          return color(i); // Fixed: Add 'return'    
        });    
        
      // Add labels    
      g.selectAll("text")    
        .data(pie(data))    
        .enter()    
        .append("text")    
        .attr("transform", function (d) {    
          return "translate(" + arc.centroid(d) + ")";    
        })    
        .attr("dy", ".35em")    
        .attr("text-anchor", "middle")    
        .attr("fill", "#fff") // Set label color to white    
        .text(function (d) {    
          return d.data.label; // Changed to 'label' to show the segment labels  
        });    
        
      // Add middle text    
      g.append("text")    
        .attr("text-anchor", "middle")    
        .attr("dy", ".35em")    
        .attr("class", "middle-text")    
        .style("font-size", "20px")    
        .style("fill", "#333")    
        .text(text);    
        
      // Add title above the chart  
        
    
      let newG = svg.append("g").attr("transform", "translate(0, 120)");    
      newG    
        .append("rect")    
        .attr("x", 100)    
        .attr("y", 120)    
        .attr("width", 30)    
        .attr("height", 8)    
        .attr("stroke", "#FFB600")    
        .attr("fill", "#FFB600");    
      newG    
        .append("text")    
        .attr("x", 132)    
        .attr("y", 130)    
        .style("font-size", 10)    
        .text("Open");    
        
      newG    
        .append("rect")    
        .attr("x", 165)    
        .attr("y", 120)    
        .attr("width", 30)    
        .attr("height", 8)    
        .attr("stroke", "#d04a02")    
        .attr("fill", "#d04a02");    
      newG    
        .append("text")    
        .attr("x", 210)    
        .attr("y", 130)    
        .style("font-size", 10)    
        .text("Closed");    
    }    
  }    
  

  function IssueFollowUpVendorByCategory() {  
    // get the data  
    let data = IssueMangementFollowUpByCategory;  

    let totalIssues = d3.sum(data, (d) => d.count); // Calculate total issues  
     //let maxVal = Math.ceil(d3.max(data, (d) => d.count));  
    let maxVal=0;
    IssueMangementFollowUpByCategory.forEach((item)=>{
      if(parseInt(item.count)>=maxVal)
      {
        maxVal=item.count;
      }
    })
    if (maxVal < 4 && maxVal >= 1) {  
      maxVal = 4;  
    } else if (maxVal <= 5) {  
      maxVal = 5;  
    } else {  
      maxVal += 5;  
    }  
    const margin = { top: 40, right: 0, bottom: 60, left: 45 },      
    width = 150 - margin.left - margin.right,      
    height = 280 - margin.top - margin.bottom;     
    
    let x = d3.scaleBand().range([0, width]).padding(0.5);  
    let y = d3.scaleLinear().range([height, 0]);  
    if (IssueManagementFollowUpRef.current) {  
      let tempRef = IssueManagementFollowUpRef.current.id;  
    
      d3.select(`#${tempRef}`).selectAll("*").remove();  
      let svg = d3  
        .select(`#${tempRef}`)  
        .append("svg")  
        .attr("width", 354)  
        .attr("height", height + margin.top + margin.bottom)  
        .append("g")  
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");  
    
      let div = d3  
        .select("body")  
        .append("div")  
        .attr("class", "vendorAssessmentTooltip")  
        .style("opacity", 0);  
    
      let xaxisTooltip = d3  
        .select("body")  
        .append("div")  
        .attr("class", "xaxisTooltip")  
        .style("opacity", 0);  
    
      x.domain(  
        data.map(function (d) {  
          return d.category;  
        })  
      );  
      y.domain([0, maxVal]);  
    
      svg  
        .selectAll(".bar")  
        .data(data)  
        .enter()  
        .append("rect")  
        .attr("class", "bar")  
        .style("fill", "#eb8c00")  
        .attr("x", function (d) {  
          return x(d.category);  
        })  
        .attr("width", x.bandwidth())  
        .attr("y", function (d) {  
          return y(d.count);  
        })  
        .attr("height", function (d) {  
          return height - y(d.count);  
        })  
        .on("mousemove", function (event, d) {  
          div  
            .style("opacity", 1)  
            .style("left", event.pageX + "px")  
            .style("top", event.pageY - 30 + "px")  
            .style("display", "inline-block")
            .style("font-size", "12px")      
 
            .html("<span>Issues: " + d.count + "</span>");  
        })  
        .on("mouseout", function (n) {  
          div.style("opacity", 0);  
          div.style("display", "none");  
        })  
        .on("click", function (event, d) {  
          issueManagementFollwUpResponseData(d.category, 1);  
          setIssueManagementFollowUpModal(true);  
        });  
    
      // Add count labels  
      svg  
        .selectAll(".text")  
        .data(data)  
        .enter()  
        .append("text")  
        .attr("class", "label")  
        .attr("x", function (d) {  
          return x(d.category) + x.bandwidth() / 2;  
        })  
        .attr("y", function (d) {  
          return y(d.count) - 16;  
        })  
        .attr("dy", ".75em")  
        .attr("text-anchor", "middle")  
        .text(function (d) {  
          return d.count;  
        })
        .style("font-size", 13)  
        ;  
    
      svg  
        .append("g")  
        .attr("transform", "translate(0," + height + ")")  
        .call(  
          d3  
            .axisBottom(x)  
            .tickFormat((d) => (d.length > 15 ? d.substring(0, 15) + "..." : d))  
        )  
        .selectAll("text")  
        .attr("transform", "translate(-1,1)rotate(-20)")  
        .style("text-anchor", "end")  
        .style("font-size", 10)  
        .on("mousemove", function (event, d) {  
          xaxisTooltip  
            .style("opacity", 1)  
            .style("left", event.pageX + "px")  
            .style("top", event.pageY - 30 + "px")  
            .style("display", "inline-block") 
            .style("font-size", "12px")      
 
            .html(`<span>${d}</span>`);  
        })  
        .on("mouseout", function (n) {  
          xaxisTooltip.style("opacity", 0);  
          xaxisTooltip.style("display", "none");  
        });  
       // Generate an array of tick values that are multiples of 5  
       const yTicks = d3.range(0, maxVal + 1, 5);  
  
       svg.append("g").call(d3.axisLeft(y).ticks(5))
           
           .selectAll("text")    
           .style("font-size", "10px");  

    //   svg.append("g")  
    // .call(d3.axisLeft(y))  
    // .selectAll("text")  
    // .style("font-size", "10px");  

         // X Axis Label      
     svg.append("text")      
     .attr("transform", `translate(${width / 2}, ${height + margin.bottom - 3})`)      
     .style("text-anchor", "middle")      
     .style("font-size", "10px")      
     .text("Category");      
    
  // Y Axis Label      
  svg.append("text")      
     .attr("transform", "rotate(-90)")      
     .attr("y", -48)      
     .attr("x", 0 - (height / 2))      
     .attr("dy", "1em")      
     .style("text-anchor", "middle")      
     .style("font-size", "10px")      
     .text("Open Issues"); 
    
     
    }  
  }  
  

  function VendorCategoryOfHighRisk() {
    // set the dimensions and margins of the graph

    let models = VendorHighRiskCategory.map((i) => {
      i.model_name = i.model_name;
      return i;
    });
    if (VendorCategoryOfHighRiskRef.current) {
      let tempRef = VendorCategoryOfHighRiskRef.current.id;
      d3.select(`#${tempRef}`).selectAll("*").remove();

      var container = d3.select(`#${tempRef}`),
        width = 400,
        height = 300,
        margin = { top: 50, right: 20, bottom: 135, left: 50 },
        barPadding = 0.2,
        axisTicks = { qty: 5, outerSize: 0, dateFormat: "%m-%d" };

      var svg = container
        .append("svg")
        .attr("width", width)
        .attr("height", height)
        .append("g")
        .attr("transform", `translate(${margin.left},${margin.top})`);

      var xScale0 = d3
        .scaleBand()
        .range([0, width - margin.left - margin.right])
        .padding(barPadding);
      var xScale1 = d3.scaleBand();
      var yScale = d3
        .scaleLinear()
        .range([height - margin.top - margin.bottom, 0]);

      var xAxis = d3.axisBottom(xScale0).tickSizeOuter(axisTicks.outerSize);
      var yAxis = d3
        .axisLeft(yScale)
        .ticks(axisTicks.qty)
        .tickSizeOuter(axisTicks.outerSize);

      xScale0.domain(models.map((d) => d.model_name));
      xScale1
        .domain(["field1", "field2", "field3"])
        .range([0, xScale0.bandwidth()]);
      yScale.domain([
        0,
        d3.max(models, (d) => Math.max(d.field1, d.field2, d.field3)),
      ]);

      var model_name = svg
        .selectAll(".model_name")
        .data(models)
        .enter()
        .append("g")
        .attr("class", "model_name")
        .attr("transform", (d) => `translate(${xScale0(d.model_name)},0)`);

      /* Add field1 bars */
      model_name
        .selectAll(".bar.field1")
        .data((d) => [d])
        .enter()
        .append("rect")
        .attr("class", "bar field1")
        .style("fill", "#D04A02")
        .attr("x", (d) => xScale1("field1"))
        .attr("y", (d) => yScale(d.field1))
        .attr("width", xScale1.bandwidth())
        .attr("height", (d) => {
          if (d.field1 != null) {
            return height - margin.top - margin.bottom - yScale(d.field1);
          } else {
            return 0;
          }
        });
      model_name.on("click", function (event, d) {
        vendorHighRiskModalDrillDown(d.model_name, "High");
        setVendorHighRiskModal(true);
      });
      /* Add field2 bars */
      model_name
        .selectAll(".bar.field2")
        .data((d) => [d])
        .enter()
        .append("rect")
        .attr("class", "bar field2")
        .style("fill", "#FFB600")
        .attr("x", (d) => xScale1("field2"))
        .attr("y", (d) => yScale(d.field2))
        .attr("width", xScale1.bandwidth())
        .attr("height", (d) => {
          if (d.field2 != null) {
            return height - margin.top - margin.bottom - yScale(d.field2);
          } else {
            return 0;
          }
        });

      /* Add field2 bars */
      model_name
        .selectAll(".bar.field3")
        .data((d) => [d])
        .enter()
        .append("rect")
        .attr("class", "bar field3")
        .style("fill", "#FF6600")
        .attr("x", (d) => xScale1("field3"))
        .attr("y", (d) => yScale(d.field3))
        .attr("width", xScale1.bandwidth())
        .attr("height", (d) => {
          if (d.field3 != null) {
            return height - margin.top - margin.bottom - yScale(d.field3);
          } else {
            return 0;
          }
        });

      // Add the X Axis
      svg
        .append("g")
        .attr("class", "x axis")
        .attr(
          "transform",
          `translate(0,${height - margin.top - margin.bottom})`
        )
        .call(xAxis)
        .selectAll("text")
        .attr("transform", "translate(-5,5)rotate(-22)")
        .style("text-anchor", "end")
        .style("font-size", 13);

      // Add the Y Axis
      svg
        .append("g")
        .attr("class", "y axis")
        .call(yAxis)
        .selectAll("text")
        .style("font-size", 13);

      //set legend
      svg
        .append("rect")
        .attr("x", 60)
        .attr("y", 210)
        .attr("width", 13)
        .attr("height", 13)
        .style("fill", "#D04A02");
      svg
        .append("text")
        .attr("class", "legend")
        .attr("x", 80)
        .attr("y", 220)
        .text("Yes");
      svg
        .append("rect")
        .attr("x", 120)
        .attr("y", 210)
        .attr("width", 13)
        .attr("height", 13)
        .style("fill", "#FFB600");
      svg
        .append("text")
        .attr("class", "legend")
        .attr("x", 140)
        .attr("y", 220)
        .text("No");
      svg
        .append("rect")
        .attr("x", 180)
        .attr("y", 210)
        .attr("width", 13)
        .attr("height", 13)
        .style("fill", "#FF6600");
      svg
        .append("text")
        .attr("class", "legend")
        .attr("x", 200)
        .attr("y", 220)
        .text("NA");
    }
  }

  function VendorCategoryOfMediumRisk() {
    // set the dimensions and margins of the graph

    let models = VendorMediumRiskCategory.map((i) => {
      i.model_name = i.model_name;
      return i;
    });
    if (VendorCategoryOfMediumRiskRef.current) {
      let tempRef = VendorCategoryOfMediumRiskRef.current.id;
      d3.select(`#${tempRef}`).selectAll("*").remove();

      var container = d3.select(`#${tempRef}`),
        width = 400,
        height = 300,
        margin = { top: 50, right: 20, bottom: 135, left: 50 },
        barPadding = 0.2,
        axisTicks = { qty: 5, outerSize: 0, dateFormat: "%m-%d" };

      var svg = container
        .append("svg")
        .attr("width", width)
        .attr("height", height)
        .append("g")
        .attr("transform", `translate(${margin.left},${margin.top})`);

      var xScale0 = d3
        .scaleBand()
        .range([0, width - margin.left - margin.right])
        .padding(barPadding);
      var xScale1 = d3.scaleBand();
      var yScale = d3
        .scaleLinear()
        .range([height - margin.top - margin.bottom, 0]);

      var xAxis = d3.axisBottom(xScale0).tickSizeOuter(axisTicks.outerSize);
      var yAxis = d3
        .axisLeft(yScale)
        .ticks(axisTicks.qty)
        .tickSizeOuter(axisTicks.outerSize);

      xScale0.domain(models.map((d) => d.model_name));
      xScale1
        .domain(["field1", "field2", "field3"])
        .range([0, xScale0.bandwidth()]);
      yScale.domain([
        0,
        d3.max(models, (d) => Math.max(d.field1, d.field2, d.field3)),
      ]);

      var model_name = svg
        .selectAll(".model_name")
        .data(models)
        .enter()
        .append("g")
        .attr("class", "model_name")
        .attr("transform", (d) => `translate(${xScale0(d.model_name)},0)`);

      /* Add field1 bars */
      model_name
        .selectAll(".bar.field1")
        .data((d) => [d])
        .enter()
        .append("rect")
        .attr("class", "bar field1")
        .style("fill", "#D04A02")
        .attr("x", (d) => xScale1("field1"))
        .attr("y", (d) => yScale(d.field1))
        .attr("width", xScale1.bandwidth())
        .attr("height", (d) => {
          return height - margin.top - margin.bottom - yScale(d.field1);
        });
      model_name.on("click", function (event, d) {
        vendorHighRiskModalDrillDown(d.model_name, "Medium");
        setVendorMediumRiskModal(true);
      });
      /* Add field2 bars */
      model_name
        .selectAll(".bar.field2")
        .data((d) => [d])
        .enter()
        .append("rect")
        .attr("class", "bar field2")
        .style("fill", "#FFB600")
        .attr("x", (d) => xScale1("field2"))
        .attr("y", (d) => yScale(d.field2))
        .attr("width", xScale1.bandwidth())
        .attr("height", (d) => {
          return height - margin.top - margin.bottom - yScale(d.field2);
        });

      /* Add field2 bars */
      model_name
        .selectAll(".bar.field3")
        .data((d) => [d])
        .enter()
        .append("rect")
        .attr("class", "bar field3")
        .style("fill", "#FF6600")
        .attr("x", (d) => xScale1("field3"))
        .attr("y", (d) => yScale(d.field3))
        .attr("width", xScale1.bandwidth())
        .attr("height", (d) => {
          return height - margin.top - margin.bottom - yScale(d.field3);
        });

      // Add the X Axis
      svg
        .append("g")
        .attr("class", "x axis")
        .attr(
          "transform",
          `translate(0,${height - margin.top - margin.bottom})`
        )
        .call(xAxis)
        .selectAll("text")
        .attr("transform", "translate(-5,5)rotate(-22)")
        .style("text-anchor", "end")
        .style("font-size", 13);

      // Add the Y Axis
      svg
        .append("g")
        .attr("class", "y axis")
        .call(yAxis)
        .selectAll("text")
        .style("font-size", 13);

      //set legend
      svg
        .append("rect")
        .attr("x", 60)
        .attr("y", 210)
        .attr("width", 13)
        .attr("height", 13)
        .style("fill", "#D04A02");
      svg
        .append("text")
        .attr("class", "legend")
        .attr("x", 80)
        .attr("y", 220)
        .text("Yes");
      svg
        .append("rect")
        .attr("x", 120)
        .attr("y", 210)
        .attr("width", 13)
        .attr("height", 13)
        .style("fill", "#FFB600");
      svg
        .append("text")
        .attr("class", "legend")
        .attr("x", 140)
        .attr("y", 220)
        .text("No");
      svg
        .append("rect")
        .attr("x", 180)
        .attr("y", 210)
        .attr("width", 13)
        .attr("height", 13)
        .style("fill", "#FF6600");
      svg
        .append("text")
        .attr("class", "legend")
        .attr("x", 200)
        .attr("y", 220)
        .text("NA");
    }
  }

  function VendorCategoryOfLowRisk() {
    // set the dimensions and margins of the graph

    let models = VendorLowRiskCategory.map((i) => {
      i.model_name = i.model_name;
      return i;
    });
    if (VendorCategoryOfLowRiskRef.current) {
      let tempRef = VendorCategoryOfLowRiskRef.current.id;
      d3.select(`#${tempRef}`).selectAll("*").remove();

      var container = d3.select(`#${tempRef}`),
        width = 400,
        height = 300,
        margin = { top: 50, right: 20, bottom: 135, left: 50 },
        barPadding = 0.2,
        axisTicks = { qty: 5, outerSize: 0, dateFormat: "%m-%d" };

      var svg = container
        .append("svg")
        .attr("width", width)
        .attr("height", height)
        .append("g")
        .attr("transform", `translate(${margin.left},${margin.top})`);

      var xScale0 = d3
        .scaleBand()
        .range([0, width - margin.left - margin.right])
        .padding(barPadding);
      var xScale1 = d3.scaleBand();
      var yScale = d3
        .scaleLinear()
        .range([height - margin.top - margin.bottom, 0]);

      var xAxis = d3.axisBottom(xScale0).tickSizeOuter(axisTicks.outerSize);
      var yAxis = d3
        .axisLeft(yScale)
        .ticks(axisTicks.qty)
        .tickSizeOuter(axisTicks.outerSize);

      xScale0.domain(models.map((d) => d.model_name));
      xScale1
        .domain(["field1", "field2", "field3"])
        .range([0, xScale0.bandwidth()]);
      yScale.domain([
        0,
        d3.max(models, (d) => Math.max(d.field1, d.field2, d.field3)),
      ]);

      var model_name = svg
        .selectAll(".model_name")
        .data(models)
        .enter()
        .append("g")
        .attr("class", "model_name")
        .attr("transform", (d) => `translate(${xScale0(d.model_name)},0)`);

      /* Add field1 bars */
      model_name
        .selectAll(".bar.field1")
        .data((d) => [d])
        .enter()
        .append("rect")
        .attr("class", "bar field1")
        .style("fill", "#D04A02")
        .attr("x", (d) => xScale1("field1"))
        .attr("y", (d) => yScale(d.field1))
        .attr("width", xScale1.bandwidth())
        .attr("height", (d) => {
          return height - margin.top - margin.bottom - yScale(d.field1);
        });
      model_name.on("click", function (event, d) {
        vendorHighRiskModalDrillDown(d.model_name, "Low");
        setVendorMediumRiskModal(true);
      });
      /* Add field2 bars */
      model_name
        .selectAll(".bar.field2")
        .data((d) => [d])
        .enter()
        .append("rect")
        .attr("class", "bar field2")
        .style("fill", "#FFB600")
        .attr("x", (d) => xScale1("field2"))
        .attr("y", (d) => yScale(d.field2))
        .attr("width", xScale1.bandwidth())
        .attr("height", (d) => {
          return height - margin.top - margin.bottom - yScale(d.field2);
        });

      /* Add field2 bars */
      model_name
        .selectAll(".bar.field3")
        .data((d) => [d])
        .enter()
        .append("rect")
        .attr("class", "bar field3")
        .style("fill", "#FF6600")
        .attr("x", (d) => xScale1("field3"))
        .attr("y", (d) => yScale(d.field3))
        .attr("width", xScale1.bandwidth())
        .attr("height", (d) => {
          return height - margin.top - margin.bottom - yScale(d.field3);
        });

      // Add the X Axis
      svg
        .append("g")
        .attr("class", "x axis")
        .attr(
          "transform",
          `translate(0,${height - margin.top - margin.bottom})`
        )
        .call(xAxis)
        .selectAll("text")
        .attr("transform", "translate(-5,5)rotate(-22)")
        .style("text-anchor", "end")
        .style("font-size", 13);

      // Add the Y Axis
      svg
        .append("g")
        .attr("class", "y axis")
        .call(yAxis)
        .selectAll("text")
        .style("font-size", 13);

      //set legend
      svg
        .append("rect")
        .attr("x", 60)
        .attr("y", 210)
        .attr("width", 13)
        .attr("height", 13)
        .style("fill", "#D04A02");
      svg
        .append("text")
        .attr("class", "legend")
        .attr("x", 80)
        .attr("y", 220)
        .text("Yes");
      svg
        .append("rect")
        .attr("x", 120)
        .attr("y", 210)
        .attr("width", 13)
        .attr("height", 13)
        .style("fill", "#FFB600");
      svg
        .append("text")
        .attr("class", "legend")
        .attr("x", 140)
        .attr("y", 220)
        .text("No");
      svg
        .append("rect")
        .attr("x", 180)
        .attr("y", 210)
        .attr("width", 13)
        .attr("height", 13)
        .style("fill", "#FF6600");
      svg
        .append("text")
        .attr("class", "legend")
        .attr("x", 200)
        .attr("y", 220)
        .text("NA");
    }
  }

  function VendorsClosureStatusId() {
    // get the data
    let data = IssueMangementClose;
    let maxVal = Math.ceil(d3.max(data, (d) => d.count));
    if (maxVal < 4 && maxVal >= 1) {
      maxVal = 4;
    } else if (maxVal <= 5) {
      maxVal = 5;
    } else {
      maxVal += 5;
    }
    let margin = { top: 20, right: 20, bottom: 110, left: 50 },
      width = 404 - margin.left - margin.right,
      height = 260 - margin.top - margin.bottom;

    let x = d3.scaleBand().range([0, width]).padding(0.5);
    let y = d3.scaleLinear().range([height, 0]);
    if (VendorsClosureStatusRef.current) {
      let tempRef = VendorsClosureStatusRef.current.id;

      d3.select(`#${tempRef}`).selectAll("*").remove();
      let svg = d3
        .select(`#${tempRef}`)
        .append("svg")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
        .append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

      let div = d3
        .select("body")
        .append("div")
        .attr("class", "vendorAssessmentTooltip")
        .style("opacity", 0);

      x.domain(
        data.map(function (d) {
          return d.category;
        })
      );
      y.domain([0, maxVal]);

      svg
        .selectAll(".bar")
        .data(data)
        .enter()
        .append("rect")
        .attr("class", "bar")
        .style("fill", "#FF6600")
        .attr("x", function (d) {
          return x(d.category);
        })
        .attr("width", x.bandwidth())
        .attr("y", function (d) {
          return y(d.count);
        })
        .attr("height", function (d) {
          return height - y(d.count);
        })
        .on("mousemove", function (event, d) {
          div
            .style("opacity", 1)
            .style("left", event.pageX + "px")
            .style("top", event.pageY - 30 + "px")
            .style("display", "inline-block")
            .html("<span>Issues: " + d.count + "</span>");
        })
        .on("mouseout", function (n) {
          div.style("opacity", 0);
          div.style("display", "none");
        })
        .on("click", function (event, d) {
          issueManagementFollwUpResponseData(d.category, 2);
          setIssueManagementFollowUpModal(true);
        });

      svg
        .append("g")
        .attr("transform", "translate(0," + height + ")")
        .call(d3.axisBottom(x))
        .selectAll("text")
        .attr("transform", "translate(-5,5)rotate(-20)")
        .style("text-anchor", "end")
        .style("font-size", 13);

      svg.append("g").call(d3.axisLeft(y).ticks(4));
    }
  }

  function CategoryWiseCriticality() {
    let data = vendorCriticality;
    // Clear previous render
    d3.select(d3Container.current).selectAll("*").remove();

    const margin = { top: 20, right: 20, bottom: 125, left: 60 },
      width = 404 - margin.left - margin.right,
      height = 280 - margin.top - margin.bottom;

    const svg = d3
      .select(d3Container.current)
      .append("svg")
      .attr("width", width + margin.left + margin.right)
      .attr("height", height + margin.top + margin.bottom)
      .append("g")
      .attr("transform", `translate(${margin.left},${margin.top})`);

    const subgroups = ["value1", "value2", "value3"];
    const groups = data.map((d) => d.category);
    const stack = d3.stack().keys(subgroups);
    const stackedData = stack(data);

    let maxVal = Math.ceil(
      d3.max(stackedData[stackedData.length - 1], (d) => d[1])
    );
    if (maxVal < 4 && maxVal >= 1) {
      maxVal = 4;
    } else if (maxVal <= 5) {
      maxVal = 5;
    } else {
      maxVal += 5;
    }

    const x = d3.scaleBand().domain(groups).range([0, width]).padding([0.2]);

    const y = d3.scaleLinear().domain([0, maxVal]).range([height, 0]);

    const color = d3
      .scaleOrdinal()
      .domain(subgroups)
      .range(["#e0301e", "#FFB600", "#175d2d"]);

    svg.append("g").call(d3.axisLeft(y));

    let hoverTooltip = d3
      .select("body")
      .append("div")
      .attr("class", "vendorAssessmentTooltip")
      .style("opacity", 0);

    let div = d3
      .select("body")
      .append("div")
      .attr("class", "xaxisTooltip")
      .style("opacity", 0);

    svg
      .append("g")
      .selectAll("g")
      .data(stackedData)
      .enter()
      .append("g")
      .attr("fill", (d) => color(d.key))
      .selectAll("rect")
      .data((d) => d)
      .enter()
      .append("rect")
      .attr("x", (d) => x(d.data.category))
      .attr("y", (d) => y(d[1]))
      .attr("height", (d) => y(d[0]) - y(d[1]))
      .attr("width", x.bandwidth())
      .on("mousemove", function (event, d) {
        hoverTooltip
          .style("opacity", 1)
          .style("left", event.pageX + "px")
          .style("top", event.pageY - 30 + "px")
          .style("display", "inline-block")
          .html(`<span>Count: ${d[1] - d[0]}</span>`);
      })
      .on("mouseout", function (n) {
        hoverTooltip.style("opacity", 0);
        hoverTooltip.style("display", "none");
      })
      .on("click", function (event, d) {
        CategoryWiseCriticalityData(d.data.category);
        setCategoryWiseCriticality(true);
      });

    svg
      .append("g")
      .attr("transform", "translate(0," + height + ")")
      .call(
        d3
          .axisBottom(x)
          .tickFormat((d) => (d.length > 15 ? d.substring(0, 15) + "..." : d))
      )
      .selectAll("text")
      .attr("transform", "translate(-5,5)rotate(-25)")
      .style("text-anchor", "end")
      .style("font-size", 16)
      .on("mousemove", function (event, d) {
        div
          .style("opacity", 1)
          .style("left", event.pageX + "px")
          .style("top", event.pageY - 30 + "px")
          .style("display", "inline-block")
          .html(`<span>${d}</span>`);
      })
      .on("mouseout", function (n) {
        div.style("opacity", 0);
        div.style("display", "none");
      });

    svg.append("g").call(d3.axisLeft(y).ticks(1));

    //transform="translate(100,110)"
    let newG = svg.append("g").attr("transform", "translate(0, 120)");
    newG
      .append("rect")
      .attr("x", 2)
      .attr("y", 120)
      .attr("width", 30)
      .attr("height", 8)
      .attr("stroke", "#e0301e")
      .attr("fill", "#e0301e");
    newG
      .append("text")
      .attr("x", 2 + 40)
      .attr("y", 130)
      .style("font-size", 10)
      .text("Sum of High");

    newG
      .append("rect")
      .attr("x", 100)
      .attr("y", 120)
      .attr("width", 30)
      .attr("height", 8)
      .attr("stroke", "#FFB600")
      .attr("fill", "#FFB600");
    newG
      .append("text")
      .attr("x", 140)
      .attr("y", 130)
      .style("font-size", 10)
      .text("Sum of Medium");

    newG
      .append("rect")
      .attr("x", 220)
      .attr("y", 120)
      .attr("width", 30)
      .attr("height", 8)
      .attr("stroke", "#175d2d")
      .attr("fill", "#175d2d");

    newG
      .append("text")
      .attr("x", 260)
      .attr("y", 130)
      .style("font-size", 10)
      .text("Sum of Low");
  }

  function CategoryWiseOverDueDate() {      
    let data = categoryWiseOverDueDate;      
      
    // Clear previous render      
    d3.select(AgingAnalysisCategoryRef.current).selectAll("*").remove();      
      
    const margin = { top: 40, right: 0, bottom: 60, left: 45 },      
          width = 260 - margin.left - margin.right,      
          height = 280 - margin.top - margin.bottom,      
          legendWidth = 170; // Width allocated for the legend      
      
    const svg = d3.select(AgingAnalysisCategoryRef.current)      
                  .append("svg")      
                  .attr("width", 354)      
                  .attr("height", height + margin.top + margin.bottom)      
                  .append("g")      
                  .attr("transform", `translate(${margin.left},${margin.top})`);      
      
    const subgroups = [      
      "IT Services Provider", "Manpower Services Provider", "Manufacturing Equipment Supplier",      
      "Parts and Ancillaries Supplier", "Dealer PV", "Others", "Dealer CV",      
      "Supplier CV", "Supplier PV", "DPDS service provider", "Connected Vehicle Vendors"      
    ];      
      
    // Ensure all subgroups have values in the data      
    data = data.map(d => {      
        subgroups.forEach(subgroup => {      
            if (d[subgroup] === undefined) {      
                d[subgroup] = 0;      
            }      
        });      
        return d;      
    });      
      
    const groups = data.map(d => d?.daysBracket);      
    const stack = d3.stack().keys(subgroups);      
    const stackedData = stack(data);      
      
    let maxVal = Math.ceil(d3.max(stackedData[stackedData.length - 1], d => d[1]));      
    if (maxVal < 4 && maxVal >= 1) {      
        maxVal = 4;      
    } else if (maxVal <= 5) {      
        maxVal = 5;      
    } else {      
        maxVal += 5;      
    }      
      
    const x = d3.scaleBand().domain(groups).range([0, width]).padding([0.5]);      
    const y = d3.scaleLinear().domain([0, maxVal]).range([height, 0]);      
      
    const color = d3.scaleOrdinal()      
                    .domain(subgroups)      
                    .range([      
                      "#D04A02", "#EB8C00", "#FFB600", "#7D7D7D", "#DEDEDE",      
                      "#295477", "#299D8F", "#4577C9", "#00C6F7", "#D93954", "#657DFF"      
                    ]);      
      
    svg.append("g")  
       .call(d3.axisLeft(y).ticks(5)) // Increase ticks to 5 for better visibility  
       .selectAll("text")  
       .style("font-size", "12px");      
      
    let hoverTooltip = d3.select("body").append("div")      
                         .attr("class", "vendorAssessmentTooltip")      
                         .style("opacity", 0);      
      
    let div = d3.select("body").append("div")      
                .attr("class", "xaxisTooltip")      
                .style("opacity", 0);      
      
    svg.append("g").selectAll("g")      
       .data(stackedData)      
       .enter()      
       .append("g")      
       .attr("fill", (d) => color(d.key))      
       .selectAll("rect")      
       .data((d) => d)      
       .enter()      
       .append("rect")      
       .attr("x", (d) => x(d?.data?.daysBracket))      
       .attr("y", (d) => y(d[1]))      
       .attr("height", (d) => y(d[0]) - y(d[1]))      
       .attr("width", x.bandwidth())      
       .on("mousemove", function (event, d) {      
         const key = d3.select(this.parentNode).datum().key;      
         const formattedKey = key.charAt(0).toUpperCase() + key.slice(1).toLowerCase();      
         hoverTooltip.style("opacity", 1)      
                     .style("left", event.pageX + "px")      
                     .style("top", event.pageY - 30 + "px")      
                     .style("display", "inline-block") 
                     .style("font-size", "12px")     
                     .html(`<span>Category: ${formattedKey} <br> Value: ${d[1] - d[0]}</span>`);      
       })      
       .on("mouseout", function (n) {      
         hoverTooltip.style("opacity", 0);      
         hoverTooltip.style("display", "none");      
       })      
       .on("click", function (event, d) {      
         CategoryWiseCriticalityOverDueDate(d?.data?.daysBracket, 'category');      
         setCategoryWiseCriticalityOverDueDateDetails(true);      
       });      
      
    svg.append("g")      
       .attr("transform", "translate(0," + height + ")")      
       .call(d3.axisBottom(x)
        .tickFormat(
          (d) => (d?.length > 10 ? d?.substring(0, 10) + "..." : d))       
          .tickPadding(8) // Add padding between the ticks        
      )
       .selectAll("text")      
      //  .attr("transform", "translate(-10,5)rotate(-25)")      
      //  .style("text-anchor", "end")      
       .style("font-size", 10) 
           
       .on("mousemove", function (event, d) {      
         div.style("opacity", 1)      
            .style("left", event.pageX + "px")      
            .style("top", event.pageY - 30 + "px")      
            .style("display", "inline-block") 
            .style("font-size", "12px")     
     
            .html(`<span>${d}</span>`);      
       })      
       .on("mouseout", function (n) {      
         div.style("opacity", 0);      
         div.style("display", "none");      
       });      
      
    // X Axis Label      
    svg.append("text")      
       .attr("transform", `translate(${width / 2}, ${height + margin.bottom -3})`)      
       .style("text-anchor", "middle")      
       .style("font-size", "10px")      
       .text("Ageing");      
      
    // Y Axis Label      
    svg.append("text")      
       .attr("transform", "rotate(-90)")      
       .attr("y", -48)      
       .attr("x", 0 - (height / 2))      
       .attr("dy", "1em")      
       .style("text-anchor", "middle")      
       .style("font-size", "10px")      
       .text("Assessment Count");      
      
    // Handle legend      
    const legendRectSize = 10;      
    const legendSpacing = 4;      
    const legendOffsetX = width +  5; // Start legend after the chart width with some padding      
    const legendOffsetY = 5; // Start legend from the top with some padding      
      
    const legend = svg.selectAll('.legend')      
        .data(subgroups)      
        .enter()      
        .append('g')      
        .attr('class', 'legend')      
        .attr('transform', (d, i) => {      
            const yOffset = legendOffsetY + i * 20;      
            return `translate(${legendOffsetX}, ${yOffset})`;      
        });      
      
    legend.append('rect')      
        .attr('width', legendRectSize)      
        .attr('height', legendRectSize)      
        .style('fill', color)      
        .style('stroke', color);      
      
    legend.append('text')      
        .attr('x', legendRectSize + legendSpacing)      
        .attr('y', legendRectSize - legendSpacing)      
        .style("font-size", "10px")      
        .text(d => d.length > 12 ? d.substring(0, 12) + "..." : d)      
        .on("mousemove", function (event, d) {      
            div.style("opacity", 1)      
               .style("left", event.pageX + "px")      
               .style("top", event.pageY - 30 + "px")      
               .style("display", "inline-block")   
               .style("font-size", "12px")      
   
               .html(`<span>${d}</span>`);      
        })      
        .on("mouseout", function () {      
            div.style("opacity", 0);      
            div.style("display", "none");      
        });      
}      






  function CriticalityWiseOverDueDate() {
    let data = criticalityWiseOverDueDate;
    // Clear previous render
    d3.select(AgingAnalysisCriticalityRef.current).selectAll("*").remove();

    const margin = { top: 40, right: 0, bottom: 60, left: 45 },      
    width = 260 - margin.left - margin.right,      
        height = 280 - margin.top - margin.bottom,      
        legendWidth = 170; // Width allocated for the legend      
    
      const svg = d3
      .select(AgingAnalysisCriticalityRef.current)
      .append("svg")
      .attr("width", 354)
      .attr("height", height + margin.top + margin.bottom)
      .append("g")
      .attr("transform", `translate(${margin.left},${margin.top})`);

    const subgroups = ["tier 1", "tier 2", "tier 3"];

    // Ensure all subgroups have values in the data      
    data = data.map(d => {      
      subgroups.forEach(subgroup => {      
          if (d[subgroup] === undefined) {      
              d[subgroup] = 0;      
          }      
      });      
      return d;      
  });      
    const groups = data.map((d) => d?.daysBracket);
    const stack = d3.stack().keys(subgroups);
    const stackedData = stack(data);

    let maxVal = Math.ceil(
      d3.max(stackedData[stackedData.length - 1], (d) => d[1])
    );
    if (maxVal < 4 && maxVal >= 1) {
      maxVal = 4;
    } else if (maxVal <= 5) {
      maxVal = 5;
    } else {
      maxVal += 5;
    }

    const x = d3.scaleBand().domain(groups).range([0, width]).padding([0.5]);

    const y = d3.scaleLinear().domain([0, maxVal]).range([height, 0]);

    const color = d3
      .scaleOrdinal()
      .domain(subgroups)
      .range(["#e0301e", "#FFB600", "#eb8c00"]);

      svg.append("g")  
      .call(d3.axisLeft(y).ticks(5)) // Increase ticks to 5 for better visibility  
      .selectAll("text")  
      .style("font-size", "12px");

    let hoverTooltip = d3
      .select("body")
      .append("div")
      .attr("class", "vendorAssessmentTooltip")
      .style("opacity", 0);

    let div = d3
      .select("body")
      .append("div")
      .attr("class", "xaxisTooltip")
      .style("opacity", 0);

    svg
      .append("g")
      .selectAll("g")
      .data(stackedData)
      .enter()
      .append("g")
      .attr("fill", (d) => color(d.key))
      .selectAll("rect")
      .data((d) => d)
      .enter()
      .append("rect")
      .attr("x", (d) => x(d?.data?.daysBracket))
      .attr("y", (d) => y(d[1]))
      .attr("height", (d) => y(d[0]) - y(d[1]))
      .attr("width", x.bandwidth())
      .on("mousemove", function (event, d) {
        const key = d3.select(this.parentNode).datum().key;  
        const formattedKey = key.charAt(0).toUpperCase() + key.slice(1).toLowerCase();  

        hoverTooltip
          .style("opacity", 1)
          .style("left", event.pageX + "px")
          .style("top", event.pageY - 30 + "px")
          .style("display", "inline-block")
          .style("font-size", "12px")      

          .html(`<span>${formattedKey} : ${d[1] - d[0]}</span>`);
      })
      .on("mouseout", function (n) {
        hoverTooltip.style("opacity", 0);
        hoverTooltip.style("display", "none");
      })
      .on("click", function (event, d) {
        CategoryWiseCriticalityOverDueDate(d?.data?.daysBracket,'criticality');
        setCategoryWiseCriticalityOverDueDateDetails(true);
      });

    svg
      .append("g")
      .attr("transform", "translate(0," + height + ")")
      .call(d3.axisBottom(x)
      .tickFormat(
        (d) => (d?.length > 10 ? d?.substring(0, 10) + "..." : d))       
        .tickPadding(8) // Add padding between the ticks        
    )
      .selectAll("text")
      // .attr("transform", "translate(-5,5)rotate(-25)")
      // .style("text-anchor", "end")
      .style("font-size", 10)
      .on("mousemove", function (event, d) {
        div
          .style("opacity", 1)
          .style("left", event.pageX + "px")
          .style("top", event.pageY - 30 + "px")
          .style("display", "inline-block")
          .style("font-size", "12px")      

          .html(`<span>${d}</span>`);
      })
      .on("mouseout", function (n) {
        div.style("opacity", 0);
        div.style("display", "none");
      });

    // svg.append("g").call(d3.axisLeft(y).ticks(1));

    //transform="translate(100,110)"
    let newG = svg.append("g").attr("transform", "translate(0, 120)");
     // X Axis Label      
     svg.append("text")      
     .attr("transform", `translate(${width / 2}, ${height + margin.bottom - 3})`)      
     .style("text-anchor", "middle")      
     .style("font-size", "10px")      
     .text("Ageing");      
    
  // Y Axis Label      
  svg.append("text")      
     .attr("transform", "rotate(-90)")      
     .attr("y", -48)      
     .attr("x", 0 - (height / 2))      
     .attr("dy", "1em")      
     .style("text-anchor", "middle")      
     .style("font-size", "10px")      
     .text("Assessment Count");      
    
  // Handle legend      
  const legendRectSize = 10;      
  const legendSpacing = 4;      
  const legendOffsetX = width + 5; // Start legend after the chart width with some padding      
  const legendOffsetY = 5; // Start legend from the top with some padding      
    
  const legend = svg.selectAll('.legend')      
      .data(subgroups)      
      .enter()      
      .append('g')      
      .attr('class', 'legend')      
      .attr('transform', (d, i) => {      
          const yOffset = legendOffsetY + i * 20;      
          return `translate(${legendOffsetX}, ${yOffset})`;      
      });      
    
  legend.append('rect')      
      .attr('width', legendRectSize)      
      .attr('height', legendRectSize)      
      .style('fill', color)      
      .style('stroke', color);      
    
  legend.append('text')      
      .attr('x', legendRectSize + legendSpacing)      
      .attr('y', legendRectSize - legendSpacing)      
      .style("font-size", "10px")      
      .text(d => {  
        const text = d.length > 12 ? d.substring(0, 12) + "..." : d;  
        return text.charAt(0).toUpperCase() + text.slice(1);  
    })      
      .on("mousemove", function (event, d) {      
          div.style("opacity", 1)      
             .style("left", event.pageX + "px")      
             .style("top", event.pageY - 30 + "px")      
             .style("display", "inline-block")
             .style("font-size", "12px")      
      
             .html(`<span>${d.charAt(0).toUpperCase() + d.slice(1)}</span>`);  
      })      
      .on("mouseout", function () {      
          div.style("opacity", 0);      
          div.style("display", "none");      
      });      
  }


  const widgetsData = async (getCountryCode) => {
    let selectedCountry = getCountryCode === undefined ? "All" : getCountryCode;
    let openStatus = 1;
    let closeStatus = 2;

    setSelectedCountry(selectedCountry);

    await getAssessmentSummaryCriticalityData(
      APIService.getAssessmentSummaryCriticality(),
      (res) => {
        let tempData = [];
        res.MSG?.forEach((item) => {
          if (item?.status !== null) {
            tempData.push(item);
          } 
        });
      setAssessmentSummaryCriticality(tempData);
      }
    )

    await getCriticalityPerCategoryData(
      APIService.getCriticalityPerCategory(), 
      (res) => {
        setCriticalityPerCategory(res.MSG);
      }
    )

    await getAssessmentSummaryByCategory(
      APIService.getAssessmentSummaryByCategory(),
      (res) => {
        
        setAssessmentSummaryByCategory(res.MSG);
      }
    );

    await getAssessmentSummary(APIService.getAssessmentSummary(), (res) => {
      let tempData = [
        {
          name: "Not started",
          count: res.MSG[0]?.notStarted,
        },
        {
          name: "Assessment Completed",
          count: res.MSG[0]?.assessmentCompleted,
        },
        {
          name: "Over due",
          count: res.MSG[0]?.overDueAssessment,
        },
        {
          name: "In Progress - Third Party",
          count: res.MSG[0]?.inProgressThirdParty,
        },
        {
          name: "In Progress - TPRM Team",
          count: res.MSG[0]?.inProgressTPRMTeam,
        },
        {
          name: "Sent Back to Third Party",
          count: res.MSG[0]?.sentBackToThirdParty,
        },
        {
          name: "Closed",
          count: res.MSG[0]?.closedIssues,
        },
        {
          name: "Open Issue",
          count: res.MSG[0]?.activeIssues,
        },
        {
          name: "Reminder 1",
          count: res.MSG[0]?.reminder1,
        },
        {
          name: "Reminder 2",
          count: res.MSG[0]?.reminder2,
        }
      ];

      let tempData2 = [];
      tempData.forEach((item) => {
        if (item.count !== null && parseInt(item.count) !== 0) {
          tempData2.push(item);
        }
      })

      setAssessmentSummary(tempData2);
    });

    await getCompletedPendingAssessment(
      APIService.getCompletedPendingAssessment(),
      (res) => {
        let tempData = [];
        res.MSG.forEach((item) => {
          if (item.value != 0) {
            tempData.push(item);
          }
        });
        setCompletedPendingAssessment(tempData);
      }
    );

    await getVendorResponseCountAPI(
      APIService.getVendorResponseCountAPI(),
      (res) => {
        let tempData = [];
        res.MSG.forEach((item) => {
          if (item.value != 0) {
            tempData.push(item);
          }
        });
        setVendorResponseChartData(tempData);
        setLoader(false);
      },
      (err) => {}
    );

    await getAssessmentbyRatingAPI(
      APIService.getAssessmentbyRating(),
      (res) => {
        setRiskOverview(res.MSG);
        setLoader(false);
      },
      (err) => {}
    );

    await upcomingAssessmentsChartCountAPI(
      APIService.UpcomingAssessmentsChartCount(selectedCountry),
      (res) => {
        let result = res.MSG;
        let tempData = [];
        result.forEach((item) => {
          if (item.issues != 0) {
            tempData.push(item);
          }
        });
        setUpComingChatData(tempData);
        setLoader(false);
      },
      (err) => {}
    );

    await getVendorCategoryAssessmentSent(
      APIService.getVendorCategoryAssessmentSent(),
      (res) => {
        let result = res.MSG;
        setVendorCategoryAssessmentSent(result);
        setLoader(false);
      },
      (err) => {}
    );

    await getIssueManagementCloseStatus(
      APIService.getIssueManagementClose(closeStatus),
      (res) => {
        let result = res.MSG;
        SetIssueMangementClose(result);
        setLoader(false);
      },
      (err) => {}
    );
    await getCriticalVendor(
      APIService.getCriticalVendor(),
      (res) => {
        let result = res.MSG;
        SetVendorCriticality(result);
        setLoader(false);
      },
      (err) => {}
    );
    await getCategoryDueDate(
      APIService.getCategoryDueDate(),
      (res) => {
        let result = res.MSG;
        SetCategoryWiseOverDueDate(result);
        setLoader(false);
      },
      (err) => {}
    );
    await getCriticalityDueDate(
      APIService.getCriticalityDueDate(),
      (res) => {
        let result = res.MSG;
        SetCriticalityWiseOverDueDate(result);
        setLoader(false);
      },
      (err) => {}
    );
    await getIssueManagementFollowUpData(
      APIService.getIssueManagementFollowUp(openStatus),
      (res) => {
        let result = res.MSG;
        setIssueMangementFollowUpByCategory(result);
        setLoader(false);
      },
      (err) => {}
    );

    await getVendorCategoryAssessmentCompleted(
      APIService.getVendorCategoryAssessmentCompleted(),
      (res) => {
        let result = res.MSG;
        setVendorCategoryAssessmentCompleted(result);
      },
      (err) => {}
    );

    await getVendorHighRiskCategory(
      APIService.getVendorHighRiskCategory(),
      (res) => {
        let result = res.MSG;
        setVendorHighRiskCategory(result);
      },
      (err) => {}
    );

    await getVendorMediumRiskCategory(
      APIService.getVendorMediumRiskCategory(),
      (res) => {
        let result = res.MSG;
        setVendorMediumRiskCategory(result);
      },
      (err) => {}
    );

    await getVendorLowRiskCategory(
      APIService.getVendorLowRiskCategory(),
      (res) => {
        let result = res.MSG;
        setVendorLowRiskCategory(result);
      },
      (err) => {}
    );

    await getClosureStatusTrendsCountAPI(
      APIService.getClosureStatusTrendsCount(),
      (res) => {
        let result = res.MSG;
        setClosueStatusTrendsData(result);
        setLoader(false);
      },
      (err) => {}
    );

    await getWidgetsDataAPI(
      APIService.getWidgetsData(selectedCountry),
      (res) => {
        setCardsData(res.MSG);
        setLoader(false);
        setBannerLoader(false);
      },
      (err) => {}
    );

    await getIssuesOpenClose(
      APIService.getIssuesOpenClose(),
      (res) => {
        let result = res.MSG;
        setGetIssuesCloseOpen(result);
        setLoader(false);
      },
      (err) => {}
    );

    await getCategoryByAssessment(
      APIService.getCategoryByAssessment(),
      (res) => {
        let result = res.MSG;
        setRiskOverviewCategory(result);
        setLoader(false);
      },
      (err) => {}
    );
  };

  const onDragAndDropIssueAging = async (selectedCountry) => {
    await getIssueAgingChartAPI(
      APIService.getIssueAgingChart(selectedCountry),
      (res) => {
        let result = res.MSG;
        getIssueAgingReport(result);
      },
      (err) => {}
    );
  };

  useEffect(() => {
    widgetsData("All");
    getOptionalWidgetData();
    getOptionalExistedGraphData();
  }, []);

  const drawerOpen = async () => {
    if (document.getElementById("dashboardDrawer").style.width === "250px") {
      document.getElementById("dashboardDrawer").style.width = "0px";
      document.getElementById("dashboardDrawerBtn").style.right = "0px";
      document.getElementById("chevron").className =
        "Appkit4-icon icon-left-chevron-fill pointer";
    } else {
      document.getElementById("dashboardDrawer").style.width = "250px";
      document.getElementById("dashboardDrawerBtn").style.right = "250px";
      document.getElementById("chevron").className =
        "Appkit4-icon icon-right-chevron-fill pointer";
    }
  };

  const onDrop = async (data) => {
    let split = data.index.split(",");
    let addedChatData = [...availableOptionalGraphs, { widget_name: split[0] }];
    setAvailableOptionalGraphs(addedChatData);
    removeChatsWidgets(Number(split[1]), split[0]);
    //add this varaible for dynamic country getting selectedCountry
    let data1 = {
      userid: sessionStorage.getItem("userId"),
      widgetid: split[1],
      sequence: 1,
      widgetname: split[0],
      type: "insert",
      graphtype: "Dashboard",
    };
    await dragAndDropInsertAPI(APIService.dragAndDropInsert(data1), (res) => {
      displayToastMessage(res.MSG, "success");
    });
    onDragAndDropIssueAging(selectedCountry);
  };

  const removeChatsWidgets = (index, name) => {
    let data = JSON.parse(JSON.stringify(availableGraphsInMenu));
    const index1 = data.findIndex((each) => each.widget_id == index);
    if (index1 > -1) {
      data.splice(index1, 1);
    }
    setAvailableGraphsInMenu(data);
  };

  const removeChatsDisplay = async (graphId, chatName, idValue) => {
    let addedChatData = [...availableOptionalGraphs];
    const index = addedChatData.findIndex(
      (each) => each.widget_name === graphId
    );
    if (index > -1) {
      addedChatData.splice(index, 1);
    }
    setAvailableOptionalGraphs(addedChatData);
    let avalibleData = [...availableGraphsInMenu];
    if (index) {
      avalibleData.push({
        graph_name: chatName,
        widget_name: graphId,
        widget_id: idValue,
      });
    }
    setAvailableGraphsInMenu(avalibleData);

    let data1 = {
      userid: sessionStorage.getItem("userId"),
      widgetid: idValue,
      sequence: 1,
      widgetname: graphId,
      type: "drop",
      graphtype: "Dashboard",
    };
    await dragAndDropInsertAPI(APIService.dragAndDropInsert(data1), (res) => {
      displayToastMessage("Widget removed successfully", "success");
    });
    getOptionalWidgetData();
  };

  const onFilterTextBoxChanged = (e) => {
    gridApi.setQuickFilter(e.target.value);
  };

  const rowStyle = { background: "white" };

  return (
    <div>
      {loader ? (
        <div className="row" id="preloader">
          <div className="col-12 col-lg-12 loader-margin text-center">
            <div className="a-loading a-primary a-m-10">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      ) : (
        <div id="contentPage container-fluid">
          {/* -------------Side Draw----------------- */}
          <div
            id="dashboardDrawerBtn"
            className="drawerOpen pointer "
            onClick={drawerOpen}
          >
            <span
              id="chevron"
              className="Appkit4-icon icon-left-chevron-fill pointer"
            ></span>
          </div>
          <div id="dashboardDrawer" className="drawer ">
            <p className="widgets">
              Widgets
              {/* <Button kind="primary" className="float-right"
                        size="sm" onClick={()=>saveWidgets()}>Save</Button>  */}
            </p>
            {availableGraphsInMenu.map((item, index) => {
              return (
                <Draggable
                  type={("chats", "index")}
                  data={[item.widget_name, item.widget_id]}
                  key={index}
                >
                  <div tabIndex={"0"} className="dragCard pointer">
                    {item.graph_name}
                  </div>
                </Draggable>
              );
            })}
          </div>

          {/* -------------Side Draw----------------- */}

          {/* ---------------------pods------------------- */}
          {bannerLoader ? (
                  <div className="row" id="preloader">
                  <div className="col-12 col-lg-12 loader-margin text-center loadingCss">
                    <div className="a-loading a-primary a-m-10 loadingText" role="status">
                     Loading...
                     <Loading loadingType='circular' indeterminate={true} compact={false}></Loading>
                    </div>
                  </div>
                </div>
          ) : (
            <div className="row show-grid ">
            <div className="col widgetCss">
              <div className="cd-grid mob-mt">
                <div className="widgets_div">
                  <div className="icon_div icon-dash-card">
                    <span className="Appkit4-icon icon-audience-fill appkitIcon"></span>
                  </div>
                  <div className="text_div text-center">
                    <div className="category-name-w">#Total third parties</div>
                    <div className="cust-count">
                      {cardsData?.thirdPartiesCount}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col widgetCss">
              <div className="cd-grid mob-mt">
                <div className="widgets_div">
                  <div className="icon_div icon-dash-card overlap-parent">
                    <span className="Appkit4-icon icon-account-box-fill appkitIcon"></span>
                  </div>
                  <div className="text_div text-center">
                    <div className="category-name-w">
                      #Total assessments sent
                    </div>
                    <div className="cust-count">
                      {cardsData?.assessmentSentVendor}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col widgetCss">
              <div className="cd-grid mob-mt">
                <div className="widgets_div">
                  <div className="icon_div icon-dash-card overlap-parent">
                    <span className="Appkit4-icon icon-document-text-outline appkitIcon"></span>
                  </div>
                  <div className="text_div text-center">
                    {" "}
                    <div className="category-name-w">
                      #Assessments Completed
                    </div>
                    <div className="cust-count">
                      {cardsData?.assessmentCompletedVendor}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col widgetCss">
              <div className="cd-grid mob-mt">
                <div className="widgets_div">
                  <div className="icon_div icon-dash-card overlap-parent">
                    <span className="Appkit4-icon icon-warning-fill appkitIcon"></span>
                  </div>
                  <div className="text_div text-center">
                    <div className="category-name-w">
                      #Needs Improvements Third Parties
                    </div>
                    <div className="cust-count">
                    {cardsData?.needsImprovementCount}
                    </div>

                  </div>
                </div>
              </div>
            </div>

            <div className="col widgetCss">
              <div className="cd-grid mob-mt">
                <div className="widgets_div">
                  <div className="icon_div icon-dash-card">
                    <span className="Appkit4-icon icon-help-question-fill appkitIcon"></span>
                  </div>
                  <div className="text_div text-center">
                    <div className="category-name-w">
                      #Third Parties with Issues
                    </div>
                    <div className="cust-count">{cardsData?.issuesCount}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          )}

          {/* ---------------------pods------------------- */}

          <div className="row graphs-row">
            {availableOptionalGraphs.map((value, index) => {
              return (
                <>
                  {value.widget_name.includes("UpcomingAssessment") && (
                    <div className="col-md-4 mt-2">
                      <div
                        className="cd-3-grid"
                        style={{ backgroundColor: "#fff" }}
                      >
                        <p className="cd-inside-txt">
                          Total upcoming assessments
                          <span
                            className="Appkit4-icon icon-close-fill close-icon float-end pointer"
                            onClick={() =>
                              removeChatsDisplay(
                                "UpcomingAssessment",
                                "Upcoming Assessment",
                                2
                              )
                            }
                          ></span>
                        </p>
                        {upComingChatData.length > 0 ? (
                          <div className="d-flex justify-content-center">
                            <div
                              id="upcomingAssesmentBarChart"
                              ref={upcomingAssessmentRef}
                              style={{ height: 320, marginTop: "0%" }}
                            />
                          </div>
                        ) : (
                          <div className="noDataLabel">
                            <p>No data</p>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  {value.widget_name.includes("vendorAssessmentSent") && (
                    <div className="col-md-4 mt-2">
                      <div
                        className="cd-3-grid"
                        style={{ backgroundColor: "#fff" }}
                      >
                        <p className="cd-inside-txt">
                          Total Assessment Sent
                          <span
                            className="Appkit4-icon icon-close-fill close-icon float-end pointer"
                            onClick={() =>
                              removeChatsDisplay(
                                "vendorAssessmentSent",
                                "Vendors whom assessment is sent",
                                7
                              )
                            }
                          ></span>
                        </p>
                        {vendorCategoryAssessmentSent.length > 0 ? (
                          <div className="d-flex justify-content-center">
                            <div
                              id="vendorAssessmentSent"
                              ref={vendorAssessmentSentRef}
                              style={{ height: 320, marginTop: "0%" }}
                            />
                          </div>
                        ) : (
                          <div className="noDataLabel">
                            <p>No data</p>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  {value.widget_name.includes("vendorAssessmentCompleted") && (
                    <div className="col-md-4 mt-2">
                      <div
                        className="cd-3-grid"
                        style={{ backgroundColor: "#fff" }}
                      >
                        <p className="cd-inside-txt">
                          Total assessment completed{" "}
                          <span
                            className="Appkit4-icon icon-close-fill close-icon float-end pointer"
                            onClick={() =>
                              removeChatsDisplay(
                                "vendorAssessmentCompleted",
                                "Vendors who completed assessment",
                                8
                              )
                            }
                          ></span>
                        </p>
                        {vendorCategoryAssessmentCompleted.length > 0 ? (
                          <div className="d-flex justify-content-center">
                            <div
                              id="vendorAssessmentCompleted"
                              ref={vendorAssessmentCompletedRef}
                              style={{ height: 320, marginTop: "0%" }}
                            />
                          </div>
                        ) : (
                          <div className="noDataLabel">
                            <p>No data</p>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  {value.widget_name.includes("IssuesByRating") && (
                    <div className="col-md-4 mt-2">
                      <div
                        className="cd-3-grid"
                        style={{ backgroundColor: "#fff" }}
                      >
                        <p className="cd-inside-txt">
                          Issues by rating
                          <span
                            className="Appkit4-icon icon-close-fill close-icon float-end pointer"
                            onClick={() =>
                              removeChatsDisplay(
                                "IssuesByRating",
                                "Issues by Rating",
                                4
                              )
                            }
                          ></span>
                        </p>
                        {getIssuesByRatings.length > 0 ? (
                          <div className="d-flex justify-content-center">
                            <div
                              //className="default-bar"
                              id="issueByRatingDonutChart"
                              ref={issueByRatingRef}
                              style={{ height: 320, marginLeft: "6%" }}
                            />
                          </div>
                        ) : (
                          <div className="noDataLabel">
                            <p>No data</p>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  {value.widget_name.includes("vendorAssessmentResponse") && (
                    <div className="col-md-4 mt-2">
                      <div
                        className="cd-3-grid"
                        style={{ backgroundColor: "#fff" }}
                      >
                        <p className="cd-inside-txt">
                          Vendors assessment response
                          <span
                            className="Appkit4-icon icon-close-fill close-icon float-end pointer"
                            onClick={() =>
                              removeChatsDisplay(
                                "vendorAssessmentResponse",
                                "Vendors Assessment Response",
                                9
                              )
                            }
                          ></span>
                        </p>
                        {vendorResponseChartData.length > 0 ? (
                          <div className="d-flex justify-content-center">
                            <div
                              id="vendorAssessmentResponse"
                              ref={vendorAssessmentResponseRef}
                              style={{ height: 320, marginTop: "0%" }}
                            />
                          </div>
                        ) : (
                          <div className="noDataLabel">
                            <p>No data</p>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  {value.widget_name.includes(
                    "Completed and pending assessments"
                  ) && (
                    <div className="col-md-4 mt-2">
                      <div
                        className="cd-3-grid"
                        style={{ backgroundColor: "#fff" }}
                      >
                        <p className="cd-inside-txt">
                          Overview of completed and pending assessment
                          <span
                            className="Appkit4-icon icon-close-fill close-icon float-end pointer"
                            onClick={() =>
                              removeChatsDisplay(
                                "Completed and pending assessments",
                                "Completed and pending assessments",
                                18
                              )
                            }
                          ></span>
                        </p>
                        {completedPendingAssessment.length > 0 ? (
                          <div className="d-flex justify-content-center">
                            <div
                              id="Completedandpendingassessments"
                              ref={completedPendingResponseRef}
                              style={{ height: 320, marginTop: "0%" }}
                            />
                          </div>
                        ) : (
                          <div className="noDataLabel">
                            <p>No data</p>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  {/* {value.widget_name.includes("IssueManagementFollowUp") && (
                    <div className="col-md-4 mt-2">
                      <div
                        className="cd-3-grid"
                        style={{ backgroundColor: "#fff" }}
                      >
                        <p className="cd-inside-txt">
                          Overview of active issues by category
                          <span
                            className="Appkit4-icon icon-close-fill close-icon float-right pointer"
                            onClick={() =>
                              removeChatsDisplay(
                                "IssueManagementFollowUp",
                                " Issue Management Follow Up",
                                10
                              )
                            }
                          ></span>
                        </p>
                        {IssueMangementFollowUpByCategory.length > 0 ? (
                          <div className="d-flex justify-content-center">
                            <div
                              id="IssueManagementFollowUp"
                              ref={IssueManagementFollowUpRef}
                              style={{ height: 320, marginTop: "0%" }}
                            />
                          </div>
                        ) : (
                          <div className="noDataLabel">
                            <p>No data</p>
                          </div>
                        )}
                      </div>
                    </div>
                  )} */}
                  {value.widget_name.includes("VendorsHighRisk") && (
                    <div className="col-md-4 mt-2">
                      <div
                        className="cd-3-grid"
                        style={{ backgroundColor: "#fff" }}
                      >
                        <p className="cd-inside-txt">
                          Vendor category of high risk
                          <span
                            className="Appkit4-icon icon-close-fill close-icon float-end pointer"
                            onClick={() =>
                              removeChatsDisplay(
                                "VendorsHighRisk",
                                "Vendor category of High Risk",
                                11
                              )
                            }
                          ></span>
                        </p>
                        {VendorHighRiskCategory.length > 0 ? (
                          <div className="d-flex justify-content-center">
                            <div
                              id="VendorCategoryOfHighRisk"
                              ref={VendorCategoryOfHighRiskRef}
                              style={{ height: 320, marginTop: "0%" }}
                            />
                          </div>
                        ) : (
                          <div className="noDataLabel">
                            <p>No data</p>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  {value.widget_name.includes("VendorsMediumRisk") && (
                    <div className="col-md-4 mt-2">
                      <div
                        className="cd-3-grid"
                        style={{ backgroundColor: "#fff" }}
                      >
                        <p className="cd-inside-txt">
                          Vendor category of medium risk
                          <span
                            className="Appkit4-icon icon-close-fill close-icon float-end pointer"
                            onClick={() =>
                              removeChatsDisplay(
                                "VendorsMediumRisk",
                                "Vendor category of Medium Risk",
                                12
                              )
                            }
                          ></span>
                        </p>
                        {VendorMediumRiskCategory.length > 0 ? (
                          <div className="d-flex justify-content-center">
                            <div
                              id="VendorCategoryOfMediumRisk"
                              ref={VendorCategoryOfMediumRiskRef}
                              style={{ height: 320, marginTop: "0%" }}
                            />
                          </div>
                        ) : (
                          <div className="noDataLabel">
                            <p>No data</p>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  {value.widget_name.includes("VendorsLowRisk") && (
                    <div className="col-md-4 mt-2">
                      <div
                        className="cd-3-grid"
                        style={{ backgroundColor: "#fff" }}
                      >
                        <p className="cd-inside-txt">
                          Vendor category of low risk
                          <span
                            className="Appkit4-icon icon-close-fill close-icon float-end pointer"
                            onClick={() =>
                              removeChatsDisplay(
                                "VendorsLowRisk",
                                "Vendor category of Low Risk",
                                13
                              )
                            }
                          ></span>
                        </p>
                        {VendorLowRiskCategory.length > 0 ? (
                          <div className="d-flex justify-content-center">
                            <div
                              id="VendorCategoryOfLowRisk"
                              ref={VendorCategoryOfLowRiskRef}
                              style={{ height: 320, marginTop: "0%" }}
                            />
                          </div>
                        ) : (
                          <div className="noDataLabel">
                            <p>No data</p>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  {value.widget_name.includes("VendorsClosureStatus") && (
                    <div className="col-md-4 mt-2">
                      <div
                        className="cd-3-grid"
                        style={{ backgroundColor: "#fff" }}
                      >
                        <p className="cd-inside-txt">
                          Overview of close issues by category
                          <span
                            className="Appkit4-icon icon-close-fill close-icon float-end pointer"
                            onClick={() =>
                              removeChatsDisplay(
                                "VendorsClosureStatus",
                                " Overview of close issues by category",
                                14
                              )
                            }
                          ></span>
                        </p>
                        {IssueMangementClose.length > 0 ? (
                          <div className="d-flex justify-content-center">
                            <div
                              id="VendorsClosureStatusId"
                              ref={VendorsClosureStatusRef}
                              style={{ height: 320, marginTop: "0%" }}
                            />
                          </div>
                        ) : (
                          <div className="noDataLabel">
                            <p>No data</p>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  {value.widget_name.includes("ClosureIssueTrends") && (
                    <div className="col-md-4 mt-2">
                      <div
                        className="cd-3-grid"
                        style={{ backgroundColor: "#fff" }}
                      >
                        <p className="cd-inside-txt">
                          Vendor close status trend
                          <span
                            className="Appkit4-icon icon-close-fill close-icon float-end pointer"
                            onClick={() =>
                              removeChatsDisplay(
                                "ClosureIssueTrends",
                                "Vendor close status Trend",
                                15
                              )
                            }
                          ></span>
                        </p>
                        {ClosueStatusTrendsData.length > 0 ? (
                          <div className="d-flex justify-content-center">
                            <div
                              id="ClosureIssueTrends"
                              ref={ClosureIssueTrendsRef}
                              style={{ height: 320 }}
                            />
                          </div>
                        ) : (
                          <div className="noDataLabel">
                            <p>No data</p>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  {value.widget_name.includes("CategoryWiseCriticality") && (
                    <div className="col-md-4 mt-2">
                      <div
                        className="cd-3-grid"
                        style={{ backgroundColor: "#fff" }}
                      >
                        <p className="cd-inside-txt">
                          Category wise criticality of third parties
                          <span
                            className="Appkit4-icon icon-close-fill close-icon float-end pointer"
                            onClick={() =>
                              removeChatsDisplay(
                                "CategoryWiseCriticality",
                                "Category Wise Criticality",
                                16
                              )
                            }
                          ></span>
                        </p>
                        {vendorCriticality.length > 0 ? (
                          <div className="d-flex justify-content-center">
                            <div
                              id="CategoryWiseCriticality"
                              ref={d3Container}
                              style={{ height: 320 }}
                            />
                          </div>
                        ) : (
                          <div className="noDataLabel">
                            <p>No data</p>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  {value.widget_name === "Status - Assessment Summary" && (
                    <div className="col-md-4 mt-2">
                      <div
                        className="cd-3-grid"
                        style={{ backgroundColor: "#fff" }}
                      >
                        <p className="cd-inside-txt">
                          Status - Assessment Summary
                          <span
                            className="Appkit4-icon icon-close-fill close-icon float-end pointer"
                            onClick={() =>
                              removeChatsDisplay(
                                "Status - Assessment Summary",
                                "Status - Assessment Summary",
                                19
                              )
                            }
                          ></span>
                        </p>
                        {assessmentSummary.length > 0 ? (
                          <div className="d-flex justify-content-center">
                            <div
                              id="assessmentSummaryDashboard"
                              ref={assessmentSummaryDashboard}
                              style={{ height: 320 }}
                            />
                          </div>
                        ) : (
                          <div className="noDataLabel">
                            <p>No data</p>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  {value.widget_name.includes("Risk Overview - Criticality per Category") && (
                    <div className="col-md-4 mt-2">
                      <div
                        className="cd-3-grid"
                        style={{ backgroundColor: "#fff" }}
                      >
                        <p className="cd-inside-txt">
                        Risk Overview - Criticality per Category
                          <span
                            className="Appkit4-icon icon-close-fill close-icon float-end pointer"
                            onClick={() =>
                              removeChatsDisplay(
                                "Risk Overview - Criticality per Category",
                                "Risk Overview - Criticality per Category",
                                22
                              )
                            }
                          ></span>
                        </p>
                        {criticalityPerCategory.length > 0 ? (
                          <div className="d-flex justify-content-center">
                            <div
                              id="criticalityPerCategoryRef"
                              ref={criticalityPerCategoryRef}
                              style={{ height: 320 }}
                            />
                          </div>
                        ) : (
                          <div className="noDataLabel">
                            <p>No data</p>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  {/* {value.widget_name === "Risk Overview-Assessment Outcome Category" && (
                    <div className="col-md-4 mt-2">
                      <div
                        className="cd-3-grid"
                        style={{ backgroundColor: "#fff" }}
                      >
                        <p className="cd-inside-txt flex-row">
                          <div>Risk Overview-Assessment Outcome Category</div>
                          <span
                            className="Appkit4-icon icon-close-fill close-icon float-right pointer"
                            onClick={() =>
                              removeChatsDisplay(
                                "Risk Overview-Assessment Outcome Category",
                                "Risk Overview-Assessment Outcome Category",
                                24
                              )
                            }
                          ></span>
                        </p>
                        {riskOverviewCategory.length > 0 ? (
                          <div className="d-flex justify-content-center">
                            <div
                              id="riskOverviewCategory"
                              ref={riskOverviewCategoryRef}
                              style={{ height: 320 }}
                            />
                          </div>
                        ) : (
                          <div className="noDataLabel">
                            <p>No data</p>
                          </div>
                        )}
                      </div>
                    </div>
                  )} */}
                  {/* {value.widget_name === "Risk Overview-Assessment Outcome" && (
                    <div className="col-md-4 mt-2">
                      <div
                        className="cd-3-grid"
                        style={{ backgroundColor: "#fff" }}
                      >
                        <p className="cd-inside-txt">
                          Risk Overview-Assesment outcome
                          <span
                            className="Appkit4-icon icon-close-fill close-icon float-right pointer"
                            onClick={() =>
                              removeChatsDisplay(
                                "Risk Overview-Assessment Outcome",
                                "Risk Overview-Assessment Outcome",
                                23
                              )
                            }
                          ></span>
                        </p>
                        {riskOverview.length > 0 ? (
                          <div className="d-flex justify-content-center">
                            <div
                              id="riskOverviewAssesmentOutcome"
                              ref={riskOverviewAssesmentOutcome}
                              style={{ height: 320 }}
                            />
                          </div>
                        ) : (
                          <div className="noDataLabel">
                            <p>No data</p>
                          </div>
                        )}
                      </div>
                    </div>
                  )} */}
                  {value.widget_name.includes(
                    "Status - Category Wise Assessment Summary"
                  ) && (
                    <div className="col-md-4 mt-2">
                      <div
                        className="cd-3-grid"
                        style={{ backgroundColor: "#fff" }}
                      >
                        <p className="cd-inside-txt flex-row">
                          <div>Status - Category Wise Assessment Summary</div>
                          <span
                            className="Appkit4-icon icon-close-fill close-icon float-end pointer"
                            onClick={() =>
                              removeChatsDisplay(
                                "Status - Category Wise Assessment Summary",
                                "Status - Category Wise Assessment Summary",
                                20
                              )
                            }
                          ></span>
                        </p>
                        {assessmentSummaryByCategory.length > 0 ? (
                          <div className="d-flex justify-content-center">
                            <div
                              id="assessmentSummaryByCategory"
                              ref={assessmentSummaryByCategoryRef}
                              style={{ height: 320 }}
                            />
                          </div>
                        ) : (
                          <div className="noDataLabel">
                            <p>No data</p>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  {value.widget_name === "Status - Assessment Summary per Third Party Criticality" && (
                    <div className="col-md-4 mt-2">
                      <div
                        className="cd-3-grid"
                        style={{ backgroundColor: "#fff" }}
                      >
                        <p className="cd-inside-txt flex-row">
                          <div>Status - Assessment Summary per Third Party Criticality</div>
                          <span
                            className="Appkit4-icon icon-close-fill close-icon float-end pointer"
                            onClick={() =>
                              removeChatsDisplay(
                                "Status - Assessment Summary per Third Party Criticality",
                                "Status - Assessment Summary per Third Party Criticality",
                                21
                              )
                            }
                          ></span>
                        </p>
                        {assessmentSummaryCriticality.length > 0 ? (
                          <div className="d-flex justify-content-center">
                            <div
                              id="assessmentSummaryCriticalityReF"
                              ref={assessmentSummaryCriticalityRef}
                              style={{ height: 320 }}
                            />
                          </div>
                        ) : (
                          <div className="noDataLabel">
                            <p>No data</p>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  {value.widget_name.includes("Issues Summary") && (
                    <div className="col-md-4 mt-2">
                      <div
                        className="cd-3-grid"
                        style={{ backgroundColor: "#fff" }}
                      >
                        <p className="cd-inside-txt">
                          Overview of open and closed issues{" "}
                          <span
                            className="Appkit4-icon icon-close-fill close-icon float-end pointer"
                            onClick={() =>
                              removeChatsDisplay(
                                "Issues Summary",
                                "IssuesSummary",
                                17
                              )
                            }
                          ></span>
                        </p>
                        {/* {getIssuesCloseOpenData.length > 0 ? (
                          <div className="d-flex justify-content-center">
                            <div
                              id="IssuesSummary"
                              ref={IssuesOpenCloseRef}
                              style={{ height: 320 }}
                            />
                          </div>
                        ) : (
                          <div className="noDataLabel">
                            <p>No data</p>
                          </div>
                        )} */}
                      </div>
                    </div>
                  )}
                  
                   {value.widget_name.includes("Issue Summary - Open Issues per Category") && (
                    <div className="col-md-4 mt-2">
                      <div
                        className="cd-3-grid"
                        style={{ backgroundColor: "#fff" }}
                      >
                        <p className="cd-inside-txt">
                        Issue Summary - Open Issues per Category
                          <span
                            className="Appkit4-icon icon-close-fill close-icon float-end pointer"
                            onClick={() =>
                              removeChatsDisplay(
                                "Issue Summary - Open Issues per Category",
                                " Issue Management Follow Up",
                                26
                              )
                            }
                          ></span>
                        </p>
                        {IssueMangementFollowUpByCategory.length > 0 ? (
                          <div className="d-flex justify-content-center">
                            <div
                              id="IssueManagementFollowUp"
                              ref={IssueManagementFollowUpRef}
                              style={{ height: 320, marginTop: "0%" }}
                            />
                          </div>
                        ) : (
                          <div className="noDataLabel">
                            <p>No data</p>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                   {value.widget_name.includes("Ageing Analysis - Category wise Overdue Cases") && (
                    <div className="col-md-4 mt-2">
                      <div
                        className="cd-3-grid"
                        style={{ backgroundColor: "#fff" }}
                      >
                        <p className="cd-inside-txt">
                        Ageing Analysis - Category Overdue Cases
                          <span
                            className="Appkit4-icon icon-close-fill close-icon float-end pointer"
                            onClick={() =>
                              removeChatsDisplay(
                                "Ageing Analysis - Category wise Overdue Cases",
                                "Ageing Analysis - Category wise Overdue Cases",
                                27
                              )
                            }
                          ></span>
                        </p>
                        {categoryWiseOverDueDate.length > 0 ? ( 
                          <div className="d-flex justify-content-center">
                            <div
                              id="AgingAnalysisCategory"
                              ref={AgingAnalysisCategoryRef}
                              style={{ height: 320 }}
                            />
                          </div>
                        ) : (
                          <div className="noDataLabel">
                            <p>No data</p>
                          </div>
                      )}
                      </div>
                    </div>
                  )}
                  {value.widget_name.includes("Ageing Analysis - Criticality wise Overdue Cases") && (
                    <div className="col-md-4 mt-2">
                      <div
                        className="cd-3-grid"
                        style={{ backgroundColor: "#fff" }}
                      >
                        <p className="cd-inside-txt">
                        Ageing Analysis - Criticality Overdue Cases
                          <span
                            className="Appkit4-icon icon-close-fill close-icon float-end pointer"
                            onClick={() =>
                              removeChatsDisplay(
                                "Ageing Analysis - Criticality wise Overdue Cases",
                                "Ageing Analysis - Criticality wise Overdue Cases",
                                28
                              )
                            }
                          ></span>
                        </p>
                        {criticalityWiseOverDueDate.length > 0 ? ( 
                          <div className="d-flex justify-content-center">
                            <div
                              id="AgingAnalysisCriticality"
                              ref={AgingAnalysisCriticalityRef}
                              style={{ height: 320 }}
                            />
                          </div>
                        ) : (
                          <div className="noDataLabel">
                            <p>No data</p>
                          </div>
                      )} 
                      </div>
                    </div>
                  )}
                  {value.widget_name === "Risk Overview - Assessment Outcome" && (
                    <div className="col-md-4 mt-2">
                      <div
                        className="cd-3-grid"
                        style={{ backgroundColor: "#fff" }}
                      >
                        <p className="cd-inside-txt">
                          Risk Overview - Assesment outcome
                          <span
                            className="Appkit4-icon icon-close-fill close-icon float-end pointer"
                            onClick={() =>
                              removeChatsDisplay(
                                "Risk Overview - Assessment Outcome",
                                "Risk Overview - Assessment Outcome",
                                23
                              )
                            }
                          ></span>
                        </p>
                        {riskOverview.length > 0 ? (
                          <div className="d-flex justify-content-center">
                            <div
                              id="riskOverviewAssesmentOutcome"
                              ref={riskOverviewAssesmentOutcome}
                              style={{ height: 320 }}
                            />
                          </div>
                        ) : (
                          <div className="noDataLabel">
                            <p>No data</p>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                   {value.widget_name.includes("Issue Summary - Issue closure status") && (
                    <div className="col-md-4 mt-2">
                      <div
                        className="cd-3-grid"
                        style={{ backgroundColor: "#fff" }}
                      >
                        <p className="cd-inside-txt">
                        Issue Summary - Issue closure status{" "}
                          <span
                            className="Appkit4-icon icon-close-fill close-icon float-end pointer"
                            onClick={() =>
                              removeChatsDisplay(
                                "Issue Summary - Issue closure status",
                                "Issue Summary - Issue closure status",
                                25
                              )
                            }
                          ></span>
                        </p>
                        {getIssuesCloseOpenData.length > 0 ? (
                          <div className="d-flex justify-content-center">
                            <div
                              id="IssuesSummary"
                              ref={IssuesOpenCloseRef}
                              style={{ height: 320 }}
                            />
                          </div>
                        ) : (
                          <div className="noDataLabel">
                            <p>No data</p>
                          </div>
                        )}
                      </div>
                    </div>
                  )}

{value?.widget_name === "Risk Overview - Assessment Outcome Category" && (
                    <div className="col-md-4 mt-2">
                      <div
                        className="cd-3-grid"
                        style={{ backgroundColor: "#fff" }}
                      >
                        <p className="cd-inside-txt flex-row">
                         Risk Overview - Assessment Outcome per Category
                          <span
                            className="Appkit4-icon icon-close-fill close-icon float-end pointer"
                            onClick={() =>
                              removeChatsDisplay(
                                "Risk Overview - Assessment Outcome Category",
                                "Risk Overview - Assessment Outcome Category",
                                24
                              )
                            }
                          ></span>
                        </p>
                        {riskOverviewCategory.length > 0 ? (
                          <div className="d-flex justify-content-center">
                            <div
                              id="riskOverviewCategory"
                              ref={riskOverviewCategoryRef}
                              style={{ height: 320 }}
                            />
                          </div>
                        ) : (
                          <div className="noDataLabel">
                            <p>No data</p>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </>
              );
            })}
             

            {availableOptionalGraphs && availableOptionalGraphs.length == 17 ? (
              <div></div>
            ) : (
              <div className="col-sm-4 mt-2">
                <div className="d3-alignment mb-4  box">
                  <Droppable
                    types={["chats", "index"]} // <= allowed drop types
                    onDrop={onDrop}
                  >
                    <div className="drag-box ">
                      <h6 className="mt-1 color-46">Add a new widget</h6>
                      <p className="color-7d">
                        Just drag and drop a widget from the list on the right.
                      </p>
                    </div>
                  </Droppable>
                </div>
              </div>
            )}
          </div>
          <div>
            <div className="row p-1 graphs-row">
              <div className="col-md-12">
                <div
                  class="ag-theme-alpine"
                  style={{ height: 500, width: "100%" }}
                >
                  <AgGridReact
                    rowStyle={rowStyle}
                    rowData={cardsData?.tableData}
                    columnDefs={[
                      {
                        headerName: "Third Party Name",
                        field: "VendorName",
                        flex:1,
                        minWidth: 150,
                        maxWidth: 150
                      },
                      { headerName: "Email", field: "email", flex: 1, minWidth: 200, maxWidth: 500},
                      { headerName: "Category", field: "category", flex: 1, minWidth: 200, maxWidth: 500},

                      { headerName: "Phone Number", field: "phone", flex: 1, minWidth: 200, maxWidth: 500},
                      {
                        headerName: "City",
                        field: "CorporateAddressCity",
                        flex: 1,
                        minWidth: 300,
                        maxWidth: 500
                      },
                      {
                        headerName: "Assessment Type",
                        field: "AssessReqAssesmentType",
                        flex: 1,
                        minWidth: 300,
                        maxWidth: 600
                      },
                    ]}
                    defaultColDef={defaultColDef}
                    pagination={true}
                    onGridReady={onGridReady}
                  />
                </div>
              </div>
            </div>
          </div>
          <div>
            <Modal
              className="baseline-modal-showcase"
              visible={upcomingAssessmentModal}
              onCancel={handleCancel}
              bodyStyle={{ maxHeight: "500px" }}
              footerStyle={{ paddingTop: "8px", marginTop: "-8px" }}
              modalStyle={{
                width: "75rem",
                maxHeight: "fit-content",
                height: "500px",
              }}
              title="Upcoming Assessment Data"
            >
              <div className="col-lg-12 mt-3 pl-1">
                <div className="exportButton">
                  <Button
                    className="secondaryButton removeRadius"
                    kind="secondary"
                    onClick={() => onBtnExport(gridRefUpcoming)}
                  >
                    Export
                  </Button>
                </div>

                <div class="example-wrapper">
                  <div className="searchTable">
                    <span>Search:</span>
                    <input
                      type="text"
                      id="filter-text-box"
                      placeholder="search..."
                      onInput={onFilterTextBoxChanged}
                    />
                  </div>
                </div>
                <div
                  class="ag-theme-alpine mt-2"
                  style={{ height: 250, width: "100%" }}
                >
                  <AgGridReact
                    ref={gridRefUpcoming}
                    rowData={filterUpcomingAssessment}
                    columnDefs={[
                      {
                        headerName: "Third Party Name",
                        field: "VendorName",
                        width: "200px",
                      },
                      { headerName: "Email ID", field: "email" },

                      {
                        headerName: "Assessment ID",
                        field: "VendorAssessmentPlanID",
                      },
                      {
                        headerName: "Assessment Status",
                        field: "VendorAssessmentPlanStatus",
                        width: "235px",
                      },
                      {
                        headerName: "Next Scheduled Date",
                        field: "NextPlannedDate",
                        cellRenderer: (data) => {
                          return formatDate(data.value);
                        },
                      },
                    ]}
                    defaultColDef={defaultColDef}
                    pagination={true}
                    onGridReady={onGridReady}
                  />
                </div>
              </div>

              <ModalFooter></ModalFooter>
            </Modal>
          </div>
          <div>
            <Modal
              className="baseline-modal-showcase"
              visible={issueRatingModal}
              onCancel={handleCancel}
              title="Risk Overview-Assesment outcome"
              bodyStyle={{ maxHeight: "500px" }}
              footerStyle={{ paddingTop: "8px", marginTop: "-8px" }}
              modalStyle={{
                width: "75rem",
                maxHeight: "fit-content",
                height: "550px",
              }}
            >
              <div className="col-lg-12 mt-3 pl-1">
                <div className="exportButton">
                  <Button
                    className="secondaryButton removeRadius"
                    kind="secondary"
                    onClick={() => onBtnExport(gridRefIssueRating)}
                  >
                    Export
                  </Button>
                </div>

                <div class="example-wrapper">
                  <div className="searchTable">
                    <span>Search:</span>
                    <input
                      type="text"
                      id="filter-text-box"
                      placeholder="search..."
                      onInput={onFilterTextBoxChanged}
                    />
                  </div>
                </div>
                <div
                  class="ag-theme-alpine mt-2"
                  style={{ height: 275, width: "100%" }}
                >
                  <AgGridReact
                    rowStyle={rowStyle}
                    ref={gridRefIssueRating}
                    rowData={filterIssueRating}
                    columnDefs={[
                      { headerName: "Third Party ID", field: "vendor_id", width: "120px" },
                      { headerName: "Assign Date", field: "created_date",
                        width: "120px",
                        cellRenderer: (data) => {
                          return formatDate(data.value);
                        }, },
                      {
                        headerName: "Status",
                        field: "assessment_status",
                       
                      },
                      {
                        headerName: "Third Party Name",
                        field: "vendor_name",
                      },
                      {
                        headerName: "Third Party Category",
                        field: "category",
                        width: "180px",
                      },
                      {
                        headerName: "Third Party Criticality",
                        field: "criticality",
                        width: "180px",
                      },
                      {
                        headerName: "Third Party SPOC Name",
                        field: "third_party_name",
                      },
                      {
                        headerName: "Third Party SPOC E-mail",field: "third_party_emailid",
                        width: "180px",
                       
                      },
                      {
                        headerName: "Business SPOC Name",
                        field: "businessuser",
                        cellRenderer: (data) => {
                          return data?.data?.additionalspoc?.map((val,i)=>{
                          return val.firstNameAdditional
                          })
                         
                        },
                        width: "180px",
                      },
                      {
                        headerName: "Business SPOC Email",
                        field: "businessuseremail",
                        cellRenderer: (data) => {
                          return data?.data?.additionalspoc?.map((val,i)=>{
                          return val.emailAdditional
                          })
                         
                        },
                        width: "180px",
                      },
                      {
                        headerName: "Risk Analyst Name",
                        field: "analyst_name",
                        width: "180px",
                      },
                    ]}
                    
                    defaultColDef={defaultColDef}
                    pagination={true}
                    onGridReady={onGridReady}
                  />
                </div>
              </div>

              <ModalFooter></ModalFooter>
            </Modal>
          </div>
          <div>
            <Modal
              className="baseline-modal-showcase"
              visible={vendorAssessmentSentModal}
              onCancel={handleCancel}
              title="Details of total assessment sent"
              bodyStyle={{ maxHeight: "500px" }}
              footerStyle={{ paddingTop: "8px", marginTop: "-8px" }}
              modalStyle={{
                width: "75rem",
                maxHeight: "fit-content",
                height: "500px",
              }}
            >
              <div className="col-lg-12 mt-3 pl-1">
                <div className="exportButton">
                  <Button
                    className="secondaryButton removeRadius"
                    kind="secondary"
                    onClick={() => onBtnExport(gridRefAssessmentSent)}
                  >
                    Export
                  </Button>
                </div>

                <div class="example-wrapper">
                  <div className="searchTable">
                    <span>Search:</span>
                    <input
                      type="text"
                      id="filter-text-box"
                      placeholder="search..."
                      onInput={onFilterTextBoxChanged}
                    />
                  </div>
                </div>
                <div
                  class="ag-theme-alpine mt-2"
                  style={{ height: 250, width: "100%" }}
                >
                  <AgGridReact
                    rowStyle={rowStyle}
                    ref={gridRefAssessmentSent}
                    rowData={vendorCategoryAssessmentSentDrilldown}
                    columnDefs={[
                      {
                        headerName: "Vendor Email ID",
                        field: "EmailID",
                        width: "300px",
                      },
                      { headerName: "Vendor Name", field: "VendorName" },
                      { headerName: "Assessment ID", field: "AssessmentID" },
                      {
                        headerName: "Initiated Date",
                        field: "CreatedDate",
                        cellRenderer: (data) => {
                          return formatDate(data.value);
                        },
                      },
                      {
                        headerName: "Category",
                        field: "Category",
                        width: "225px",
                      },
                    ]}
                    defaultColDef={defaultColDef}
                    pagination={true}
                    onGridReady={onGridReady}
                  />
                </div>
              </div>

              <ModalFooter></ModalFooter>
            </Modal>
          </div>
          <div>
            <Modal
              className="baseline-modal-showcase"
              visible={vendorAssessmentCompletedModal}
              onCancel={handleCancel}
              title="Details of total assessment completed"
              bodyStyle={{ maxHeight: "500px" }}
              footerStyle={{ paddingTop: "8px", marginTop: "-8px" }}
              modalStyle={{
                width: "75rem",
                maxHeight: "fit-content",
                height: "500px",
              }}
            >
              <div className="col-lg-12 mt-3 pl-1">
                <div className="exportButton">
                  <Button
                    className="secondaryButton removeRadius"
                    kind="secondary"
                    onClick={() => onBtnExport(gridRefAssessmentCompleted)}
                  >
                    Export
                  </Button>
                </div>

                <div class="example-wrapper">
                  <div className="searchTable">
                    <span>Search:</span>
                    <input
                      type="text"
                      id="filter-text-box"
                      placeholder="search..."
                      onInput={onFilterTextBoxChanged}
                    />
                  </div>
                </div>
                <div
                  class="ag-theme-alpine mt-2"
                  style={{ height: 250, width: "100%" }}
                >
                  <AgGridReact
                    rowStyle={rowStyle}
                    ref={gridRefAssessmentCompleted}
                    rowData={vendorCategoryAssessmentCompletedDrilldown}
                    columnDefs={[
                      {
                        headerName: "Vendor Email ID",
                        field: "EmailID",
                        width: "300px",
                      },
                      { headerName: "Vendor Name", field: "VendorName" },
                      { headerName: "Assessment ID", field: "AssessmentID" },
                      {
                        headerName: "Updated Date",
                        field: "UpdatedDate",
                        cellRenderer: (data) => {
                          return formatDate(data.value);
                        },
                      },
                      {
                        headerName: "Category",
                        field: "Category",
                        width: "225px",
                      },
                    ]}
                    defaultColDef={defaultColDef}
                    pagination={true}
                    onGridReady={onGridReady}
                  />
                </div>
              </div>

              <ModalFooter></ModalFooter>
            </Modal>
          </div>
          <div>
            <Modal
              className="baseline-modal-showcase"
              visible={vendorResponseModal}
              onCancel={VendorResponseCancel}
              title="Vendor Response"
              bodyStyle={{ maxHeight: "500px" }}
              footerStyle={{ paddingTop: "8px", marginTop: "-8px" }}
              modalStyle={{
                width: "75rem",
                maxHeight: "fit-content",
                height: "500px",
              }}
            >
              {loading ? (
                <div className="row" id="preloader">
                  <div className="col-12 col-lg-12 loader-margin text-center">
                    <div className="a-loading a-primary a-m-10">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="col-lg-12 mt-3 pl-1">
                  <div className="exportButton">
                    <Button
                      className="secondaryButton removeRadius"
                      kind="secondary"
                      onClick={() => onBtnExport(vendor)}
                    >
                      Export
                    </Button>
                  </div>
                  <div className="example-wrapper">
                    <div className="searchTable">
                      <span>Search:</span>
                      <input
                        type="text"
                        id="filter-text-box"
                        placeholder="search..."
                        onInput={onFilterTextBoxChanged}
                      />
                    </div>
                  </div>
                  <div
                    className="ag-theme-alpine mt-2"
                    style={{ height: 250, width: "100%" }}
                  >
                    <AgGridReact
                      rowStyle={rowStyle}
                      ref={vendor}
                      rowData={vendorResponseDrilldownData}
                      columnDefs={[
                        {
                          headerName: "Vendor ID",
                          field: "id",
                          width: "100px",
                        },
                        { headerName: "Vendor Name", field: "vendorname" },
                        {
                          headerName: "Third Party Point of Contact Name",
                          field: "id",
                          width: "235px",
                          cellRenderer: (data) => {
                            return (
                              data?.data?.firstname + " " + data?.data?.lastname
                            );
                          },
                        },
                        {
                          headerName: "Email Id",
                          field: "email",
                        },
                        {
                          headerName: "Assessment Submission ",
                          field: "submiteddate",
                          cellRenderer: (data) => {
                            return formatDate(data.value);
                          },
                        },
                        {
                          headerName: "Status",
                          field: "status",
                        },
                      ]}
                      defaultColDef={defaultColDef}
                      pagination={true}
                      onGridReady={onGridReady}
                    />
                  </div>
                </div>
              )}

              <ModalFooter></ModalFooter>
            </Modal>
          </div>
          <div>
            <Modal
              className="baseline-modal-showcase"
              visible={IssueManagementFollowUpModal}
              onCancel={IssueManagementFollowUpCancel}
              title="Issue Summary - Open Issues per Category
              "
              bodyStyle={{ maxHeight: "500px" }}
              footerStyle={{ paddingTop: "8px", marginTop: "-8px" }}
              modalStyle={{
                width: "75rem",
                maxHeight: "fit-content",
                height: "525px",
              }}
            >
              {loading ? (
                <div className="row" id="preloader">
                  <div className="col-12 col-lg-12 loader-margin text-center">
                    <div className="a-loading a-primary a-m-10">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="col-lg-12 mt-3 pl-1">
                  <div className="exportButton">
                    <Button
                      className="secondaryButton removeRadius"
                      kind="secondary"
                      onClick={() => onBtnExport(gridRefOpenIssue)}
                    >
                      Export
                    </Button>
                  </div>
                  <div className="example-wrapper">
                    <div className="searchTable">
                      <span>Search:</span>
                      <input
                        type="text"
                        id="filter-text-box"
                        placeholder="search..."
                        onInput={onFilterTextBoxChanged}
                      />
                    </div>
                  </div>
                  <div
                    className="ag-theme-alpine mt-2"
                    style={{ height: 270, width: "100%" }}
                  >
                    <AgGridReact
                      rowStyle={rowStyle}
                      ref={gridRefOpenIssue}
                      rowData={issueManagementFollwUpResponse}
                      columnDefs={[
                        { headerName: "Third Party ID", field: "id", width: "120px" },
                        { headerName: "Assign Date", field: "createddate",
                          width: "120px",
                          cellRenderer: (data) => {
                            return formatDate(data.value);
                          }, },
                        {
                          headerName: "Status",
                          field: "statusname",
                         
                        },
                        {
                          headerName: "Third Party Name",
                          field: "vendorname",
                        },
                        {
                          headerName: "Third Party Category",
                          field: "categoryname",
                          width: "180px",
                        },
                        {
                          headerName: "Third Party Criticality",
                          field: "criticality",
                          width: "180px",
                        },
                        {
                          headerName: "Issue Description",
                          field: "issuedetails",
                        },
                        {
                          headerName: "Issue Open Date",field: "createddate",
                          width: "140px",
                          cellRenderer: (data) => {
                            return formatDate(data.value);
                          },
                        },
                        {
                          headerName: "Business SPOC Name",
                          field: "businessuser",
                          cellRenderer: (data) => {
                            return data?.data?.additionalspoc?.map((val,i)=>{
                            return val.firstNameAdditional
                            })
                           
                          },
                          width: "180px",
                        },
                        {
                          headerName: "Business SPOC Email",
                          field: "businessuseremail",
                          cellRenderer: (data) => {
                            return data?.data?.additionalspoc?.map((val,i)=>{
                            return val.emailAdditional
                            })
                           
                          },
                          width: "180px",
                        },
                        {
                          headerName: "Risk Analyst Name",
                          field: "analyst",
                          width: "180px",
                        },
                      ]}
                      defaultColDef={defaultColDef}
                      pagination={true}
                      onGridReady={onGridReady}
                    />
                  </div>
                </div>
              )}

              <ModalFooter></ModalFooter>
            </Modal>
          </div>
          <div>
            <Modal
              className="baseline-modal-showcase"
              visible={VendorHighRiskModal}
              onCancel={VendorHighRiskModalCancel}
              title="Vendor High Risk
              "
              bodyStyle={{ maxHeight: "500px" }}
              footerStyle={{ paddingTop: "8px", marginTop: "-8px" }}
              modalStyle={{
                width: "75rem",
                maxHeight: "fit-content",
                height: "500px",
              }}
            >
              {loading ? (
                <div className="row" id="preloader">
                  <div className="col-12 col-lg-12 loader-margin text-center">
                    <div className="a-loading a-primary a-m-10">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="col-lg-12 mt-3 pl-1">
                  <div className="exportButton">
                    <Button
                      className="secondaryButton removeRadius"
                      kind="secondary"
                      onClick={() => onBtnExport(gridRef)}
                    >
                      Export
                    </Button>
                  </div>

                  <div class="example-wrapper">
                    <div className="searchTable">
                      <span>Search:</span>
                      <input
                        type="text"
                        id="filter-text-box"
                        placeholder="search..."
                        onInput={onFilterTextBoxChanged}
                      />
                    </div>
                  </div>
                  <div
                    className="ag-theme-alpine mt-2"
                    style={{ height: 250, width: "100%" }}
                  >
                    <AgGridReact
                      rowStyle={rowStyle}
                      ref={gridRef}
                      rowData={vendorHighRiskModalDrillDownData}
                      columnDefs={[
                        {
                          headerName: "Vendor ID",
                          field: "vendorid",
                          width: "100px",
                        },
                        { headerName: "Vendor Name", field: "vendorname" },
                        {
                          headerName: "Total No.Of Yes",
                          field: "totalcountofyes",
                          width: "150px",
                        },
                        {
                          headerName: "Total No.Of No",
                          field: "totalcountofno",
                          width: "150px",
                        },
                        {
                          headerName: "Total No.Of NA",
                          field: "totalcountofna",
                          width: "150px",
                        },
                        {
                          headerName: "Category",
                          field: "category",
                          width: "180px",
                        },
                        {
                          headerName: "Rating",
                          field: "rating",
                          width: "100px",
                        },
                        { headerName: "Score", field: "score", width: "100px" },
                      ]}
                      defaultColDef={defaultColDef}
                      pagination={true}
                      onGridReady={onGridReady}
                    />
                  </div>
                </div>
              )}

              <ModalFooter></ModalFooter>
            </Modal>
          </div>
          <div>
            <Modal
              className="baseline-modal-showcase"
              visible={VendorMediumRiskModal}
              onCancel={VendorMediumRiskModalCancel}
              title="Vendor Medium Risk Modal"
              bodyStyle={{ maxHeight: "500px" }}
              footerStyle={{ paddingTop: "8px", marginTop: "-8px" }}
              modalStyle={{
                width: "75rem",
                maxHeight: "fit-content",
                height: "500px",
              }}
            >
              {loading ? (
                <div className="row" id="preloader">
                  <div className="col-12 col-lg-12 loader-margin text-center">
                    <div className="a-loading a-primary a-m-10">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="col-lg-12 mt-3 pl-1">
                  <div className="exportButton">
                    <Button
                      className="secondaryButton removeRadius"
                      kind="secondary"
                      onClick={() => onBtnExport(mediumRisk)}
                    >
                      Export
                    </Button>
                  </div>
                  <div className="example-wrapper">
                    <div className="searchTable">
                      <span>Search:</span>
                      <input
                        type="text"
                        id="filter-text-box"
                        placeholder="search..."
                        onInput={onFilterTextBoxChanged}
                      />
                    </div>
                  </div>
                  <div
                    className="ag-theme-alpine mt-2"
                    style={{ height: 250, width: "100%" }}
                  >
                    <AgGridReact
                      rowStyle={rowStyle}
                      ref={mediumRisk}
                      rowData={vendorHighRiskModalDrillDownData}
                      columnDefs={[
                        {
                          headerName: "Vendor ID",
                          field: "vendorid",
                          width: "100px",
                        },
                        { headerName: "Vendor Name", field: "vendorname" },
                        {
                          headerName: "Total No.Of Yes",
                          field: "totalcountofyes",
                          width: "150px",
                        },
                        {
                          headerName: "Total No.Of No",
                          field: "totalcountofno",
                          width: "150px",
                        },
                        {
                          headerName: "Total No.Of NA",
                          field: "totalcountofna",
                          width: "150px",
                        },
                        {
                          headerName: "Category",
                          field: "category",
                          width: "180px",
                        },
                        {
                          headerName: "Rating",
                          field: "rating",
                          width: "100px",
                        },
                        { headerName: "Score", field: "score", width: "100px" },
                      ]}
                      defaultColDef={defaultColDef}
                      pagination={true}
                      onGridReady={onGridReady}
                    />
                  </div>
                </div>
              )}

              <ModalFooter></ModalFooter>
            </Modal>
          </div>
          <div>
            <Modal
              className="baseline-modal-showcase"
              visible={VendorLowRiskModal}
              onCancel={VendorLowRiskModalCancel}
              title="Vendor Low Risk Modal"
              bodyStyle={{ maxHeight: "500px" }}
              footerStyle={{ paddingTop: "8px", marginTop: "-8px" }}
              modalStyle={{
                width: "75rem",
                maxHeight: "fit-content",
                height: "500px",
              }}
            >
              {loading ? (
                <div className="row" id="preloader">
                  <div className="col-12 col-lg-12 loader-margin text-center">
                    <div className="a-loading a-primary a-m-10">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="col-lg-12 mt-3 pl-1">
                  <div className="exportButton">
                    <Button
                      className="secondaryButton removeRadius"
                      kind="secondary"
                      onClick={() => onBtnExport(vendorHigh)}
                    >
                      Export
                    </Button>
                  </div>
                  <div className="example-wrapper">
                    <div className="searchTable">
                      <span>Search:</span>
                      <input
                        type="text"
                        id="filter-text-box"
                        placeholder="search..."
                        onInput={onFilterTextBoxChanged}
                      />
                    </div>
                  </div>
                  <div
                    className="ag-theme-alpine mt-2"
                    style={{ height: 250, width: "100%" }}
                  >
                    <AgGridReact
                      rowStyle={rowStyle}
                      ref={vendorHigh}
                      rowData={vendorHighRiskModalDrillDownData}
                      columnDefs={[
                        {
                          headerName: "Vendor ID",
                          field: "vendorid",
                          width: "100px",
                        },
                        { headerName: "Vendor Name", field: "vendorname" },
                        {
                          headerName: "Total No.Of Yes",
                          field: "totalcountofyes",
                          width: "150px",
                        },
                        {
                          headerName: "Total No.Of No",
                          field: "totalcountofno",
                          width: "150px",
                        },
                        {
                          headerName: "Total No.Of NA",
                          field: "totalcountofna",
                          width: "150px",
                        },
                        {
                          headerName: "Category",
                          field: "category",
                          width: "180px",
                        },
                        {
                          headerName: "Rating",
                          field: "rating",
                          width: "100px",
                        },
                        { headerName: "Score", field: "score", width: "100px" },
                      ]}
                      defaultColDef={defaultColDef}
                      pagination={true}
                      onGridReady={onGridReady}
                    />
                  </div>
                </div>
              )}

              <ModalFooter></ModalFooter>
            </Modal>
          </div>
          <div>
            <Modal
              className="baseline-modal-showcase"
              visible={assessmentSummaryModal}
              onCancel={handleCancel}
              title="Status - Assessment Summary"
              bodyStyle={{ maxHeight: "500px" }}
              footerStyle={{ paddingTop: "8px", marginTop: "-8px" }}
              modalStyle={{
                width: "75rem",
                maxHeight: "fit-content",
                height: "500px",
              }}
            >
              {loading ? (
                <div className="row" id="preloader">
                  <div className="col-12 col-lg-12 loader-margin text-center">
                    <div className="a-loading a-primary a-m-10">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="col-lg-12 mt-3 pl-1">
                  <div className="exportButton">
                    <Button
                      className="secondaryButton removeRadius"
                      kind="secondary"
                      onClick={() => onBtnExport(gridRefAssessmentSummary)}
                    >
                      Export
                    </Button>
                  </div>
                  <div className="example-wrapper">
                    <div className="searchTable">
                      <span>Search:</span>
                      <input
                        type="text"
                        id="filter-text-box"
                        placeholder="search..."
                        onInput={onFilterTextBoxChanged}
                      />
                    </div>
                  </div>
                  <div
                    className="ag-theme-alpine mt-2"
                    style={{ height: 250, width: "100%" }}
                  >
                    <AgGridReact
                      rowStyle={rowStyle}
                      ref={gridRefAssessmentSummary}
                      rowData={assessmentSummaryDrilldown}
                      columnDefs={[
                        {
                          headerName: "Third Party ID",
                          field: "vendor_id",
                        },
                        {
                          headerName: "Assign Date",
                          field: "created_date",
                          cellRenderer: (data) => {
                            return formatDate(data.value);
                          },
                        },
                        {
                          headerName: "Status",
                          field: "assessment_status",
                        },
                        {
                          headerName: "Third Party Name",
                          field: "vendor_name",
                        },
                        {
                          headerName: "Third Party Category",
                          field: "category",
                        },
                        {
                          headerName: "Third Party Criticality",
                          field: "criticality",
                        },
                        {
                          headerName: "Third Party Spoc Name",
                          field: "third_party_name",
                        },
                        {
                          headerName: "Third Party SPOC E-mail",
                          field: "third_party_emailid",
                        },
                        {
                          headerName: "Business Spoc Name",
                          field: "additionalName",
                          tooltipValueGetter: (p) => p.value,
                        },
                        {
                          headerName: "Business Spoc E-mail",
                          field: "additionalEmail",
                          tooltipValueGetter: (p) => p.value,
                        }
                      ]}
                      defaultColDef={defaultColDef}
                      pagination={true}
                      onGridReady={onGridReady}
                      tooltipShowDelay={0}
                      tooltipHideDelay={20000}
                      tooltipInteraction={true}
                    />
                  </div>
                </div>
              )}

              <ModalFooter></ModalFooter>
            </Modal>
          </div>
          <div>
            <Modal
              className="baseline-modal-showcase"
              visible={assessmentCriticalityModal}
              onCancel={handleCancel}
              title="Status - Assessment Summary per Third Party Criticality"
              bodyStyle={{ maxHeight: "500px" }}
              footerStyle={{ paddingTop: "8px", marginTop: "-8px" }}
              modalStyle={{
                width: "75rem",
                maxHeight: "fit-content",
                height: "500px",
              }}
            >
              {loading ? (
                <div className="row" id="preloader">
                  <div className="col-12 col-lg-12 loader-margin text-center">
                    <div className="a-loading a-primary a-m-10">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="col-lg-12 mt-3 pl-1">
                  <div className="exportButton">
                    <Button
                      className="secondaryButton removeRadius"
                      kind="secondary"
                      onClick={() => onBtnExport(gridRefAssessmentCriticality)}
                    >
                      Export
                    </Button>
                  </div>
                  <div className="example-wrapper">
                    <div className="searchTable">
                      <span>Search:</span>
                      <input
                        type="text"
                        id="filter-text-box"
                        placeholder="search..."
                        onInput={onFilterTextBoxChanged}
                      />
                    </div>
                  </div>
                  <div
                    className="ag-theme-alpine mt-2"
                    style={{ height: 250, width: "100%" }}
                  >
                    <AgGridReact
                      rowStyle={rowStyle}
                      ref={gridRefAssessmentCriticality}
                      rowData={assessmentSummaryCriticalityDrilldown}
                      columnDefs={[
                        {
                          headerName: "Third Party ID",
                          field: "vendor_id",
                        },
                        {
                          headerName: "Assign Date",
                          field: "created_date",
                          cellRenderer: (data) => {
                            return formatDate(data.value);
                          },
                        },
                        {
                          headerName: "Status",
                          field: "assessment_status",
                        },
                        {
                          headerName: "Third Party Name",
                          field: "vendor_name",
                        },
                        {
                          headerName: "Third Party Category",
                          field: "category",
                        },
                        {
                          headerName: "Third Party Criticality",
                          field: "criticality",
                        },
                        {
                          headerName: "Third Party Spoc Name",
                          field: "third_party_name",
                        },
                        {
                          headerName: "Third Party SPOC E-mail",
                          field: "third_party_emailid",
                        },
                        {
                          headerName: "Business Spoc Name",
                          field: "additionalName",
                          tooltipValueGetter: (p) => p.value,
                        },
                        {
                          headerName: "Business Spoc E-mail",
                          field: "additionalEmail",
                          tooltipValueGetter: (p) => p.value,
                        }
                      ]}
                      defaultColDef={defaultColDef}
                      pagination={true}
                      onGridReady={onGridReady}
                      tooltipShowDelay={0}
                      tooltipHideDelay={20000}
                      tooltipInteraction={true}
                    />
                  </div>
                </div>
              )}

              <ModalFooter></ModalFooter>
            </Modal>
          </div>
          <div>
            <Modal
              className="baseline-modal-showcase"
              visible={assessmentSummaryByCategoryModal}
              onCancel={handleCancel}
              title="Status - Category Wise Assessment Summary"
              bodyStyle={{ maxHeight: "500px" }}
              footerStyle={{ paddingTop: "8px", marginTop: "-8px" }}
              modalStyle={{
                width: "75rem",
                maxHeight: "fit-content",
                height: "500px",
              }}
            >
              {loading ? (
                <div className="row" id="preloader">
                  <div className="col-12 col-lg-12 loader-margin text-center">
                    <div className="a-loading a-primary a-m-10">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="col-lg-12 mt-3 pl-1">
                  <div className="exportButton">
                    <Button
                      className="secondaryButton removeRadius"
                      kind="secondary"
                      onClick={() => onBtnExport(gridRefAssessmentSummaryByCategory)}
                    >
                      Export
                    </Button>
                  </div>
                  <div className="example-wrapper">
                    <div className="searchTable">
                      <span>Search:</span>
                      <input
                        type="text"
                        id="filter-text-box"
                        placeholder="search..."
                        onInput={onFilterTextBoxChanged}
                      />
                    </div>
                  </div>
                  <div
                    className="ag-theme-alpine mt-2"
                    style={{ height: 250, width: "100%" }}
                  >
                    <AgGridReact
                      rowStyle={rowStyle}
                      ref={gridRefAssessmentSummaryByCategory}
                      rowData={assessmentSummaryByCategoryDrilldown}
                      columnDefs={[
                        {
                          headerName: "Third Party ID",
                          field: "vendor_id",
                        },
                        {
                          headerName: "Assign Date",
                          field: "created_date",
                          cellRenderer: (data) => {
                            return formatDate(data.value);
                          },
                        },
                        {
                          headerName: "Status",
                          field: "status_name",
                        },
                        {
                          headerName: "Third Party Name",
                          field: "vendor_name",
                        },
                        {
                          headerName: "Third Party Category",
                          field: "category",
                        },
                        {
                          headerName: "Third Party Criticality",
                          field: "criticality",
                        },
                        {
                          headerName: "Third Party Spoc Name",
                          field: "third_party_name",
                        },
                        {
                          headerName: "Third Party SPOC E-mail",
                          field: "third_party_emailid",
                        },
                        {
                          headerName: "Business Spoc Name",
                          field: "additionalName",
                          tooltipValueGetter: (p) => p.value,
                        },
                        {
                          headerName: "Business Spoc E-mail",
                          field: "additionalEmail",
                          tooltipValueGetter: (p) => p.value,
                        }
                      ]}
                      defaultColDef={defaultColDef}
                      pagination={true}
                      onGridReady={onGridReady}
                      tooltipShowDelay={0}
                      tooltipHideDelay={20000}
                      tooltipInteraction={true}
                    />
                  </div>
                </div>
              )}

              <ModalFooter></ModalFooter>
            </Modal>
          </div>
          <div>
            <Modal
              className="baseline-modal-showcase"
              visible={categoryByCriticalityModal}
              onCancel={handleCancel}
              title="Risk Overview - Criticality per Category"
              bodyStyle={{ maxHeight: "500px" }}
              footerStyle={{ paddingTop: "8px", marginTop: "-8px" }}
              modalStyle={{
                width: "75rem",
                maxHeight: "fit-content",
                height: "500px",
              }}
            >
              {loading ? (
                <div className="row" id="preloader">
                  <div className="col-12 col-lg-12 loader-margin text-center">
                    <div className="a-loading a-primary a-m-10">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="col-lg-12 mt-3 pl-1">
                  <div className="exportButton">
                    <Button
                      className="secondaryButton removeRadius"
                      kind="secondary"
                      onClick={() => onBtnExport(gridRefCriticalityPerCategory)}
                    >
                      Export
                    </Button>
                  </div>
                  <div className="example-wrapper">
                    <div className="searchTable">
                      <span>Search:</span>
                      <input
                        type="text"
                        id="filter-text-box"
                        placeholder="search..."
                        onInput={onFilterTextBoxChanged}
                      />
                    </div>
                  </div>
                  <div
                    className="ag-theme-alpine mt-2"
                    style={{ height: 250, width: "100%" }}
                  >
                    <AgGridReact
                      rowStyle={rowStyle}
                      ref={gridRefCriticalityPerCategory}
                      rowData={categoryByCriticalityDrilldown}
                      columnDefs={[
                        {
                          headerName: "Third Party ID",
                          field: "vendor_id",
                        },
                        {
                          headerName: "Assign Date",
                          field: "created_date",
                          cellRenderer: (data) => {
                            return formatDate(data.value);
                          },
                        },
                        {
                          headerName: "Status",
                          field: "status_name",
                        },
                        {
                          headerName: "Third Party Name",
                          field: "vendor_name",
                        },
                        {
                          headerName: "Third Party Category",
                          field: "category",
                        },
                        {
                          headerName: "Third Party Criticality",
                          field: "criticality",
                        },
                        {
                          headerName: "Third Party Spoc Name",
                          field: "third_party_name",
                        },
                        {
                          headerName: "Third Party SPOC E-mail",
                          field: "third_party_emailid",
                        },
                        {
                          headerName: "Business Spoc Name",
                          field: "additionalName",
                          tooltipValueGetter: (p) => p.value,
                        },
                        {
                          headerName: "Business Spoc E-mail",
                          field: "additionalEmail",
                          tooltipValueGetter: (p) => p.value,
                        }
                      ]}
                      defaultColDef={defaultColDef}
                      pagination={true}
                      onGridReady={onGridReady}
                      tooltipShowDelay={0}
                      tooltipHideDelay={20000}
                      tooltipInteraction={true}
                    />
                  </div>
                </div>
              )}

              <ModalFooter></ModalFooter>
            </Modal>
          </div>
          <div>
            <Modal
              className="baseline-modal-showcase"
              visible={issueTrendModal}
              onCancel={issueTrendModalCancel}
              title="Close Issue Trend Modal"
              bodyStyle={{ maxHeight: "500px" }}
              footerStyle={{ paddingTop: "8px", marginTop: "-8px" }}
              modalStyle={{
                width: "75rem",
                maxHeight: "fit-content",
                height: "550px",
              }}
            >
              {loading ? (
                <div className="row" id="preloader">
                  <div className="col-12 col-lg-12 loader-margin text-center">
                    <div className="a-loading a-primary a-m-10">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="col-lg-12 mt-3 pl-1">
                  <div className="exportButton">
                    <Button
                      className="secondaryButton removeRadius"
                      kind="secondary"
                      onClick={() => onBtnExport(closeStatus)}
                    >
                      Export
                    </Button>
                  </div>
                  <div className="example-wrapper">
                    <div className="searchTable">
                      <span>Search:</span>
                      <input
                        type="text"
                        id="filter-text-box"
                        placeholder="search..."
                        onInput={onFilterTextBoxChanged}
                      />
                    </div>
                  </div>
                  <div
                    className="ag-theme-alpine mt-2"
                    style={{ height: 275, width: "100%" }}
                  >
                    <AgGridReact
                      rowStyle={rowStyle}
                      ref={closeStatus}
                      rowData={closeStatusTrendsDownData}
                      columnDefs={[
                        {
                          headerName: "Vendor ID",
                          field: "vendorid",
                          width: "100px",
                        },
                        { headerName: "Vendor Name", field: "vendorname" },

                        {
                          headerName: "Rating",
                          field: "rating",
                          width: "100px",
                        },
                        {
                          headerName: "Created date",
                          field: "date",
                          width: "135px",
                          cellRenderer: (data) => {
                            return formatDate(data.value);
                          },
                        },
                        {
                          headerName: "Status",
                          field: "statusname",
                          width: "100px",
                        },
                        { headerName: "Issue Details", field: "issuedetails" },
                        {
                          headerName: "Control ID",
                          field: "controlid",
                          width: "100px",
                        },
                        { headerName: "Control Name", field: "controlname" },
                      ]}
                      defaultColDef={defaultColDef}
                      pagination={true}
                      onGridReady={onGridReady}
                    />
                  </div>
                </div>
              )}

              <ModalFooter></ModalFooter>
            </Modal>
          </div>
          <div>
            <Modal
              className="baseline-modal-showcase"
              visible={categoryWiseCriticality}
              onCancel={CategoryWiseCriticalityCancel}
              title="Details of category wise criticality"
              bodyStyle={{ maxHeight: "500px" }}
              footerStyle={{ paddingTop: "8px", marginTop: "-8px" }}
              modalStyle={{
                width: "75rem",
                maxHeight: "fit-content",
                height: "550px",
              }}
            >
              {loading ? (
                <div className="row" id="preloader">
                  <div className="col-12 col-lg-12 loader-margin text-center">
                    <div className="a-loading a-primary a-m-10">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="col-lg-12 mt-3 pl-1">
                  <div className="exportButton">
                    <Button
                      className="secondaryButton removeRadius"
                      kind="secondary"
                      onClick={() => onBtnExport(closeStatus)}
                    >
                      Export
                    </Button>
                  </div>
                  <div className="example-wrapper">
                    <div className="searchTable">
                      <span>Search:</span>
                      <input
                        type="text"
                        id="filter-text-box"
                        placeholder="search..."
                        onInput={onFilterTextBoxChanged}
                      />
                    </div>
                  </div>
                  <div
                    className="ag-theme-alpine mt-2"
                    style={{ height: 275, width: "100%" }}
                  >
                    <AgGridReact
                      rowStyle={rowStyle}
                      ref={closeStatus}
                      rowData={categoryWiseCriticalityData}
                      columnDefs={[
                        {
                          headerName: "Assessment ID",
                          field: "AssessmentID",
                          width: "200px",
                        },
                        { headerName: "Vendor Name", field: "VendorName" },

                        {
                          headerName: "Category",
                          field: "Category",
                          width: "100px",
                        },
                        {
                          headerName: "Created date",
                          field: "CreatedDate",
                          width: "135px",
                          cellRenderer: (data) => {
                            return formatDate(data.value);
                          },
                        },
                        {
                          headerName: "EmailID",
                          field: "EmailID",
                          width: "200px",
                        },
                        {
                          headerName: "Rating",
                          field: "rating",
                          width: "200px",
                        },
                      ]}
                      defaultColDef={defaultColDef}
                      pagination={true}
                      onGridReady={onGridReady}
                    />
                  </div>
                </div>
              )}

              <ModalFooter></ModalFooter>
            </Modal>
          </div>
          <div>
            <Modal
              className="baseline-modal-showcase"
              visible={getIssuesCloseOpenModalData}
              onCancel={IssueCloseOpenData}
              title="Issue Summary - Issue closure status"
              bodyStyle={{ maxHeight: "500px" }}
              footerStyle={{ paddingTop: "8px", marginTop: "-8px" }}
              modalStyle={{
                width: "75rem",
                maxHeight: "fit-content",
                height: "550px",
              }}
            >
              {loading ? (
                <div className="row" id="preloader">
                  <div className="col-12 col-lg-12 loader-margin text-center">
                    <div className="a-loading a-primary a-m-10">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="col-lg-12 mt-3 pl-1">
                  <div className="exportButton">
                    <Button
                      className="secondaryButton removeRadius"
                      kind="secondary"
                      onClick={() => onBtnExport(closeStatus)}
                    >
                      Export
                    </Button>
                  </div>
                  <div className="example-wrapper">
                    <div className="searchTable">
                      <span>Search:</span>
                      <input
                        type="text"
                        id="filter-text-box"
                        placeholder="search..."
                        onInput={onFilterTextBoxChanged}
                      />
                    </div>
                  </div>
                  <div
                    className="ag-theme-alpine mt-2"
                    style={{ height: 275, width: "100%" }}
                  >
                    <AgGridReact
                      rowStyle={rowStyle}
                      ref={closeStatus}
                      rowData={getIssuesCloseOpenModalApiDataDetails}
                      columnDefs={[
                        { headerName: "Third Party ID", field: "vendorid", width: "120px" },
                        { headerName: "Assign Date", field: "createddate",
                          width: "120px",
                          cellRenderer: (data) => {
                            return formatDate(data.value);
                          }, },
                        {
                          headerName: "Status",
                          field: "statusname",
                         
                        },
                        {
                          headerName: "Third Party Name",
                          field: "vendorname",
                        },
                        {
                          headerName: "Third Party Category",
                          field: "categoryname",
                          width: "180px",
                        },
                        {
                          headerName: "Third Party Criticality",
                          field: "criticality",
                          width: "180px",
                        },
                        {
                          headerName: "Issue Id",
                          field: "issueactionid",
                        },
                        {
                          headerName: "Issue Description",
                          field: "issuedetails",
                        },
                        {
                          headerName: "Issue Open Date",field: "createddate",
                          width: "140px",
                          cellRenderer: (data) => {
                            return formatDate(data.value);
                          },
                        },
                        {
                          headerName: "Business SPOC Name",
                          field: "businessuser",
                          cellRenderer: (data) => {
                            return data?.data?.additionalspoc?.map((val,i)=>{
                            return val.firstNameAdditional
                            })
                           
                          },
                          width: "180px",
                        },
                        {
                          headerName: "Business SPOC Email",
                          field: "businessuseremail",
                          cellRenderer: (data) => {
                            return data?.data?.additionalspoc?.map((val,i)=>{
                            return val.emailAdditional
                            })
                           
                          },
                          width: "180px",
                        },
                        {
                          headerName: "Risk Analyst Name",
                          field: "analyst",
                          width: "180px",
                        },
                      ]}
                      defaultColDef={defaultColDef}
                      pagination={true}
                      onGridReady={onGridReady}
                    />
                  </div>
                </div>
              )}

              <ModalFooter></ModalFooter>
            </Modal>
          </div>
          <div>
            <Modal
              className="baseline-modal-showcase"
              visible={completedAssessmentModal}
              onCancel={handleCancel}
              title="List of completed assessments"
              bodyStyle={{ maxHeight: "500px" }}
              footerStyle={{ paddingTop: "8px", marginTop: "-8px" }}
              modalStyle={{
                width: "67rem",
                maxHeight: "fit-content",
                height: "550px",
              }}
            >
              <div className="col-lg-12 mt-3 pl-1">
                <div className="exportButton">
                  <Button
                    className="secondaryButton removeRadius"
                    kind="secondary"
                    onClick={() => onBtnExport(gridRefCompletedAssessment)}
                  >
                    Export
                  </Button>
                </div>
                <div className="example-wrapper">
                  <div className="searchTable">
                    <span>Search:</span>
                    <input
                      type="text"
                      id="filter-text-box"
                      placeholder="search..."
                      onInput={onFilterTextBoxChanged}
                    />
                  </div>
                </div>
                <div
                  className="ag-theme-alpine mt-2"
                  style={{ height: 275, width: "100%" }}
                >
                  <AgGridReact
                    rowStyle={rowStyle}
                    ref={gridRefCompletedAssessment}
                    rowData={completedAssessmentData}
                    columnDefs={[
                      {
                        headerName: "Assessment ID",
                        field: "AssessmentID",
                        width: "200px",
                      },
                      { headerName: "Email ID", field: "EmailID" },
                      {
                        headerName: "Third Party Name",
                        field: "VendorName",
                        width: "400px",
                      },
                      {
                        headerName: "Updated Date",
                        field: "UpdatedDate",
                        width: "200px",
                        cellRenderer: (data) => {
                          return formatDate(data.value);
                        },
                      },
                    ]}
                    defaultColDef={defaultColDef}
                    pagination={true}
                    onGridReady={onGridReady}
                  />
                </div>
              </div>

              <ModalFooter></ModalFooter>
            </Modal>
          </div>
          <div>
            <Modal
              className="baseline-modal-showcase"
              visible={pendingAssessmentModal}
              onCancel={handleCancel}
              title="List of pending assessments"
              bodyStyle={{ maxHeight: "500px" }}
              footerStyle={{ paddingTop: "8px", marginTop: "-8px" }}
              modalStyle={{
                width: "67rem",
                maxHeight: "fit-content",
                height: "550px",
              }}
            >
              <div className="col-lg-12 mt-3 pl-1">
                <div className="exportButton">
                  <Button
                    className="secondaryButton removeRadius"
                    kind="secondary"
                    onClick={() => onBtnExport(gridRefPendingAssessment)}
                  >
                    Export
                  </Button>
                </div>
                <div className="example-wrapper">
                  <div className="searchTable">
                    <span>Search:</span>
                    <input
                      type="text"
                      id="filter-text-box"
                      placeholder="search..."
                      onInput={onFilterTextBoxChanged}
                    />
                  </div>
                </div>
                <div
                  className="ag-theme-alpine mt-2"
                  style={{ height: 275, width: "100%" }}
                >
                  <AgGridReact
                    rowStyle={rowStyle}
                    ref={gridRefPendingAssessment}
                    rowData={pendingAssessmentData}
                    columnDefs={[
                      {
                        headerName: "Assessment ID",
                        field: "AssessmentID",
                        width: "200px",
                      },
                      { headerName: "Email ID", field: "EmailID" },
                      {
                        headerName: "Third Party Name",
                        field: "VendorName",
                        width: "400px",
                      },
                      {
                        headerName: "Created Date",
                        field: "CreatedDate",
                        width: "200px",
                        cellRenderer: (data) => {
                          return formatDate(data.value);
                        },
                      },
                    ]}
                    defaultColDef={defaultColDef}
                    pagination={true}
                    onGridReady={onGridReady}
                  />
                </div>
              </div>

              <ModalFooter></ModalFooter>
            </Modal>
          </div>
          <div>
            <Modal
              className="baseline-modal-showcase"
              visible={categoryWiseOverDueDateDetails}
              onCancel={CategoryWiseCriticalityOverDueDateDetailsCancel}
              title="Ageing Analysis - Category Overdue Cases"
              bodyStyle={{ maxHeight: "500px" }}
              footerStyle={{ paddingTop: "8px", marginTop: "-8px" }}
              modalStyle={{
                width: "75rem",
                maxHeight: "fit-content",
                height: "550px",
              }}
            >
              {loading ? (
                <div className="row" id="preloader">
                  <div className="col-12 col-lg-12 loader-margin text-center">
                    <div className="a-loading a-primary a-m-10">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="col-lg-12 mt-3 pl-1">
                  <div className="exportButton">
                    <Button
                      className="secondaryButton removeRadius"
                      kind="secondary"
                      onClick={() => onBtnExport(closeStatus)}
                    >
                      Export
                    </Button>
                  </div>
                  <div className="example-wrapper">
                    <div className="searchTable">
                      <span>Search:</span>
                      <input
                        type="text"
                        id="filter-text-box"
                        placeholder="search..."
                        onInput={onFilterTextBoxChanged}
                      />
                    </div>
                  </div>
                  <div
                    className="ag-theme-alpine mt-2"
                    style={{ height: 275, width: "100%" }}
                  >
                    <AgGridReact
                      rowStyle={rowStyle}
                      ref={closeStatus}
                      rowData={categoryWiseOverDueDateResponse}
                      columnDefs={[
                        { headerName: "Third Party ID", field: "vendorid", width: "120px" },
                        
                       
                        {
                          headerName: "Third Party Name",
                          field: "vendorname",width: "160px",
                        },
                        {
                          headerName: "Third Party Category",
                          field: "categoryname",
                          width: "250px",
                        },
                        {
                          headerName: "Third Party Criticality",
                          field: "criticality",
                          width: "180px",
                        },
                        
                      
                        {
                          headerName: "Business SPOC Name",
                          field: "businessuser",
                          cellRenderer: (data) => {
                            return data?.data?.additionalspoc?.map((val,i)=>{
                            return val.firstNameAdditional
                            })
                           
                          },
                          width: "180px",
                        },
                        {
                          headerName: "Business SPOC Email",
                          field: "businessuseremail",
                          cellRenderer: (data) => {
                            return data?.data?.additionalspoc?.map((val,i)=>{
                            return val.emailAdditional
                            })
                           
                          },
                          width: "180px",
                        },
                        {
                          headerName: "Risk Analyst Name",
                          field: "analyst",
                          width: "180px",
                        },
                      ]}
                      defaultColDef={defaultColDef}
                      pagination={true}
                      onGridReady={onGridReady}
                    />
                  </div>
                </div>
              )}

              <ModalFooter></ModalFooter>
            </Modal>
          </div>
        </div>
      )}
    </div>
  );
}

export default Dashboard;
